(self.webpackChunk_N_E = self.webpackChunk_N_E || []).push([
  [931], {
    7726: function(e, t, n) {
      Promise.resolve().then(n.bind(n, 2630))
    },
    2630: function(e, t, n) {
      "use strict";
      let i, s;
      n.r(t), n.d(t, {
        default: function() {
          return u8
        }
      });
      var a = n(7437),
        o = n(2265),
        l = n.t(o, 2),
        c = n(4887),
        u = "u" > typeof globalThis ? globalThis : window;

      function d(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e
      }
      var h = {
          exports: {}
        },
        p = {};
      h.exports = function() {
        if (eo) return p;
        eo = 1;
        var e = Symbol.for("react.element"),
          t = Symbol.for("react.fragment"),
          n = Object.prototype.hasOwnProperty,
          i = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          s = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };

        function a(t, a, o) {
          var l, c = {},
            u = null,
            d = null;
          for (l in void 0 !== o && (u = "" + o), void 0 !== a.key && (u = "" + a.key), void 0 !== a.ref && (d = a.ref), a) n.call(a, l) && !s.hasOwnProperty(l) && (c[l] = a[l]);
          if (t && t.defaultProps)
            for (l in a = t.defaultProps) void 0 === c[l] && (c[l] = a[l]);
          return {
            $$typeof: e,
            type: t,
            key: u,
            ref: d,
            props: c,
            _owner: i.current
          }
        }
        return p.Fragment = t, p.jsx = a, p.jsxs = a, p
      }();
      var m = h.exports,
        f = function(e) {
          var t = typeof e;
          return null != e && ("object" == t || "function" == t)
        },
        g = "object" == typeof u && u && u.Object === Object && u,
        v = "object" == typeof self && self && self.Object === Object && self,
        y = g || v || Function("return this")(),
        x = /\s/,
        b = function(e) {
          for (var t = e.length; t-- && x.test(e.charAt(t)););
          return t
        },
        C = /^\s+/,
        w = y.Symbol,
        j = Object.prototype,
        _ = j.hasOwnProperty,
        k = j.toString,
        S = w ? w.toStringTag : void 0,
        E = Object.prototype.toString,
        P = function(e) {
          var t = _.call(e, S),
            n = e[S];
          try {
            e[S] = void 0;
            var i = !0
          } catch {}
          var s = k.call(e);
          return i && (t ? e[S] = n : delete e[S]), s
        },
        M = w ? w.toStringTag : void 0,
        T = function(e) {
          var t;
          return "symbol" == typeof e || null != e && "object" == typeof e && "[object Symbol]" == (null == (t = e) ? void 0 === t ? "[object Undefined]" : "[object Null]" : M && M in Object(t) ? P(t) : E.call(t))
        },
        L = 0 / 0,
        A = /^[-+]0x[0-9a-f]+$/i,
        V = /^0b[01]+$/i,
        R = /^0o[0-7]+$/i,
        N = parseInt,
        D = function() {
          return y.Date.now()
        },
        O = function(e) {
          if ("number" == typeof e) return e;
          if (T(e)) return L;
          if (f(e)) {
            var t, n = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = f(n) ? n + "" : n
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = (t = e) && t.slice(0, b(t) + 1).replace(C, "");
          var i = V.test(e);
          return i || R.test(e) ? N(e.slice(2), i ? 2 : 8) : A.test(e) ? L : +e
        },
        H = Math.max,
        I = Math.min;
      let B = d(function(e, t, n) {
          var i, s, a, o, l, c, u = 0,
            d = !1,
            h = !1,
            p = !0;
          if ("function" != typeof e) throw TypeError("Expected a function");

          function m(t) {
            var n = i,
              a = s;
            return i = s = void 0, u = t, o = e.apply(a, n)
          }

          function g(e) {
            var n = e - c,
              i = e - u;
            return void 0 === c || n >= t || n < 0 || h && i >= a
          }

          function v() {
            var e, n, i, s = D();
            if (g(s)) return y(s);
            l = setTimeout(v, (e = s - c, n = s - u, i = t - e, h ? I(i, a - n) : i))
          }

          function y(e) {
            return l = void 0, p && i ? m(e) : (i = s = void 0, o)
          }

          function x() {
            var e, n = D(),
              a = g(n);
            if (i = arguments, s = this, c = n, a) {
              if (void 0 === l) return u = e = c, l = setTimeout(v, t), d ? m(e) : o;
              if (h) return clearTimeout(l), l = setTimeout(v, t), m(c)
            }
            return void 0 === l && (l = setTimeout(v, t)), o
          }
          return t = O(t) || 0, f(n) && (d = !!n.leading, a = (h = "maxWait" in n) ? H(O(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p), x.cancel = function() {
            void 0 !== l && clearTimeout(l), u = 0, i = c = s = l = void 0
          }, x.flush = function() {
            return void 0 === l ? o : y(D())
          }, x
        }),
        F = function() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return (null == t ? void 0 : t.filter(e => "string" == typeof e && !!e.length && e.trim())).join(" ").trim()
        };
      var W = {
          transparent: "_1qyxb2gd _1qyxb2gc",
          invertedTransparent: "_1qyxb2ge _1qyxb2gc",
          blackGradient: "_1qyxb2gf _1qyxb2gc",
          solidWhite: "_1qyxb2gg _1qyxb2gc"
        },
        z = "_1qyxb2gb",
        $ = {
          sticky: "_1qyxb2g7 _1qyxb2g6",
          normal: "_1qyxb2g8 _1qyxb2g6",
          semiSticky: "_1qyxb2g9 _1qyxb2g6"
        },
        Z = "_1qyxb2g1",
        U = "_1qyxb2ga";
      let q = e => {
          let {
            label: t,
            children: n,
            count: i,
            ...s
          } = e;
          return m.jsxs("button", {
            className: "w5nxqn0",
            ...s,
            children: [i && m.jsx("span", {
              className: "w5nxqn2",
              children: i
            }), n, m.jsx("span", {
              className: "w5nxqn1",
              children: t
            })]
          })
        },
        X = e => m.jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          focusable: "false",
          ...e,
          children: m.jsx("path", {
            d: "M6.04004 9.19995H41.96V12.8H6.04004V9.19995ZM6.04004 22.2H41.96V25.7999H6.04004V22.2ZM6.04004 35.2H41.96V38.7999H6.04004V35.2Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          })
        });

      function Y(e, t) {
        let {
          checkForDefaultPrevented: n = !0
        } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return function(i) {
          if (null == e || e(i), !1 === n || !i.defaultPrevented) return null == t ? void 0 : t(i)
        }
      }

      function K() {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return e => t.forEach(t => {
          "function" == typeof t ? t(e) : null != t && (t.current = e)
        })
      }

      function G() {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return o.useCallback(K(...t), t)
      }
      var Q = null != globalThis && globalThis.document ? o.useLayoutEffect : () => {},
        J = l["useId".toString()] || (() => {}),
        ee = 0;

      function et(e) {
        let [t, n] = o.useState(J());
        return Q(() => {
          e || n(e => e ?? String(ee++))
        }, [e]), e || (t ? `radix-${t}` : "")
      }

      function en(e) {
        let t = o.useRef(e);
        return o.useEffect(() => {
          t.current = e
        }), o.useMemo(() => function() {
          for (var e, n = arguments.length, i = Array(n), s = 0; s < n; s++) i[s] = arguments[s];
          return null == (e = t.current) ? void 0 : e.call(t, ...i)
        }, [])
      }
      var er = o.forwardRef((e, t) => {
        let {
          children: n,
          ...i
        } = e, s = o.Children.toArray(n), a = s.find(ea);
        if (a) {
          let e = a.props.children,
            n = s.map(t => t === a ? o.Children.count(e) > 1 ? o.Children.only(null) : o.isValidElement(e) ? e.props.children : null : t);
          return m.jsx(ei, {
            ...i,
            ref: t,
            children: o.isValidElement(e) ? o.cloneElement(e, void 0, n) : null
          })
        }
        return m.jsx(ei, {
          ...i,
          ref: t,
          children: n
        })
      });
      er.displayName = "Slot";
      var ei = o.forwardRef((e, t) => {
        let {
          children: n,
          ...i
        } = e;
        if (o.isValidElement(n)) {
          var s, a;
          let e, l;
          let c = (e = null == (s = Object.getOwnPropertyDescriptor(n.props, "ref")) ? void 0 : s.get) && "isReactWarning" in e && e.isReactWarning ? n.ref : (e = null == (a = Object.getOwnPropertyDescriptor(n, "ref")) ? void 0 : a.get) && "isReactWarning" in e && e.isReactWarning ? n.props.ref : n.props.ref || n.ref;
          return o.cloneElement(n, {
            ... function(e, t) {
              let n = {
                ...t
              };
              for (let i in t) {
                let s = e[i],
                  a = t[i];
                /^on[A-Z]/.test(i) ? s && a ? n[i] = function() {
                  for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                  a(...t), s(...t)
                } : s && (n[i] = s) : "style" === i ? n[i] = {
                  ...s,
                  ...a
                } : "className" === i && (n[i] = [s, a].filter(Boolean).join(" "))
              }
              return {
                ...e,
                ...n
              }
            }(i, n.props),
            ref: t ? K(t, c) : c
          })
        }
        return o.Children.count(n) > 1 ? o.Children.only(null) : null
      });
      ei.displayName = "SlotClone";
      var es = e => {
        let {
          children: t
        } = e;
        return m.jsx(m.Fragment, {
          children: t
        })
      };

      function ea(e) {
        return o.isValidElement(e) && e.type === es
      }
      var eo, el, ec = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((e, t) => {
          let n = o.forwardRef((e, n) => {
            let {
              asChild: i,
              ...s
            } = e, a = i ? er : t;
            return window[Symbol.for("radix-ui")] = !0, m.jsx(a, {
              ...s,
              ref: n
            })
          });
          return n.displayName = `Primitive.${t}`, {
            ...e,
            [t]: n
          }
        }, {}),
        eu = "dismissableLayer.update",
        ed = o.createContext({
          layers: new Set,
          layersWithOutsidePointerEventsDisabled: new Set,
          branches: new Set
        }),
        eh = o.forwardRef((e, t) => {
          let {
            disableOutsidePointerEvents: n = !1,
            onEscapeKeyDown: i,
            onPointerDownOutside: s,
            onFocusOutside: a,
            onInteractOutside: l,
            onDismiss: c,
            ...u
          } = e, d = o.useContext(ed), [h, p] = o.useState(null), f = (null == h ? void 0 : h.ownerDocument) ?? (null == globalThis ? void 0 : globalThis.document), [, g] = o.useState({}), v = G(t, e => p(e)), y = Array.from(d.layers), [x] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), b = y.indexOf(x), C = h ? y.indexOf(h) : -1, w = d.layersWithOutsidePointerEventsDisabled.size > 0, j = C >= b, _ = function(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null == globalThis ? void 0 : globalThis.document,
              n = en(e),
              i = o.useRef(!1),
              s = o.useRef(() => {});
            return o.useEffect(() => {
              let e = e => {
                  if (e.target && !i.current) {
                    let i = function() {
                        em("dismissableLayer.pointerDownOutside", n, a, {
                          discrete: !0
                        })
                      },
                      a = {
                        originalEvent: e
                      };
                    "touch" === e.pointerType ? (t.removeEventListener("click", s.current), s.current = i, t.addEventListener("click", s.current, {
                      once: !0
                    })) : i()
                  } else t.removeEventListener("click", s.current);
                  i.current = !1
                },
                a = window.setTimeout(() => {
                  t.addEventListener("pointerdown", e)
                }, 0);
              return () => {
                window.clearTimeout(a), t.removeEventListener("pointerdown", e), t.removeEventListener("click", s.current)
              }
            }, [t, n]), {
              onPointerDownCapture: () => i.current = !0
            }
          }(e => {
            let t = e.target,
              n = [...d.branches].some(e => e.contains(t));
            !j || n || (null == s || s(e), null == l || l(e), e.defaultPrevented || null == c || c())
          }, f), k = function(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null == globalThis ? void 0 : globalThis.document,
              n = en(e),
              i = o.useRef(!1);
            return o.useEffect(() => {
              let e = e => {
                e.target && !i.current && em("dismissableLayer.focusOutside", n, {
                  originalEvent: e
                }, {
                  discrete: !1
                })
              };
              return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e)
            }, [t, n]), {
              onFocusCapture: () => i.current = !0,
              onBlurCapture: () => i.current = !1
            }
          }(e => {
            let t = e.target;
            [...d.branches].some(e => e.contains(t)) || (null == a || a(e), null == l || l(e), e.defaultPrevented || null == c || c())
          }, f);
          return function(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null == globalThis ? void 0 : globalThis.document,
              n = en(e);
            o.useEffect(() => {
              let e = e => {
                "Escape" === e.key && n(e)
              };
              return t.addEventListener("keydown", e, {
                capture: !0
              }), () => t.removeEventListener("keydown", e, {
                capture: !0
              })
            }, [n, t])
          }(e => {
            C === d.layers.size - 1 && (null == i || i(e), !e.defaultPrevented && c && (e.preventDefault(), c()))
          }, f), o.useEffect(() => {
            if (h) return n && (0 === d.layersWithOutsidePointerEventsDisabled.size && (el = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(h)), d.layers.add(h), ep(), () => {
              n && 1 === d.layersWithOutsidePointerEventsDisabled.size && (f.body.style.pointerEvents = el)
            }
          }, [h, f, n, d]), o.useEffect(() => () => {
            h && (d.layers.delete(h), d.layersWithOutsidePointerEventsDisabled.delete(h), ep())
          }, [h, d]), o.useEffect(() => {
            let e = () => g({});
            return document.addEventListener(eu, e), () => document.removeEventListener(eu, e)
          }, []), m.jsx(ec.div, {
            ...u,
            ref: v,
            style: {
              pointerEvents: w ? j ? "auto" : "none" : void 0,
              ...e.style
            },
            onFocusCapture: Y(e.onFocusCapture, k.onFocusCapture),
            onBlurCapture: Y(e.onBlurCapture, k.onBlurCapture),
            onPointerDownCapture: Y(e.onPointerDownCapture, _.onPointerDownCapture)
          })
        });

      function ep() {
        let e = new CustomEvent(eu);
        document.dispatchEvent(e)
      }

      function em(e, t, n, i) {
        let {
          discrete: s
        } = i, a = n.originalEvent.target, o = new CustomEvent(e, {
          bubbles: !1,
          cancelable: !0,
          detail: n
        });
        t && a.addEventListener(e, t, {
          once: !0
        }), s ? a && c.flushSync(() => a.dispatchEvent(o)) : a.dispatchEvent(o)
      }
      eh.displayName = "DismissableLayer", o.forwardRef((e, t) => {
        let n = o.useContext(ed),
          i = o.useRef(null),
          s = G(t, i);
        return o.useEffect(() => {
          let e = i.current;
          if (e) return n.branches.add(e), () => {
            n.branches.delete(e)
          }
        }, [n.branches]), m.jsx(ec.div, {
          ...e,
          ref: s
        })
      }).displayName = "DismissableLayerBranch";
      var ef = "focusScope.autoFocusOnMount",
        eg = "focusScope.autoFocusOnUnmount",
        ev = {
          bubbles: !1,
          cancelable: !0
        },
        ey = o.forwardRef((e, t) => {
          let {
            loop: n = !1,
            trapped: i = !1,
            onMountAutoFocus: s,
            onUnmountAutoFocus: a,
            ...l
          } = e, [c, u] = o.useState(null), d = en(s), h = en(a), p = o.useRef(null), f = G(t, e => u(e)), g = o.useRef({
            paused: !1,
            pause() {
              this.paused = !0
            },
            resume() {
              this.paused = !1
            }
          }).current;
          o.useEffect(() => {
            if (i) {
              let e = function(e) {
                  if (g.paused || !c) return;
                  let t = e.target;
                  c.contains(t) ? p.current = t : eC(p.current, {
                    select: !0
                  })
                },
                t = function(e) {
                  if (g.paused || !c) return;
                  let t = e.relatedTarget;
                  null !== t && (c.contains(t) || eC(p.current, {
                    select: !0
                  }))
                };
              document.addEventListener("focusin", e), document.addEventListener("focusout", t);
              let n = new MutationObserver(function(e) {
                if (document.activeElement === document.body)
                  for (let t of e) t.removedNodes.length > 0 && eC(c)
              });
              return c && n.observe(c, {
                childList: !0,
                subtree: !0
              }), () => {
                document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), n.disconnect()
              }
            }
          }, [i, c, g.paused]), o.useEffect(() => {
            if (c) {
              ew.add(g);
              let e = document.activeElement;
              if (!c.contains(e)) {
                let t = new CustomEvent(ef, ev);
                c.addEventListener(ef, d), c.dispatchEvent(t), t.defaultPrevented || (function(e) {
                  let {
                    select: t = !1
                  } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = document.activeElement;
                  for (let i of e)
                    if (eC(i, {
                        select: t
                      }), document.activeElement !== n) return
                }(ex(c).filter(e => "A" !== e.tagName), {
                  select: !0
                }), document.activeElement === e && eC(c))
              }
              return () => {
                c.removeEventListener(ef, d), setTimeout(() => {
                  let t = new CustomEvent(eg, ev);
                  c.addEventListener(eg, h), c.dispatchEvent(t), t.defaultPrevented || eC(e ?? document.body, {
                    select: !0
                  }), c.removeEventListener(eg, h), ew.remove(g)
                }, 0)
              }
            }
          }, [c, d, h, g]);
          let v = o.useCallback(e => {
            if (!n && !i || g.paused) return;
            let t = "Tab" === e.key && !e.altKey && !e.ctrlKey && !e.metaKey,
              s = document.activeElement;
            if (t && s) {
              let t = e.currentTarget,
                [i, a] = function(e) {
                  let t = ex(e);
                  return [eb(t, e), eb(t.reverse(), e)]
                }(t);
              i && a ? e.shiftKey || s !== a ? e.shiftKey && s === i && (e.preventDefault(), n && eC(a, {
                select: !0
              })) : (e.preventDefault(), n && eC(i, {
                select: !0
              })) : s === t && e.preventDefault()
            }
          }, [n, i, g.paused]);
          return m.jsx(ec.div, {
            tabIndex: -1,
            ...l,
            ref: f,
            onKeyDown: v
          })
        });

      function ex(e) {
        let t = [],
          n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
            acceptNode: e => {
              let t = "INPUT" === e.tagName && "hidden" === e.type;
              return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
            }
          });
        for (; n.nextNode();) t.push(n.currentNode);
        return t
      }

      function eb(e, t) {
        for (let n of e)
          if (! function(e, t) {
              let {
                upTo: n
              } = t;
              if ("hidden" === getComputedStyle(e).visibility) return !0;
              for (; e && (void 0 === n || e !== n);) {
                if ("none" === getComputedStyle(e).display) return !0;
                e = e.parentElement
              }
              return !1
            }(n, {
              upTo: t
            })) return n
      }

      function eC(e) {
        let {
          select: t = !1
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        if (e && e.focus) {
          var n;
          let i = document.activeElement;
          e.focus({
            preventScroll: !0
          }), e !== i && (n = e) instanceof HTMLInputElement && "select" in n && t && e.select()
        }
      }
      ey.displayName = "FocusScope";
      var ew = (s = [], {
        add(e) {
          let t = s[0];
          e !== t && (null == t || t.pause()), (s = ej(s, e)).unshift(e)
        },
        remove(e) {
          var t;
          null == (t = (s = ej(s, e))[0]) || t.resume()
        }
      });

      function ej(e, t) {
        let n = [...e],
          i = n.indexOf(t);
        return -1 !== i && n.splice(i, 1), n
      }
      var e_ = e => {
        var t, n;
        let i, s;
        let {
          present: a,
          children: l
        } = e, c = function(e) {
          var t, n;
          let [i, s] = o.useState(), a = o.useRef({}), l = o.useRef(e), c = o.useRef("none"), [u, d] = (t = e ? "mounted" : "unmounted", n = {
            mounted: {
              UNMOUNT: "unmounted",
              ANIMATION_OUT: "unmountSuspended"
            },
            unmountSuspended: {
              MOUNT: "mounted",
              ANIMATION_END: "unmounted"
            },
            unmounted: {
              MOUNT: "mounted"
            }
          }, o.useReducer((e, t) => n[e][t] ?? e, t));
          return o.useEffect(() => {
            let e = ek(a.current);
            c.current = "mounted" === u ? e : "none"
          }, [u]), Q(() => {
            let t = a.current,
              n = l.current;
            if (n !== e) {
              let i = c.current,
                s = ek(t);
              e ? d("MOUNT") : "none" === s || (null == t ? void 0 : t.display) === "none" ? d("UNMOUNT") : d(n && i !== s ? "ANIMATION_OUT" : "UNMOUNT"), l.current = e
            }
          }, [e, d]), Q(() => {
            if (i) {
              let e;
              let t = i.ownerDocument.defaultView ?? window,
                n = n => {
                  let s = ek(a.current).includes(n.animationName);
                  if (n.target === i && s && (d("ANIMATION_END"), !l.current)) {
                    let n = i.style.animationFillMode;
                    i.style.animationFillMode = "forwards", e = t.setTimeout(() => {
                      "forwards" === i.style.animationFillMode && (i.style.animationFillMode = n)
                    })
                  }
                },
                s = e => {
                  e.target === i && (c.current = ek(a.current))
                };
              return i.addEventListener("animationstart", s), i.addEventListener("animationcancel", n), i.addEventListener("animationend", n), () => {
                t.clearTimeout(e), i.removeEventListener("animationstart", s), i.removeEventListener("animationcancel", n), i.removeEventListener("animationend", n)
              }
            }
            d("ANIMATION_END")
          }, [i, d]), {
            isPresent: ["mounted", "unmountSuspended"].includes(u),
            ref: o.useCallback(e => {
              e && (a.current = getComputedStyle(e)), s(e)
            }, [])
          }
        }(a), u = "function" == typeof l ? l({
          present: c.isPresent
        }) : o.Children.only(l), d = G(c.ref, (i = null == (t = Object.getOwnPropertyDescriptor(u.props, "ref")) ? void 0 : t.get) && "isReactWarning" in i && i.isReactWarning ? u.ref : (i = null == (n = Object.getOwnPropertyDescriptor(u, "ref")) ? void 0 : n.get) && "isReactWarning" in i && i.isReactWarning ? u.props.ref : u.props.ref || u.ref);
        return "function" == typeof l || c.isPresent ? o.cloneElement(u, {
          ref: d
        }) : null
      };

      function ek(e) {
        return (null == e ? void 0 : e.animationName) || "none"
      }
      e_.displayName = "Presence";
      var eS = 0;

      function eE() {
        let e = document.createElement("span");
        return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e
      }
      var eP = function() {
        return (eP = Object.assign || function(e) {
          for (var t, n = 1, i = arguments.length; n < i; n++)
            for (var s in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
          return e
        }).apply(this, arguments)
      };

      function eM(e, t) {
        var n = {};
        for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && 0 > t.indexOf(i) && (n[i] = e[i]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols)
          for (var s = 0, i = Object.getOwnPropertySymbols(e); s < i.length; s++) 0 > t.indexOf(i[s]) && Object.prototype.propertyIsEnumerable.call(e, i[s]) && (n[i[s]] = e[i[s]]);
        return n
      }
      var eT = "right-scroll-bar-position",
        eL = "width-before-scroll-bar";

      function eA(e, t) {
        return "function" == typeof e ? e(t) : e && (e.current = t), e
      }
      var eV = o.useLayoutEffect,
        eR = new WeakMap,
        eN = function(e) {
          var t = e.sideCar,
            n = eM(e, ["sideCar"]);
          if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
          var i = t.read();
          if (!i) throw Error("Sidecar medium not found");
          return o.createElement(i, eP({}, n))
        };
      eN.isSideCarExport = !0;
      var eD = (void 0 === l8 && (l8 = {}), (void 0 === ce && (ce = function(e) {
          return e
        }), ct = [], cn = !1, cr = {
          read: function() {
            if (cn) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            return ct.length ? ct[ct.length - 1] : null
          },
          useMedium: function(e) {
            var t = ce(e, cn);
            return ct.push(t),
              function() {
                ct = ct.filter(function(e) {
                  return e !== t
                })
              }
          },
          assignSyncMedium: function(e) {
            for (cn = !0; ct.length;) {
              var t = ct;
              ct = [], t.forEach(e)
            }
            ct = {
              push: function(t) {
                return e(t)
              },
              filter: function() {
                return ct
              }
            }
          },
          assignMedium: function(e) {
            cn = !0;
            var t = [];
            if (ct.length) {
              var n = ct;
              ct = [], n.forEach(e), t = ct
            }
            var i = function() {
                var n = t;
                t = [], n.forEach(e)
              },
              s = function() {
                return Promise.resolve().then(i)
              };
            s(), ct = {
              push: function(e) {
                t.push(e), s()
              },
              filter: function(e) {
                return t = t.filter(e), ct
              }
            }
          }
        }).options = eP({
          async: !0,
          ssr: !1
        }, l8), cr),
        eO = function() {},
        eH = o.forwardRef(function(e, t) {
          var n, i, s, a, l = o.useRef(null),
            c = o.useState({
              onScrollCapture: eO,
              onWheelCapture: eO,
              onTouchMoveCapture: eO
            }),
            u = c[0],
            d = c[1],
            h = e.forwardProps,
            p = e.children,
            m = e.className,
            f = e.removeScrollBar,
            g = e.enabled,
            v = e.shards,
            y = e.sideCar,
            x = e.noIsolation,
            b = e.inert,
            C = e.allowPinchZoom,
            w = e.as,
            j = e.gapMode,
            _ = eM(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]),
            k = (n = [l, t], i = function(e) {
              return n.forEach(function(t) {
                return eA(t, e)
              })
            }, (s = (0, o.useState)(function() {
              return {
                value: null,
                callback: i,
                facade: {
                  get current() {
                    return s.value
                  },
                  set current(r) {
                    var e = s.value;
                    e !== r && (s.value = r, s.callback(r, e))
                  }
                }
              }
            })[0]).callback = i, a = s.facade, eV(function() {
              var e = eR.get(a);
              if (e) {
                var t = new Set(e),
                  i = new Set(n),
                  s = a.current;
                t.forEach(function(e) {
                  i.has(e) || eA(e, null)
                }), i.forEach(function(e) {
                  t.has(e) || eA(e, s)
                })
              }
              eR.set(a, n)
            }, [n]), a),
            S = eP(eP({}, _), u);
          return o.createElement(o.Fragment, null, g && o.createElement(y, {
            sideCar: eD,
            removeScrollBar: f,
            shards: v,
            noIsolation: x,
            inert: b,
            setCallbacks: d,
            allowPinchZoom: !!C,
            lockRef: l,
            gapMode: j
          }), h ? o.cloneElement(o.Children.only(p), eP(eP({}, S), {
            ref: k
          })) : o.createElement(void 0 === w ? "div" : w, eP({}, S, {
            className: m,
            ref: k
          }), p))
        });
      eH.defaultProps = {
        enabled: !0,
        removeScrollBar: !0,
        inert: !1
      }, eH.classNames = {
        fullWidth: eL,
        zeroRight: eT
      };
      var eI = function() {
          var e = 0,
            t = null;
          return {
            add: function(i) {
              var s, a;
              0 == e && (t = function() {
                if (!document) return null;
                var e = document.createElement("style");
                e.type = "text/css";
                var t = ci || n.nc;
                return t && e.setAttribute("nonce", t), e
              }()) && ((s = t).styleSheet ? s.styleSheet.cssText = i : s.appendChild(document.createTextNode(i)), a = t, (document.head || document.getElementsByTagName("head")[0]).appendChild(a)), e++
            },
            remove: function() {
              --e || !t || (t.parentNode && t.parentNode.removeChild(t), t = null)
            }
          }
        },
        eB = function() {
          var e = eI();
          return function(t, n) {
            o.useEffect(function() {
              return e.add(t),
                function() {
                  e.remove()
                }
            }, [t && n])
          }
        },
        eF = function() {
          var e = eB();
          return function(t) {
            return e(t.styles, t.dynamic), null
          }
        },
        eW = function(e) {
          return parseInt(e || "", 10) || 0
        },
        ez = function(e) {
          var t = window.getComputedStyle(document.body),
            n = t["padding" === e ? "paddingLeft" : "marginLeft"],
            i = t["padding" === e ? "paddingTop" : "marginTop"],
            s = t["padding" === e ? "paddingRight" : "marginRight"];
          return [eW(n), eW(i), eW(s)]
        },
        e$ = function(e) {
          void 0 === e && (e = "margin");
          var t = ez(e),
            n = document.documentElement.clientWidth,
            i = window.innerWidth;
          return {
            left: t[0],
            top: t[1],
            right: t[2],
            gap: Math.max(0, i - n + t[2] - t[0])
          }
        },
        eZ = eF(),
        eU = "data-scroll-locked",
        eq = function(e, t, n, i) {
          var s = e.left,
            a = e.top,
            o = e.right,
            l = e.gap;
          return void 0 === n && (n = "margin"), `
  .`.concat("with-scroll-bars-hidden", ` {
   overflow: hidden `).concat(i, `;
   padding-right: `).concat(l, "px ").concat(i, `;
  }
  body[`).concat(eU, `] {
    overflow: hidden `).concat(i, `;
    overscroll-behavior: contain;
    `).concat([t && "position: relative ".concat(i, ";"), "margin" === n && `
    padding-left: `.concat(s, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(i, `;
    `), "padding" === n && "padding-right: ".concat(l, "px ").concat(i, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(eT, ` {
    right: `).concat(l, "px ").concat(i, `;
  }
  
  .`).concat(eL, ` {
    margin-right: `).concat(l, "px ").concat(i, `;
  }
  
  .`).concat(eT, " .").concat(eT, ` {
    right: 0 `).concat(i, `;
  }
  
  .`).concat(eL, " .").concat(eL, ` {
    margin-right: 0 `).concat(i, `;
  }
  
  body[`).concat(eU, `] {
    `).concat("--removed-body-scroll-bar-size", ": ").concat(l, `px;
  }
`)
        },
        eX = function() {
          var e = parseInt(document.body.getAttribute(eU) || "0", 10);
          return isFinite(e) ? e : 0
        },
        eY = function() {
          o.useEffect(function() {
            return document.body.setAttribute(eU, (eX() + 1).toString()),
              function() {
                var e = eX() - 1;
                e <= 0 ? document.body.removeAttribute(eU) : document.body.setAttribute(eU, e.toString())
              }
          }, [])
        },
        eK = function(e) {
          var t = e.noRelative,
            n = e.noImportant,
            i = e.gapMode,
            s = void 0 === i ? "margin" : i;
          eY();
          var a = o.useMemo(function() {
            return e$(s)
          }, [s]);
          return o.createElement(eZ, {
            styles: eq(a, !t, s, n ? "" : "!important")
          })
        },
        eG = !1;
      try {
        var eQ = Object.defineProperty({}, "passive", {
          get: function() {
            return eG = !0, !0
          }
        });
        window.addEventListener("test", eQ, eQ), window.removeEventListener("test", eQ, eQ)
      } catch {
        eG = !1
      }
      var eJ = !!eG && {
          passive: !1
        },
        e1 = function(e, t) {
          if (!(e instanceof Element)) return !1;
          var n = window.getComputedStyle(e);
          return "hidden" !== n[t] && !(n.overflowY === n.overflowX && "TEXTAREA" !== e.tagName && "visible" === n[t])
        },
        e0 = function(e, t) {
          var n = t.ownerDocument,
            i = t;
          do {
            if ("u" > typeof ShadowRoot && i instanceof ShadowRoot && (i = i.host), e2(e, i)) {
              var s = e5(e, i);
              if (s[1] > s[2]) return !0
            }
            i = i.parentNode
          } while (i && i !== n.body);
          return !1
        },
        e2 = function(e, t) {
          return "v" === e ? e1(t, "overflowY") : e1(t, "overflowX")
        },
        e5 = function(e, t) {
          return "v" === e ? [t.scrollTop, t.scrollHeight, t.clientHeight] : [t.scrollLeft, t.scrollWidth, t.clientWidth]
        },
        e3 = function(e, t, n, i, s) {
          var a, o = (a = window.getComputedStyle(t).direction, "h" === e && "rtl" === a ? -1 : 1),
            l = o * i,
            c = n.target,
            u = t.contains(c),
            d = !1,
            h = l > 0,
            p = 0,
            m = 0;
          do {
            var f = e5(e, c),
              g = f[0],
              v = f[1] - f[2] - o * g;
            (g || v) && e2(e, c) && (p += v, m += g), c instanceof ShadowRoot ? c = c.host : c = c.parentNode
          } while (!u && c !== document.body || u && (t.contains(c) || t === c));
          return (h && (s && 1 > Math.abs(p) || !s && l > p) || !h && (s && 1 > Math.abs(m) || !s && -l > m)) && (d = !0), d
        },
        e4 = function(e) {
          return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0]
        },
        e6 = function(e) {
          return [e.deltaX, e.deltaY]
        },
        e7 = function(e) {
          return e && "current" in e ? e.current : e
        },
        e9 = 0,
        e8 = [];
      let te = (cs = function(e) {
        var t = o.useRef([]),
          n = o.useRef([0, 0]),
          i = o.useRef(),
          s = o.useState(e9++)[0],
          a = o.useState(eF)[0],
          l = o.useRef(e);
        o.useEffect(function() {
          l.current = e
        }, [e]), o.useEffect(function() {
          if (e.inert) {
            document.body.classList.add("block-interactivity-".concat(s));
            var t = (function(e, t, n) {
              if (n || 2 == arguments.length)
                for (var i, s = 0, a = t.length; s < a; s++) !i && s in t || (i || (i = Array.prototype.slice.call(t, 0, s)), i[s] = t[s]);
              return e.concat(i || Array.prototype.slice.call(t))
            })([e.lockRef.current], (e.shards || []).map(e7), !0).filter(Boolean);
            return t.forEach(function(e) {
                return e.classList.add("allow-interactivity-".concat(s))
              }),
              function() {
                document.body.classList.remove("block-interactivity-".concat(s)), t.forEach(function(e) {
                  return e.classList.remove("allow-interactivity-".concat(s))
                })
              }
          }
        }, [e.inert, e.lockRef.current, e.shards]);
        var c = o.useCallback(function(e, t) {
            if ("touches" in e && 2 === e.touches.length || "wheel" === e.type && e.ctrlKey) return !l.current.allowPinchZoom;
            var s, a = e4(e),
              o = n.current,
              c = "deltaX" in e ? e.deltaX : o[0] - a[0],
              u = "deltaY" in e ? e.deltaY : o[1] - a[1],
              d = e.target,
              h = Math.abs(c) > Math.abs(u) ? "h" : "v";
            if ("touches" in e && "h" === h && "range" === d.type) return !1;
            var p = e0(h, d);
            if (!p) return !0;
            if (p ? s = h : (s = "v" === h ? "h" : "v", p = e0(h, d)), !p) return !1;
            if (!i.current && "changedTouches" in e && (c || u) && (i.current = s), !s) return !0;
            var m = i.current || s;
            return e3(m, t, e, "h" === m ? c : u, !0)
          }, []),
          u = o.useCallback(function(e) {
            if (!(!e8.length || e8[e8.length - 1] !== a)) {
              var n = "deltaY" in e ? e6(e) : e4(e),
                i = t.current.filter(function(t) {
                  var i;
                  return t.name === e.type && (t.target === e.target || e.target === t.shadowParent) && (i = t.delta)[0] === n[0] && i[1] === n[1]
                })[0];
              if (i && i.should) {
                e.cancelable && e.preventDefault();
                return
              }
              if (!i) {
                var s = (l.current.shards || []).map(e7).filter(Boolean).filter(function(t) {
                  return t.contains(e.target)
                });
                (s.length > 0 ? c(e, s[0]) : !l.current.noIsolation) && e.cancelable && e.preventDefault()
              }
            }
          }, []),
          d = o.useCallback(function(e, n, i, s) {
            var a = {
              name: e,
              delta: n,
              target: i,
              should: s,
              shadowParent: function(e) {
                for (var t = null; null !== e;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
                return t
              }(i)
            };
            t.current.push(a), setTimeout(function() {
              t.current = t.current.filter(function(e) {
                return e !== a
              })
            }, 1)
          }, []),
          h = o.useCallback(function(e) {
            n.current = e4(e), i.current = void 0
          }, []),
          p = o.useCallback(function(t) {
            d(t.type, e6(t), t.target, c(t, e.lockRef.current))
          }, []),
          m = o.useCallback(function(t) {
            d(t.type, e4(t), t.target, c(t, e.lockRef.current))
          }, []);
        o.useEffect(function() {
          return e8.push(a), e.setCallbacks({
              onScrollCapture: p,
              onWheelCapture: p,
              onTouchMoveCapture: m
            }), document.addEventListener("wheel", u, eJ), document.addEventListener("touchmove", u, eJ), document.addEventListener("touchstart", h, eJ),
            function() {
              e8 = e8.filter(function(e) {
                return e !== a
              }), document.removeEventListener("wheel", u, eJ), document.removeEventListener("touchmove", u, eJ), document.removeEventListener("touchstart", h, eJ)
            }
        }, []);
        var f = e.removeScrollBar,
          g = e.inert;
        return o.createElement(o.Fragment, null, g ? o.createElement(a, {
          styles: `
  .block-interactivity-`.concat(s, ` {pointer-events: none;}
  .allow-interactivity-`).concat(s, ` {pointer-events: all;}
`)
        }) : null, f ? o.createElement(eK, {
          gapMode: e.gapMode
        }) : null)
      }, eD.useMedium(cs), eN);
      var tt = o.forwardRef(function(e, t) {
        return o.createElement(eH, eP({}, e, {
          ref: t,
          sideCar: te
        }))
      });
      tt.classNames = eH.classNames;
      var tn = new WeakMap,
        tr = new WeakMap,
        ti = {},
        ts = 0,
        ta = function(e) {
          return e && (e.host || ta(e.parentNode))
        },
        to = function(e, t, n, i) {
          var s = (Array.isArray(e) ? e : [e]).map(function(e) {
            if (t.contains(e)) return e;
            var n = ta(e);
            return n && t.contains(n) ? n : (console.error("aria-hidden", e, "in not contained inside", t, ". Doing nothing"), null)
          }).filter(function(e) {
            return !!e
          });
          ti[n] || (ti[n] = new WeakMap);
          var a = ti[n],
            o = [],
            l = new Set,
            c = new Set(s),
            u = function(e) {
              !e || l.has(e) || (l.add(e), u(e.parentNode))
            };
          s.forEach(u);
          var d = function(e) {
            !e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
              if (l.has(e)) d(e);
              else {
                var t = e.getAttribute(i),
                  s = null !== t && "false" !== t,
                  c = (tn.get(e) || 0) + 1,
                  u = (a.get(e) || 0) + 1;
                tn.set(e, c), a.set(e, u), o.push(e), 1 === c && s && tr.set(e, !0), 1 === u && e.setAttribute(n, "true"), s || e.setAttribute(i, "true")
              }
            })
          };
          return d(t), l.clear(), ts++,
            function() {
              o.forEach(function(e) {
                var t = tn.get(e) - 1,
                  s = a.get(e) - 1;
                tn.set(e, t), a.set(e, s), t || (tr.has(e) || e.removeAttribute(i), tr.delete(e)), s || e.removeAttribute(n)
              }), --ts || (tn = new WeakMap, tn = new WeakMap, tr = new WeakMap, ti = {})
            }
        },
        tl = function(e, t, n) {
          void 0 === n && (n = "data-aria-hidden");
          var i = Array.from(Array.isArray(e) ? e : [e]),
            s = t || (typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body);
          return s ? (i.push.apply(i, Array.from(s.querySelectorAll("[aria-live]"))), to(i, s, n, "aria-hidden")) : function() {
            return null
          }
        },
        tc = "Dialog",
        [tu, td] = function(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = [],
            i = () => {
              let t = n.map(e => o.createContext(e));
              return function(n) {
                let i = (null == n ? void 0 : n[e]) || t;
                return o.useMemo(() => ({
                  [`__scope${e}`]: {
                    ...n,
                    [e]: i
                  }
                }), [n, i])
              }
            };
          return i.scopeName = e, [function(t, i) {
            let s = o.createContext(i),
              a = n.length;
            n = [...n, i];
            let l = t => {
              var n;
              let {
                scope: i,
                children: l,
                ...c
              } = t, u = (null == (n = null == i ? void 0 : i[e]) ? void 0 : n[a]) || s, d = o.useMemo(() => c, Object.values(c));
              return m.jsx(u.Provider, {
                value: d,
                children: l
              })
            };
            return l.displayName = t + "Provider", [l, function(n, l) {
              var c;
              let u = (null == (c = null == l ? void 0 : l[e]) ? void 0 : c[a]) || s,
                d = o.useContext(u);
              if (d) return d;
              if (void 0 !== i) return i;
              throw Error(`\`${n}\` must be used within \`${t}\``)
            }]
          }, function() {
            for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            let i = t[0];
            if (1 === t.length) return i;
            let s = () => {
              let e = t.map(e => ({
                useScope: e(),
                scopeName: e.scopeName
              }));
              return function(t) {
                let n = e.reduce((e, n) => {
                  let {
                    useScope: i,
                    scopeName: s
                  } = n, a = i(t)[`__scope${s}`];
                  return {
                    ...e,
                    ...a
                  }
                }, {});
                return o.useMemo(() => ({
                  [`__scope${i.scopeName}`]: n
                }), [n])
              }
            };
            return s.scopeName = i.scopeName, s
          }(i, ...t)]
        }(tc),
        [th, tp] = tu(tc),
        tm = e => {
          let {
            __scopeDialog: t,
            children: n,
            open: i,
            defaultOpen: s,
            onOpenChange: a,
            modal: l = !0
          } = e, c = o.useRef(null), u = o.useRef(null), [d = !1, h] = function(e) {
            let {
              prop: t,
              defaultProp: n,
              onChange: i = () => {}
            } = e, [s, a] = function(e) {
              let {
                defaultProp: t,
                onChange: n
              } = e, i = o.useState(t), [s] = i, a = o.useRef(s), l = en(n);
              return o.useEffect(() => {
                a.current !== s && (l(s), a.current = s)
              }, [s, a, l]), i
            }({
              defaultProp: n,
              onChange: i
            }), l = void 0 !== t, c = l ? t : s, u = en(i);
            return [c, o.useCallback(e => {
              if (l) {
                let n = "function" == typeof e ? e(t) : e;
                n !== t && u(n)
              } else a(e)
            }, [l, t, a, u])]
          }({
            prop: i,
            defaultProp: s,
            onChange: a
          });
          return m.jsx(th, {
            scope: t,
            triggerRef: c,
            contentRef: u,
            contentId: et(),
            titleId: et(),
            descriptionId: et(),
            open: d,
            onOpenChange: h,
            onOpenToggle: o.useCallback(() => h(e => !e), [h]),
            modal: l,
            children: n
          })
        };
      tm.displayName = tc;
      var tf = "DialogTrigger";
      o.forwardRef((e, t) => {
        let {
          __scopeDialog: n,
          ...i
        } = e, s = tp(tf, n), a = G(t, s.triggerRef);
        return m.jsx(ec.button, {
          type: "button",
          "aria-haspopup": "dialog",
          "aria-expanded": s.open,
          "aria-controls": s.contentId,
          "data-state": tM(s.open),
          ...i,
          ref: a,
          onClick: Y(e.onClick, s.onOpenToggle)
        })
      }).displayName = tf;
      var [tg, tv] = tu("DialogPortal", {
        forceMount: void 0
      }), ty = "DialogOverlay", tx = o.forwardRef((e, t) => {
        let n = tv(ty, e.__scopeDialog),
          {
            forceMount: i = n.forceMount,
            ...s
          } = e,
          a = tp(ty, e.__scopeDialog);
        return a.modal ? m.jsx(e_, {
          present: i || a.open,
          children: m.jsx(tb, {
            ...s,
            ref: t
          })
        }) : null
      });
      tx.displayName = ty;
      var tb = o.forwardRef((e, t) => {
          let {
            __scopeDialog: n,
            ...i
          } = e, s = tp(ty, n);
          return m.jsx(tt, {
            as: er,
            allowPinchZoom: !0,
            shards: [s.contentRef],
            children: m.jsx(ec.div, {
              "data-state": tM(s.open),
              ...i,
              ref: t,
              style: {
                pointerEvents: "auto",
                ...i.style
              }
            })
          })
        }),
        tC = "DialogContent",
        tw = o.forwardRef((e, t) => {
          let n = tv(tC, e.__scopeDialog),
            {
              forceMount: i = n.forceMount,
              ...s
            } = e,
            a = tp(tC, e.__scopeDialog);
          return m.jsx(e_, {
            present: i || a.open,
            children: a.modal ? m.jsx(tj, {
              ...s,
              ref: t
            }) : m.jsx(t_, {
              ...s,
              ref: t
            })
          })
        });
      tw.displayName = tC;
      var tj = o.forwardRef((e, t) => {
          let n = tp(tC, e.__scopeDialog),
            i = o.useRef(null),
            s = G(t, n.contentRef, i);
          return o.useEffect(() => {
            let e = i.current;
            if (e) return tl(e)
          }, []), m.jsx(tk, {
            ...e,
            ref: s,
            trapFocus: n.open,
            disableOutsidePointerEvents: !0,
            onCloseAutoFocus: Y(e.onCloseAutoFocus, e => {
              var t;
              e.preventDefault(), null == (t = n.triggerRef.current) || t.focus()
            }),
            onPointerDownOutside: Y(e.onPointerDownOutside, e => {
              let t = e.detail.originalEvent,
                n = 0 === t.button && !0 === t.ctrlKey;
              (2 === t.button || n) && e.preventDefault()
            }),
            onFocusOutside: Y(e.onFocusOutside, e => e.preventDefault())
          })
        }),
        t_ = o.forwardRef((e, t) => {
          let n = tp(tC, e.__scopeDialog),
            i = o.useRef(!1),
            s = o.useRef(!1);
          return m.jsx(tk, {
            ...e,
            ref: t,
            trapFocus: !1,
            disableOutsidePointerEvents: !1,
            onCloseAutoFocus: t => {
              var a, o;
              null == (a = e.onCloseAutoFocus) || a.call(e, t), t.defaultPrevented || (i.current || null == (o = n.triggerRef.current) || o.focus(), t.preventDefault()), i.current = !1, s.current = !1
            },
            onInteractOutside: t => {
              var a, o;
              null == (a = e.onInteractOutside) || a.call(e, t), t.defaultPrevented || (i.current = !0, "pointerdown" === t.detail.originalEvent.type && (s.current = !0));
              let l = t.target;
              (null == (o = n.triggerRef.current) ? void 0 : o.contains(l)) && t.preventDefault(), "focusin" === t.detail.originalEvent.type && s.current && t.preventDefault()
            }
          })
        }),
        tk = o.forwardRef((e, t) => {
          let {
            __scopeDialog: n,
            trapFocus: i,
            onOpenAutoFocus: s,
            onCloseAutoFocus: a,
            ...l
          } = e, c = tp(tC, n), u = o.useRef(null), d = G(t, u);
          return o.useEffect(() => {
            let e = document.querySelectorAll("[data-radix-focus-guard]");
            return document.body.insertAdjacentElement("afterbegin", e[0] ?? eE()), document.body.insertAdjacentElement("beforeend", e[1] ?? eE()), eS++, () => {
              1 === eS && document.querySelectorAll("[data-radix-focus-guard]").forEach(e => e.remove()), eS--
            }
          }, []), m.jsxs(m.Fragment, {
            children: [m.jsx(ey, {
              asChild: !0,
              loop: !0,
              trapped: i,
              onMountAutoFocus: s,
              onUnmountAutoFocus: a,
              children: m.jsx(eh, {
                role: "dialog",
                id: c.contentId,
                "aria-describedby": c.descriptionId,
                "aria-labelledby": c.titleId,
                "data-state": tM(c.open),
                ...l,
                ref: d,
                onDismiss: () => c.onOpenChange(!1)
              })
            }), m.jsxs(m.Fragment, {
              children: [m.jsx(tV, {
                titleId: c.titleId
              }), m.jsx(tR, {
                contentRef: u,
                descriptionId: c.descriptionId
              })]
            })]
          })
        }),
        tS = "DialogTitle";
      o.forwardRef((e, t) => {
        let {
          __scopeDialog: n,
          ...i
        } = e, s = tp(tS, n);
        return m.jsx(ec.h2, {
          id: s.titleId,
          ...i,
          ref: t
        })
      }).displayName = tS;
      var tE = "DialogDescription";
      o.forwardRef((e, t) => {
        let {
          __scopeDialog: n,
          ...i
        } = e, s = tp(tE, n);
        return m.jsx(ec.p, {
          id: s.descriptionId,
          ...i,
          ref: t
        })
      }).displayName = tE;
      var tP = "DialogClose";

      function tM(e) {
        return e ? "open" : "closed"
      }
      o.forwardRef((e, t) => {
        let {
          __scopeDialog: n,
          ...i
        } = e, s = tp(tP, n);
        return m.jsx(ec.button, {
          type: "button",
          ...i,
          ref: t,
          onClick: Y(e.onClick, () => s.onOpenChange(!1))
        })
      }).displayName = tP;
      var tT = "DialogTitleWarning",
        [tL, tA] = function(e, t) {
          let n = o.createContext(t),
            i = e => {
              let {
                children: t,
                ...i
              } = e, s = o.useMemo(() => i, Object.values(i));
              return m.jsx(n.Provider, {
                value: s,
                children: t
              })
            };
          return i.displayName = e + "Provider", [i, function(i) {
            let s = o.useContext(n);
            if (s) return s;
            if (void 0 !== t) return t;
            throw Error(`\`${i}\` must be used within \`${e}\``)
          }]
        }(tT, {
          contentName: tC,
          titleName: tS,
          docsSlug: "dialog"
        }),
        tV = e => {
          let {
            titleId: t
          } = e, n = tA(tT), i = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
          return o.useEffect(() => {
            t && (document.getElementById(t) || console.error(i))
          }, [i, t]), null
        },
        tR = e => {
          let {
            contentRef: t,
            descriptionId: n
          } = e, i = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${tA("DialogDescriptionWarning").contentName}}.`;
          return o.useEffect(() => {
            var e;
            let s = null == (e = t.current) ? void 0 : e.getAttribute("aria-describedby");
            n && s && (document.getElementById(n) || console.warn(i))
          }, [i, t, n]), null
        };
      let tN = () => {
        let [e, t] = (0, o.useState)([0, 0]);
        return (0, o.useEffect)(() => {
          let e = () => {
              t([window.innerWidth, window.innerHeight])
            },
            n = B(e, 40);
          return window.addEventListener("resize", n), e(), () => {
            window.removeEventListener("resize", n)
          }
        }, []), e
      };
      var tD = "936px",
        tO = "var(--_1epihgq2v)",
        tH = "var(--_1epihgq2w)",
        tI = "var(--_1epihgq2x)",
        tB = "var(--_1epihgq2y)",
        tF = {
          level1: "zf6z1ha zf6z1h9",
          level2: "zf6z1hb zf6z1h9",
          level3: "zf6z1hc zf6z1h9"
        };
      let tW = e => {
          let {
            children: t,
            level: n,
            mobileAccountButton: i
          } = e, s = tN()[0] < Number(tD.replace("px", ""));
          return m.jsxs(m.Fragment, {
            children: [m.jsx("ul", {
              className: tF[`level${n}`],
              children: t
            }), s && 1 === n && i && m.jsx("div", {
              className: "qn51an4",
              children: i
            })]
          })
        },
        tz = e => {
          let {
            children: t,
            isMenuOpen: n,
            onOpenChange: i
          } = e;
          return tN()[0] < Number(tD.replace("px", "")) ? m.jsxs(tm, {
            open: n,
            modal: !0,
            onOpenChange: i,
            children: [m.jsx(tx, {}), m.jsx(tw, {
              className: "qn51an3",
              children: t
            })]
          }) : m.jsx("div", {
            className: F(z, "yh30yx0"),
            children: t
          })
        },
        t$ = e => {
          let {
            isMenuOpen: t,
            onOpenChange: n,
            children: i,
            mobileAccountButton: s
          } = e, [a, l] = (0, o.useState)(void 0), c = o.Children.map(i, (e, t) => (0, o.cloneElement)(e, {
            index: t,
            isMainLevelActive: a === t,
            onActiveIndexChange: e => {
              e !== a && l(e)
            }
          }));
          return m.jsx(tz, {
            isMenuOpen: t,
            onOpenChange: n,
            children: m.jsx("nav", {
              className: "qn51an0",
              children: m.jsx(tW, {
                mobileAccountButton: s,
                level: 1,
                children: c
              })
            })
          })
        },
        tZ = e => m.jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          focusable: "false",
          ...e,
          children: m.jsx("path", {
            d: "M21.46 24L6.19995 8.73995L8.73995 6.19995L24 21.46L39.2599 6.19995L41.7999 8.73995L26.54 24L41.7999 39.2599L39.2599 41.7999L24 26.54L8.73995 41.7999L6.19995 39.2599L21.46 24Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          })
        }),
        tU = e => m.jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          focusable: "false",
          ...e,
          children: m.jsx("path", {
            d: "M28.42 31.18C26.08 32.94 23.16 34 20 34C12.26 34 6 27.74 6 20C6 12.26 12.26 6 20 6C27.74 6 34 12.26 34 20C34 23.28 32.88 26.28 31 28.68L42 39.44L39.48 42.02L28.42 31.2V31.18ZM30.4 20C30.4 25.74 25.74 30.4 20 30.4C14.26 30.4 9.6 25.74 9.6 20C9.6 14.26 14.26 9.6 20 9.6C25.74 9.6 30.4 14.26 30.4 20Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          })
        });
      var tq = "_1y2ff7g4",
        tX = {
          default: "gm9kwm2",
          invertedColors: "gm9kwm3"
        };
      let tY = e => {
        let {
          label: t,
          icon: n,
          invertedColors: i,
          className: s,
          ...a
        } = e, o = i ? tX.invertedColors : tX.default;
        return m.jsxs("button", {
          className: F("gm9kwm1", o, s || ""),
          ...a,
          children: [n, t && m.jsx("span", {
            className: "gm9kwm0",
            children: t
          })]
        })
      };
      var tK = {
          left: "ki0jezc",
          right: "ki0jezd"
        },
        tG = {
          small: "ki0jez6",
          medium: "ki0jez7",
          large: "ki0jez8"
        },
        tQ = {
          primary: "ki0jez2 ki0jez0",
          secondary: "ki0jez3 ki0jez0",
          tertiary: "ki0jez4 ki0jez0",
          transparent: "ki0jez5 ki0jez0"
        },
        tJ = {
          primary: "ki0jezb ki0jeza"
        };
      let t1 = e => {
        let {
          componentNode: t = "button",
          buttonStyle: n = "primary",
          size: i = "small",
          iconPosition: s = "left",
          children: a,
          counter: o,
          invertColors: l = !1,
          icon: c,
          url: u,
          onClick: d
        } = e, h = tQ[n], p = tG[i], f = c ? tK[s] : "", g = o ? tJ.primary : "", v = F(h, p, f, l ? "ki0jez1" : "");
        return m.jsxs("button" == t ? "button" : "a", {
          className: v,
          onClick: "button" == t ? d : void 0,
          href: "a" == t ? u : void 0,
          children: [c && m.jsx("span", {
            className: "ki0jez9",
            children: c
          }), a && m.jsx("span", {
            className: "ki0jeze",
            children: a
          }), o && "large" === i && "primary" === n && m.jsx("span", {
            className: g,
            children: o
          })]
        })
      };
      var t0 = {
        two: "_1900asl1",
        three: "_1900asl2"
      };
      let t2 = e => {
        let {
          placeholder: t,
          value: n,
          onChange: i,
          isParentOpen: s,
          searchButtonLabel: a,
          searchSuggestions: l,
          fieldIcon: c,
          showButton: u = !1,
          label: d,
          supportingText: h,
          id: p = "searchField"
        } = e, f = (0, o.useRef)(null), g = c ? (0, o.cloneElement)(c, {
          className: tq
        }) : m.jsx(tU, {
          className: tq
        });
        return (0, o.useEffect)(() => {
          s && f.current && f.current.focus()
        }, [s, f]), m.jsxs("form", {
          onSubmit: e => {
            e.preventDefault()
          },
          children: [d && m.jsx("label", {
            htmlFor: p,
            className: "_1y2ff7g1",
            children: d
          }), m.jsxs("div", {
            className: "_1y2ff7g0",
            children: [g, m.jsx("input", {
              type: "text",
              id: p,
              placeholder: t,
              value: n,
              onChange: e => i(e.target.value),
              className: "_1y2ff7g3",
              ref: f
            }), n && m.jsx(tY, {
              icon: m.jsx(tZ, {}),
              onClick: () => i("")
            }), u && m.jsx(t1, {
              buttonStyle: "primary",
              size: "medium",
              icon: m.jsx(tU, {}),
              iconPosition: "right",
              children: a && m.jsx(m.Fragment, {
                children: a
              })
            }), l && n && m.jsx("div", {
              className: F("_1y2ff7g5", t0.two),
              children: l
            })]
          }), h && m.jsx("p", {
            className: "_1y2ff7g2",
            children: h
          })]
        })
      };
      var t5 = "dk6f4c0",
        t3 = "dk6f4cb";

      function t4(e) {
        let {
          component: t = "p",
          variant: n,
          children: i,
          className: s = "",
          fontWeight: a = "light",
          spaceBelow: o
        } = e, l = n || t, c = "dk6f4ce";
        "regular" === a && (c = "dk6f4cf"), "bold" === a && (c = "dk6f4ch"), "medium" === a && (c = "dk6f4cg");
        let u = "";
        o && (u = "asj0v2");
        let d = F({
          h1: "dk6f4c1 dk6f4c0",
          h2: "dk6f4c2 dk6f4c0",
          h3: "dk6f4c3 dk6f4c0",
          h4: "dk6f4c4 dk6f4c0",
          h5: "dk6f4c5 dk6f4c0",
          h6: "dk6f4c6 dk6f4c0",
          p: t3,
          paragraph8: "dk6f4c8",
          paragraph10: "dk6f4c9",
          paragraph12: "dk6f4ca",
          paragraph14: t3,
          paragraph16: "dk6f4cc",
          paragraph18: "dk6f4cd",
          span: t3,
          div: t3,
          intro: "dk6f4c7 dk6f4c0"
        } [l] ?? t5, t5, l, s, c, u);
        return "h1" === t ? m.jsx("h1", {
          className: d,
          children: i
        }) : "h2" === t ? m.jsx("h2", {
          className: d,
          children: i
        }) : "h3" === t ? m.jsx("h3", {
          className: d,
          children: i
        }) : "h4" === t ? m.jsx("h4", {
          className: d,
          children: i
        }) : "h5" === t ? m.jsx("h5", {
          className: d,
          children: i
        }) : "h6" === t ? m.jsx("h6", {
          className: d,
          children: i
        }) : "div" === t ? m.jsx("div", {
          className: d,
          children: i
        }) : "span" === t ? m.jsx("span", {
          className: d,
          children: i
        }) : m.jsx("p", {
          className: d,
          children: i
        })
      }
      let t6 = e => {
          let {
            tags: t,
            label: n
          } = e;
          return m.jsxs("div", {
            className: "cue7lz0",
            children: [m.jsx(t4, {
              variant: "paragraph16",
              fontWeight: "medium",
              children: n
            }), m.jsx("ul", {
              className: "cue7lz1",
              children: t.map((e, t) => m.jsx("li", {
                children: m.jsx("button", {
                  className: "cue7lz2",
                  children: e
                })
              }, t))
            })]
          })
        },
        t7 = e => {
          let {
            children: t,
            ...n
          } = e;
          return m.jsx("button", {
            className: "ksiy7w0",
            ...n,
            children: t
          })
        },
        t9 = e => {
          let {
            categories: t
          } = e;
          return m.jsx("div", {
            className: "b65uxn0",
            children: t.map((e, t) => m.jsxs("div", {
              children: [m.jsx(t4, {
                variant: "paragraph12",
                fontWeight: "regular",
                className: "b65uxn1",
                children: e.name
              }), e.suggestions.map((e, t) => m.jsxs(t7, {
                onClick: e.onClick,
                children: [m.jsx(tU, {
                  className: "b65uxn2"
                }), m.jsx(t4, {
                  component: "span",
                  variant: "paragraph16",
                  fontWeight: "regular",
                  dangerouslySetInnerHTML: {
                    __html: e.name
                  },
                  children: m.jsx("span", {
                    dangerouslySetInnerHTML: {
                      __html: e.name
                    }
                  })
                })]
              }, t))]
            }, t))
          })
        };
      var t8 = {
          one: "_1l2267a22",
          two: "_1l2267a23",
          three: "_1l2267a24",
          four: "_1l2267a25",
          five: "_1l2267a26",
          six: "_1l2267a27",
          seven: "_1l2267a28",
          eight: "_1l2267a29",
          nine: "_1l2267a2a",
          ten: "_1l2267a2b",
          eleven: "_1l2267a2c",
          twelve: "_1l2267a2d"
        },
        ne = {
          one: "_1l2267a2e",
          two: "_1l2267a2f",
          three: "_1l2267a2g",
          four: "_1l2267a2h",
          five: "_1l2267a2i",
          six: "_1l2267a2j",
          seven: "_1l2267a2k",
          eight: "_1l2267a2l",
          nine: "_1l2267a2m",
          ten: "_1l2267a2n",
          eleven: "_1l2267a2o",
          twelve: "_1l2267a2p"
        },
        nt = {
          one: "_1l2267a2q",
          two: "_1l2267a2r",
          three: "_1l2267a2s",
          four: "_1l2267a2t",
          five: "_1l2267a2u",
          six: "_1l2267a2v",
          seven: "_1l2267a2w",
          eight: "_1l2267a2x",
          nine: "_1l2267a2y",
          ten: "_1l2267a2z",
          eleven: "_1l2267a30",
          twelve: "_1l2267a31"
        },
        nn = {
          two: "_1l2267ag",
          three: "_1l2267ah",
          four: "_1l2267ai",
          five: "_1l2267aj",
          six: "_1l2267ak",
          seven: "_1l2267al",
          eight: "_1l2267am",
          nine: "_1l2267an",
          ten: "_1l2267ao",
          eleven: "_1l2267ap",
          twelve: "_1l2267aq"
        },
        nr = {
          two: "_1l2267a5",
          three: "_1l2267a6",
          four: "_1l2267a7",
          five: "_1l2267a8",
          six: "_1l2267a9",
          seven: "_1l2267aa",
          eight: "_1l2267ab",
          nine: "_1l2267ac",
          ten: "_1l2267ad",
          eleven: "_1l2267ae",
          twelve: "_1l2267af"
        },
        ni = {
          one: "_1l2267a12",
          two: "_1l2267a13",
          three: "_1l2267a14",
          four: "_1l2267a15",
          five: "_1l2267a16",
          six: "_1l2267a17",
          seven: "_1l2267a18",
          eight: "_1l2267a19",
          nine: "_1l2267a1a",
          ten: "_1l2267a1b",
          eleven: "_1l2267a1c",
          twelve: "_1l2267a1d"
        },
        ns = {
          one: "_1l2267a1e",
          two: "_1l2267a1f",
          three: "_1l2267a1g",
          four: "_1l2267a1h",
          five: "_1l2267a1i",
          six: "_1l2267a1j",
          seven: "_1l2267a1k",
          eight: "_1l2267a1l",
          nine: "_1l2267a1m",
          ten: "_1l2267a1n",
          eleven: "_1l2267a1o",
          twelve: "_1l2267a1p"
        },
        na = {
          one: "_1l2267a1q",
          two: "_1l2267a1r",
          three: "_1l2267a1s",
          four: "_1l2267a1t",
          five: "_1l2267a1u",
          six: "_1l2267a1v",
          seven: "_1l2267a1w",
          eight: "_1l2267a1x",
          nine: "_1l2267a1y",
          ten: "_1l2267a1z",
          eleven: "_1l2267a20",
          twelve: "_1l2267a21"
        },
        no = {
          two: "_1l2267ar",
          three: "_1l2267as",
          four: "_1l2267at",
          five: "_1l2267au",
          six: "_1l2267av",
          seven: "_1l2267aw",
          eight: "_1l2267ax",
          nine: "_1l2267ay",
          ten: "_1l2267az",
          eleven: "_1l2267a10",
          twelve: "_1l2267a11"
        };
      let nl = e => {
          let {
            children: t,
            isOverlay: n
          } = e;
          return m.jsx("div", {
            className: F("_1l2267a3", n ? "_1l2267a0" : ""),
            children: t
          })
        },
        nc = e => {
          let {
            children: t,
            columns: n = 1,
            columnsL: i = 1,
            columnsXL: s = 1,
            start: a,
            startL: o,
            startXL: l,
            end: c,
            endL: u,
            endXL: d,
            verticalCentered: h = !1,
            changeOrder: p = !1,
            className: f = ""
          } = e, g = "", v = "", y = "", x = "", b = "", C = "", w = "", j = "", _ = "";
          switch (n) {
            case 2:
              g = nr.two;
              break;
            case 3:
              g = nr.three;
              break;
            case 4:
              g = nr.four;
              break;
            case 5:
              g = nr.five;
              break;
            case 6:
              g = nr.six;
              break;
            case 7:
              g = nr.seven;
              break;
            case 8:
              g = nr.eight;
              break;
            case 9:
              g = nr.nine;
              break;
            case 10:
              g = nr.ten;
              break;
            case 11:
              g = nr.eleven;
              break;
            case 12:
              g = nr.twelve;
              break;
            default:
              g = ""
          }
          switch (i) {
            case 2:
              v = nn.two;
              break;
            case 3:
              v = nn.three;
              break;
            case 4:
              v = nn.four;
              break;
            case 5:
              v = nn.five;
              break;
            case 6:
              v = nn.six;
              break;
            case 7:
              v = nn.seven;
              break;
            case 8:
              v = nn.eight;
              break;
            case 9:
              v = nn.nine;
              break;
            case 10:
              v = nn.ten;
              break;
            case 11:
              v = nn.eleven;
              break;
            case 12:
              v = nn.twelve;
              break;
            default:
              v = ""
          }
          switch (s) {
            case 2:
              y = no.two;
              break;
            case 3:
              y = no.three;
              break;
            case 4:
              y = no.four;
              break;
            case 5:
              y = no.five;
              break;
            case 6:
              y = no.six;
              break;
            case 7:
              y = no.seven;
              break;
            case 8:
              y = no.eight;
              break;
            case 9:
              y = no.nine;
              break;
            case 10:
              y = no.ten;
              break;
            case 11:
              y = no.eleven;
              break;
            case 12:
              y = no.twelve;
              break;
            default:
              y = ""
          }
          switch (a) {
            case 1:
              x = ni.one;
              break;
            case 2:
              x = ni.two;
              break;
            case 3:
              x = ni.three;
              break;
            case 4:
              x = ni.four;
              break;
            case 5:
              x = ni.five;
              break;
            case 6:
              x = ni.six;
              break;
            case 7:
              x = ni.seven;
              break;
            case 8:
              x = ni.eight;
              break;
            case 9:
              x = ni.nine;
              break;
            case 10:
              x = ni.ten;
              break;
            case 11:
              x = ni.eleven;
              break;
            case 12:
              x = ni.twelve
          }
          switch (o) {
            case 1:
              b = ns.one;
              break;
            case 2:
              b = ns.two;
              break;
            case 3:
              b = ns.three;
              break;
            case 4:
              b = ns.four;
              break;
            case 5:
              b = ns.five;
              break;
            case 6:
              b = ns.six;
              break;
            case 7:
              b = ns.seven;
              break;
            case 8:
              b = ns.eight;
              break;
            case 9:
              b = ns.nine;
              break;
            case 10:
              b = ns.ten;
              break;
            case 11:
              b = ns.eleven;
              break;
            case 12:
              b = ns.twelve
          }
          switch (l) {
            case 1:
              C = na.one;
              break;
            case 2:
              C = na.two;
              break;
            case 3:
              C = na.three;
              break;
            case 4:
              C = na.four;
              break;
            case 5:
              C = na.five;
              break;
            case 6:
              C = na.six;
              break;
            case 7:
              C = na.seven;
              break;
            case 8:
              C = na.eight;
              break;
            case 9:
              C = na.nine;
              break;
            case 10:
              C = na.ten;
              break;
            case 11:
              C = na.eleven;
              break;
            case 12:
              C = na.twelve
          }
          switch (c) {
            case 1:
              w = t8.one;
              break;
            case 2:
              w = t8.two;
              break;
            case 3:
              w = t8.three;
              break;
            case 4:
              w = t8.four;
              break;
            case 5:
              w = t8.five;
              break;
            case 6:
              w = t8.six;
              break;
            case 7:
              w = t8.seven;
              break;
            case 8:
              w = t8.eight;
              break;
            case 9:
              w = t8.nine;
              break;
            case 10:
              w = t8.ten;
              break;
            case 11:
              w = t8.eleven;
              break;
            case 12:
              w = t8.twelve
          }
          switch (u) {
            case 1:
              j = ne.one;
              break;
            case 2:
              j = ne.two;
              break;
            case 3:
              j = ne.three;
              break;
            case 4:
              j = ne.four;
              break;
            case 5:
              j = ne.five;
              break;
            case 6:
              j = ne.six;
              break;
            case 7:
              j = ne.seven;
              break;
            case 8:
              j = ne.eight;
              break;
            case 9:
              j = ne.nine;
              break;
            case 10:
              j = ne.ten;
              break;
            case 11:
              j = ne.eleven;
              break;
            case 12:
              j = ne.twelve
          }
          switch (d) {
            case 1:
              _ = nt.one;
              break;
            case 2:
              _ = nt.two;
              break;
            case 3:
              _ = nt.three;
              break;
            case 4:
              _ = nt.four;
              break;
            case 5:
              _ = nt.five;
              break;
            case 6:
              _ = nt.six;
              break;
            case 7:
              _ = nt.seven;
              break;
            case 8:
              _ = nt.eight;
              break;
            case 9:
              _ = nt.nine;
              break;
            case 10:
              _ = nt.ten;
              break;
            case 11:
              _ = nt.eleven;
              break;
            case 12:
              _ = nt.twelve
          }
          return m.jsx("div", {
            className: F("_1l2267a4", g, v, y, x, b, C, w, j, _, h ? "_1l2267a1" : "", p ? "_1l2267a2" : "", f),
            children: t
          })
        },
        nu = e => {
          let {
            isOpen: t,
            onOpenChange: n,
            placeholder: i
          } = e, [s, a] = (0, o.useState)(""), l = t ? "isActive" : "", c = tN()[0] < Number(tD.replace("px", ""));
          return m.jsxs(tm, {
            open: t,
            modal: c,
            onOpenChange: n,
            children: [m.jsx(tx, {}), m.jsx(tw, {
              className: F("_1topwo74"),
              children: m.jsx(nl, {
                isOverlay: !0,
                children: m.jsx(nc, {
                  startL: 3,
                  endL: 11,
                  children: m.jsxs("div", {
                    className: F("_1topwo75", t0.three, l),
                    children: [m.jsx(t2, {
                      onChange: e => a(e),
                      placeholder: i ?? "",
                      value: s,
                      isParentOpen: t
                    }), s.length > 0 ? m.jsx(t9, {
                      categories: [{
                        name: "Products",
                        suggestions: [{
                          name: "Thermo<strong>mix TM6</strong>",
                          onClick: () => {}
                        }, {
                          name: "<strong>Cookbook “Fit with</strong> Thermo<strong>mix\xae”</strong>",
                          onClick: () => {}
                        }]
                      }, {
                        name: "Articles",
                        suggestions: [{
                          name: "<strong>Tips and tricks for</strong> Thermo<strong>mix\xae</strong>",
                          onClick: () => {}
                        }, {
                          name: "<strong>How Star chefs use</strong> Thermo<strong>mix\xae</strong>",
                          onClick: () => {}
                        }]
                      }]
                    }) : m.jsx(t6, {
                      label: "Searched most often",
                      tags: ["Thermomix TM6", "Kobold VK7", "Robot", "Hotline", "Accessories"]
                    })]
                  })
                })
              })
            })]
          })
        },
        nd = e => {
          let {
            logo: t,
            landingPageLogo: n,
            advisor: i,
            cart: s,
            backgroundType: a = "transparent",
            stickyMode: l = "sticky",
            isLandingPage: c = !1,
            navigation: u,
            mobileAccountButton: d
          } = e, [h, p] = (0, o.useState)(!1), [f, g] = (0, o.useState)(!1), [v, y] = (0, o.useState)(!0), [x, b] = (0, o.useState)(!1), C = tN()[0] < Number(tD.replace("px", "")), [w, j] = (0, o.useState)(!1);
          (0, o.useEffect)(() => {
            {
              let e = window.scrollY,
                t = B(() => {
                  let t = window.scrollY;
                  t > e ? (p(!0), g(!1), y(!1)) : 0 === t ? (p(!1), g(!1), y(!0)) : (p(!1), g(!0), y(!1)), e = t
                }, 0);
              return window.addEventListener("scroll", t), () => {
                window.removeEventListener("scroll", t)
              }
            }
          }, []);
          let _ = h ? "_1qyxb2g2" : "",
            k = f ? "_1qyxb2g4" : "",
            S = W[a] || "";
          return c && (S = W.transparent, l = "normal"), "sticky" === l && (_ || k) && (S = W.solidWhite), "semiSticky" === l && f && !v && (S = W.solidWhite), m.jsxs(m.Fragment, {
            children: [m.jsx("header", {
              className: F($[l], _, k, S, c ? "_1qyxb2g3" : "", v ? "_1qyxb2g5" : ""),
              children: c ? m.jsx(nl, {
                children: m.jsx(nc, {
                  columns: 12,
                  children: m.jsx("div", {
                    className: F(U, z),
                    children: m.jsx("div", {
                      className: "_1qyxb2g0",
                      children: n
                    })
                  })
                })
              }) : m.jsxs(m.Fragment, {
                children: [m.jsx(nl, {
                  children: m.jsx(nc, {
                    columns: 12,
                    children: m.jsxs("div", {
                      className: F(U, z),
                      children: [m.jsxs("div", {
                        className: Z,
                        children: [C && m.jsx(q, {
                          label: "Menu",
                          children: x ? m.jsx(tZ, {}) : m.jsx(X, {}),
                          disabled: x,
                          onClick: () => {
                            b(!x)
                          }
                        }), i]
                      }), m.jsx("div", {
                        children: t
                      }), m.jsxs("div", {
                        className: Z,
                        children: [m.jsx(q, {
                          label: "Search",
                          children: w ? m.jsx(tZ, {}) : m.jsx(tU, {}),
                          onClick: () => {
                            j(!w)
                          }
                        }), s]
                      })]
                    })
                  })
                }), m.jsx(nl, {
                  children: m.jsx(nc, {
                    columns: 12,
                    children: m.jsx(t$, {
                      isMenuOpen: x,
                      onOpenChange: e => b(e),
                      mobileAccountButton: d,
                      children: u
                    })
                  })
                }), m.jsx(nu, {
                  isOpen: w,
                  onOpenChange: e => {
                    j(e)
                  },
                  placeholder: "Search"
                })]
              })
            }), m.jsx("div", {
              className: F("_1qyxb2gh")
            })]
          })
        };
      var nh = {
          left: "_7kok976",
          center: "_7kok977",
          right: "_7kok978"
        },
        np = {
          horizontal: "_7kok971 _7kok970",
          vertical: "_7kok972 _7kok970"
        },
        nm = {
          fill: "_7kok973",
          "50%": "_7kok974",
          hug: "_7kok975"
        };
      let nf = e => {
        let {
          children: t,
          layout: n = "horizontal",
          sizing: i = "hug",
          alignment: s = "left"
        } = e, a = np[n], o = i ? nm[i] : "", l = nh[s];
        return m.jsx("div", {
          className: F(a, o, l),
          children: t
        })
      };

      function ng(e) {
        return null !== e && "object" == typeof e && "function" == typeof e.start
      }
      let nv = e => Array.isArray(e);

      function ny(e, t) {
        if (!Array.isArray(t)) return !1;
        let n = t.length;
        if (n !== e.length) return !1;
        for (let i = 0; i < n; i++)
          if (t[i] !== e[i]) return !1;
        return !0
      }

      function nx(e) {
        return "string" == typeof e || Array.isArray(e)
      }

      function nb(e) {
        let t = [{}, {}];
        return null == e || e.values.forEach((e, n) => {
          t[0][n] = e.get(), t[1][n] = e.getVelocity()
        }), t
      }

      function nC(e, t, n, i) {
        if ("function" == typeof t) {
          let [s, a] = nb(i);
          t = t(void 0 !== n ? n : e.custom, s, a)
        }
        if ("string" == typeof t && (t = e.variants && e.variants[t]), "function" == typeof t) {
          let [s, a] = nb(i);
          t = t(void 0 !== n ? n : e.custom, s, a)
        }
        return t
      }

      function nw(e, t, n) {
        let i = e.getProps();
        return nC(i, t, void 0 !== n ? n : i.custom, e)
      }
      let nj = ["animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"],
        n_ = ["initial", ...nj],
        nk = ["transformPerspective", "x", "y", "z", "translateX", "translateY", "translateZ", "scale", "scaleX", "scaleY", "rotate", "rotateX", "rotateY", "rotateZ", "skew", "skewX", "skewY"],
        nS = new Set(nk),
        nE = e => 1e3 * e,
        nP = e => e / 1e3,
        nM = {
          type: "spring",
          stiffness: 500,
          damping: 25,
          restSpeed: 10
        },
        nT = e => ({
          type: "spring",
          stiffness: 550,
          damping: 0 === e ? 2 * Math.sqrt(550) : 30,
          restSpeed: 10
        }),
        nL = {
          type: "keyframes",
          duration: .8
        },
        nA = {
          type: "keyframes",
          ease: [.25, .1, .35, 1],
          duration: .3
        },
        nV = (e, t) => {
          let {
            keyframes: n
          } = t;
          return n.length > 2 ? nL : nS.has(e) ? e.startsWith("scale") ? nT(n[1]) : nM : nA
        };

      function nR(e, t) {
        return e ? e[t] || e.default || e : void 0
      }
      let nN = {
          useManualTiming: !1
        },
        nD = e => null !== e;

      function nO(e, t, n) {
        let {
          repeat: i,
          repeatType: s = "loop"
        } = t, a = e.filter(nD), o = i && "loop" !== s && i % 2 == 1 ? 0 : a.length - 1;
        return o && void 0 !== n ? n : a[o]
      }
      let nH = e => e,
        nI = ["read", "resolveKeyframes", "update", "preRender", "render", "postRender"];

      function nB(e, t) {
        let n = !1,
          i = !0,
          s = {
            delta: 0,
            timestamp: 0,
            isProcessing: !1
          },
          a = () => n = !0,
          o = nI.reduce((e, t) => (e[t] = function(e) {
            let t = new Set,
              n = new Set,
              i = !1,
              s = !1,
              a = new WeakSet,
              o = {
                delta: 0,
                timestamp: 0,
                isProcessing: !1
              };

            function l(t) {
              a.has(t) && (c.schedule(t), e()), t(o)
            }
            let c = {
              schedule: function(e) {
                let s = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                  o = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                  l = o && i ? t : n;
                return s && a.add(e), l.has(e) || l.add(e), e
              },
              cancel: e => {
                n.delete(e), a.delete(e)
              },
              process: e => {
                if (o = e, i) {
                  s = !0;
                  return
                }
                i = !0, [t, n] = [n, t], n.clear(), t.forEach(l), i = !1, s && (s = !1, c.process(e))
              }
            };
            return c
          }(a), e), {}),
          {
            read: l,
            resolveKeyframes: c,
            update: u,
            preRender: d,
            render: h,
            postRender: p
          } = o,
          m = () => {
            let a = performance.now();
            n = !1, s.delta = i ? 1e3 / 60 : Math.max(Math.min(a - s.timestamp, 40), 1), s.timestamp = a, s.isProcessing = !0, l.process(s), c.process(s), u.process(s), d.process(s), h.process(s), p.process(s), s.isProcessing = !1, n && t && (i = !1, e(m))
          },
          f = () => {
            n = !0, i = !0, s.isProcessing || e(m)
          };
        return {
          schedule: nI.reduce((e, t) => {
            let i = o[t];
            return e[t] = function(e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                s = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
              return n || f(), i.schedule(e, t, s)
            }, e
          }, {}),
          cancel: e => {
            for (let t = 0; t < nI.length; t++) o[nI[t]].cancel(e)
          },
          state: s,
          steps: o
        }
      }
      let {
        schedule: nF,
        cancel: nW,
        state: nz,
        steps: n$
      } = nB("u" > typeof requestAnimationFrame ? requestAnimationFrame : nH, !0), nZ = (e, t, n) => (((1 - 3 * n + 3 * t) * e + (3 * n - 6 * t)) * e + 3 * t) * e;

      function nU(e, t, n, i) {
        if (e === t && n === i) return nH;
        let s = t => (function(e, t, n, i, s) {
          let a, o, l = 0;
          do(a = nZ(o = t + (n - t) / 2, i, s) - e) > 0 ? n = o : t = o; while (Math.abs(a) > 1e-7 && ++l < 12);
          return o
        })(t, 0, 1, e, n);
        return e => 0 === e || 1 === e ? e : nZ(s(e), t, i)
      }
      let nq = e => t => t <= .5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2,
        nX = e => t => 1 - e(1 - t),
        nY = nU(.33, 1.53, .69, .99),
        nK = nX(nY),
        nG = nq(nK),
        nQ = e => (e *= 2) < 1 ? .5 * nK(e) : .5 * (2 - Math.pow(2, -10 * (e - 1))),
        nJ = e => 1 - Math.sin(Math.acos(e)),
        n1 = nX(nJ),
        n0 = nq(nJ),
        n2 = e => /^0[^.\s]+$/u.test(e),
        n5 = e => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e),
        n3 = e => t => "string" == typeof t && t.startsWith(e),
        n4 = n3("--"),
        n6 = n3("var(--"),
        n7 = e => !!n6(e) && n9.test(e.split("/*")[0].trim()),
        n9 = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
        n8 = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u,
        re = (e, t, n) => n > t ? t : n < e ? e : n,
        rt = {
          test: e => "number" == typeof e,
          parse: parseFloat,
          transform: e => e
        },
        rn = {
          ...rt,
          transform: e => re(0, 1, e)
        },
        rr = {
          ...rt,
          default: 1
        },
        ri = e => ({
          test: t => "string" == typeof t && t.endsWith(e) && 1 === t.split(" ").length,
          parse: parseFloat,
          transform: t => `${t}${e}`
        }),
        rs = ri("deg"),
        ra = ri("%"),
        ro = ri("px"),
        rl = ri("vh"),
        rc = ri("vw"),
        ru = {
          ...ra,
          parse: e => ra.parse(e) / 100,
          transform: e => ra.transform(100 * e)
        },
        rd = new Set(["width", "height", "top", "left", "right", "bottom", "x", "y", "translateX", "translateY"]),
        rh = e => e === rt || e === ro,
        rp = (e, t) => parseFloat(e.split(", ")[t]),
        rm = (e, t) => (n, i) => {
          let {
            transform: s
          } = i;
          if ("none" === s || !s) return 0;
          let a = s.match(/^matrix3d\((.+)\)$/u);
          if (a) return rp(a[1], t);
          {
            let t = s.match(/^matrix\((.+)\)$/u);
            return t ? rp(t[1], e) : 0
          }
        },
        rf = new Set(["x", "y", "z"]),
        rg = nk.filter(e => !rf.has(e)),
        rv = {
          width: (e, t) => {
            let {
              x: n
            } = e, {
              paddingLeft: i = "0",
              paddingRight: s = "0"
            } = t;
            return n.max - n.min - parseFloat(i) - parseFloat(s)
          },
          height: (e, t) => {
            let {
              y: n
            } = e, {
              paddingTop: i = "0",
              paddingBottom: s = "0"
            } = t;
            return n.max - n.min - parseFloat(i) - parseFloat(s)
          },
          top: (e, t) => {
            let {
              top: n
            } = t;
            return parseFloat(n)
          },
          left: (e, t) => {
            let {
              left: n
            } = t;
            return parseFloat(n)
          },
          bottom: (e, t) => {
            let {
              y: n
            } = e, {
              top: i
            } = t;
            return parseFloat(i) + (n.max - n.min)
          },
          right: (e, t) => {
            let {
              x: n
            } = e, {
              left: i
            } = t;
            return parseFloat(i) + (n.max - n.min)
          },
          x: rm(4, 13),
          y: rm(5, 14)
        };
      rv.translateX = rv.x, rv.translateY = rv.y;
      let ry = e => t => t.test(e),
        rx = [rt, ro, ra, rs, rc, rl, {
          test: e => "auto" === e,
          parse: e => e
        }],
        rb = e => rx.find(ry(e)),
        rC = new Set,
        rw = !1,
        rj = !1;

      function r_() {
        if (rj) {
          let e = Array.from(rC).filter(e => e.needsMeasurement),
            t = new Set(e.map(e => e.element)),
            n = new Map;
          t.forEach(e => {
            let t = function(e) {
              let t = [];
              return rg.forEach(n => {
                let i = e.getValue(n);
                void 0 !== i && (t.push([n, i.get()]), i.set(n.startsWith("scale") ? 1 : 0))
              }), t
            }(e);
            t.length && (n.set(e, t), e.render())
          }), e.forEach(e => e.measureInitialState()), t.forEach(e => {
            e.render();
            let t = n.get(e);
            t && t.forEach(t => {
              var n;
              let [i, s] = t;
              null === (n = e.getValue(i)) || void 0 === n || n.set(s)
            })
          }), e.forEach(e => e.measureEndState()), e.forEach(e => {
            void 0 !== e.suspendedScrollY && window.scrollTo(0, e.suspendedScrollY)
          })
        }
        rj = !1, rw = !1, rC.forEach(e => e.complete()), rC.clear()
      }

      function rk() {
        rC.forEach(e => {
          e.readKeyframes(), e.needsMeasurement && (rj = !0)
        })
      }
      class rS {
        constructor(e, t, n, i, s, a = !1) {
          this.isComplete = !1, this.isAsync = !1, this.needsMeasurement = !1, this.isScheduled = !1, this.unresolvedKeyframes = [...e], this.onComplete = t, this.name = n, this.motionValue = i, this.element = s, this.isAsync = a
        }
        scheduleResolve() {
          this.isScheduled = !0, this.isAsync ? (rC.add(this), rw || (rw = !0, nF.read(rk), nF.resolveKeyframes(r_))) : (this.readKeyframes(), this.complete())
        }
        readKeyframes() {
          let {
            unresolvedKeyframes: e,
            name: t,
            element: n,
            motionValue: i
          } = this;
          for (let s = 0; s < e.length; s++)
            if (null === e[s]) {
              if (0 === s) {
                let s = null == i ? void 0 : i.get(),
                  a = e[e.length - 1];
                if (void 0 !== s) e[0] = s;
                else if (n && t) {
                  let i = n.readValue(t, a);
                  null != i && (e[0] = i)
                }
                void 0 === e[0] && (e[0] = a), i && void 0 === s && i.set(e[0])
              } else e[s] = e[s - 1]
            }
        }
        setFinalKeyframe() {}
        measureInitialState() {}
        renderEndStyles() {}
        measureEndState() {}
        complete() {
          this.isComplete = !0, this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), rC.delete(this)
        }
        cancel() {
          this.isComplete || (this.isScheduled = !1, rC.delete(this))
        }
        resume() {
          this.isComplete || this.scheduleResolve()
        }
      }
      let rE = e => Math.round(1e5 * e) / 1e5,
        rP = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu,
        rM = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
        rT = (e, t) => n => !!("string" == typeof n && rM.test(n) && n.startsWith(e) || t && null != n && Object.prototype.hasOwnProperty.call(n, t)),
        rL = (e, t, n) => i => {
          if ("string" != typeof i) return i;
          let [s, a, o, l] = i.match(rP);
          return {
            [e]: parseFloat(s),
            [t]: parseFloat(a),
            [n]: parseFloat(o),
            alpha: void 0 !== l ? parseFloat(l) : 1
          }
        },
        rA = e => re(0, 255, e),
        rV = {
          ...rt,
          transform: e => Math.round(rA(e))
        },
        rR = {
          test: rT("rgb", "red"),
          parse: rL("red", "green", "blue"),
          transform: e => {
            let {
              red: t,
              green: n,
              blue: i,
              alpha: s = 1
            } = e;
            return "rgba(" + rV.transform(t) + ", " + rV.transform(n) + ", " + rV.transform(i) + ", " + rE(rn.transform(s)) + ")"
          }
        },
        rN = {
          test: rT("#"),
          parse: function(e) {
            let t = "",
              n = "",
              i = "",
              s = "";
            return e.length > 5 ? (t = e.substring(1, 3), n = e.substring(3, 5), i = e.substring(5, 7), s = e.substring(7, 9)) : (t = e.substring(1, 2), n = e.substring(2, 3), i = e.substring(3, 4), s = e.substring(4, 5), t += t, n += n, i += i, s += s), {
              red: parseInt(t, 16),
              green: parseInt(n, 16),
              blue: parseInt(i, 16),
              alpha: s ? parseInt(s, 16) / 255 : 1
            }
          },
          transform: rR.transform
        },
        rD = {
          test: rT("hsl", "hue"),
          parse: rL("hue", "saturation", "lightness"),
          transform: e => {
            let {
              hue: t,
              saturation: n,
              lightness: i,
              alpha: s = 1
            } = e;
            return "hsla(" + Math.round(t) + ", " + ra.transform(rE(n)) + ", " + ra.transform(rE(i)) + ", " + rE(rn.transform(s)) + ")"
          }
        },
        rO = {
          test: e => rR.test(e) || rN.test(e) || rD.test(e),
          parse: e => rR.test(e) ? rR.parse(e) : rD.test(e) ? rD.parse(e) : rN.parse(e),
          transform: e => "string" == typeof e ? e : e.hasOwnProperty("red") ? rR.transform(e) : rD.transform(e)
        },
        rH = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu,
        rI = "number",
        rB = "color",
        rF = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;

      function rW(e) {
        let t = e.toString(),
          n = [],
          i = {
            color: [],
            number: [],
            var: []
          },
          s = [],
          a = 0,
          o = t.replace(rF, e => (rO.test(e) ? (i.color.push(a), s.push(rB), n.push(rO.parse(e))) : e.startsWith("var(") ? (i.var.push(a), s.push("var"), n.push(e)) : (i.number.push(a), s.push(rI), n.push(parseFloat(e))), ++a, "${}")).split("${}");
        return {
          values: n,
          split: o,
          indexes: i,
          types: s
        }
      }

      function rz(e) {
        return rW(e).values
      }

      function r$(e) {
        let {
          split: t,
          types: n
        } = rW(e), i = t.length;
        return e => {
          let s = "";
          for (let a = 0; a < i; a++)
            if (s += t[a], void 0 !== e[a]) {
              let t = n[a];
              t === rI ? s += rE(e[a]) : t === rB ? s += rO.transform(e[a]) : s += e[a]
            } return s
        }
      }
      let rZ = e => "number" == typeof e ? 0 : e,
        rU = {
          test: function(e) {
            var t, n;
            return isNaN(e) && "string" == typeof e && ((null === (t = e.match(rP)) || void 0 === t ? void 0 : t.length) || 0) + ((null === (n = e.match(rH)) || void 0 === n ? void 0 : n.length) || 0) > 0
          },
          parse: rz,
          createTransformer: r$,
          getAnimatableNone: function(e) {
            let t = rz(e);
            return r$(e)(t.map(rZ))
          }
        },
        rq = new Set(["brightness", "contrast", "saturate", "opacity"]);

      function rX(e) {
        let [t, n] = e.slice(0, -1).split("(");
        if ("drop-shadow" === t) return e;
        let [i] = n.match(rP) || [];
        if (!i) return e;
        let s = n.replace(i, ""),
          a = rq.has(t) ? 1 : 0;
        return i !== n && (a *= 100), t + "(" + a + s + ")"
      }
      let rY = /\b([a-z-]*)\(.*?\)/gu,
        rK = {
          ...rU,
          getAnimatableNone: e => {
            let t = e.match(rY);
            return t ? t.map(rX).join(" ") : e
          }
        },
        rG = {
          ...rt,
          transform: Math.round
        },
        rQ = {
          borderWidth: ro,
          borderTopWidth: ro,
          borderRightWidth: ro,
          borderBottomWidth: ro,
          borderLeftWidth: ro,
          borderRadius: ro,
          radius: ro,
          borderTopLeftRadius: ro,
          borderTopRightRadius: ro,
          borderBottomRightRadius: ro,
          borderBottomLeftRadius: ro,
          width: ro,
          maxWidth: ro,
          height: ro,
          maxHeight: ro,
          top: ro,
          right: ro,
          bottom: ro,
          left: ro,
          padding: ro,
          paddingTop: ro,
          paddingRight: ro,
          paddingBottom: ro,
          paddingLeft: ro,
          margin: ro,
          marginTop: ro,
          marginRight: ro,
          marginBottom: ro,
          marginLeft: ro,
          backgroundPositionX: ro,
          backgroundPositionY: ro,
          rotate: rs,
          rotateX: rs,
          rotateY: rs,
          rotateZ: rs,
          scale: rr,
          scaleX: rr,
          scaleY: rr,
          scaleZ: rr,
          skew: rs,
          skewX: rs,
          skewY: rs,
          distance: ro,
          translateX: ro,
          translateY: ro,
          translateZ: ro,
          x: ro,
          y: ro,
          z: ro,
          perspective: ro,
          transformPerspective: ro,
          opacity: rn,
          originX: ru,
          originY: ru,
          originZ: ro,
          zIndex: rG,
          size: ro,
          fillOpacity: rn,
          strokeOpacity: rn,
          numOctaves: rG
        },
        rJ = {
          ...rQ,
          color: rO,
          backgroundColor: rO,
          outlineColor: rO,
          fill: rO,
          stroke: rO,
          borderColor: rO,
          borderTopColor: rO,
          borderRightColor: rO,
          borderBottomColor: rO,
          borderLeftColor: rO,
          filter: rK,
          WebkitFilter: rK
        },
        r1 = e => rJ[e];

      function r0(e, t) {
        let n = r1(e);
        return n !== rK && (n = rU), n.getAnimatableNone ? n.getAnimatableNone(t) : void 0
      }
      let r2 = new Set(["auto", "none", "0"]);
      class r5 extends rS {
        constructor(e, t, n, i, s) {
          super(e, t, n, i, s, !0)
        }
        readKeyframes() {
          let {
            unresolvedKeyframes: e,
            element: t,
            name: n
          } = this;
          if (!t || !t.current) return;
          super.readKeyframes();
          for (let n = 0; n < e.length; n++) {
            let i = e[n];
            if ("string" == typeof i && n7(i = i.trim())) {
              let s = function e(t, n) {
                let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                nH(i <= 4, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`);
                let [s, a] = function(e) {
                  let t = n8.exec(e);
                  if (!t) return [, ];
                  let [, n, i, s] = t;
                  return [`--${n??i}`, s]
                }(t);
                if (!s) return;
                let o = window.getComputedStyle(n).getPropertyValue(s);
                if (o) {
                  let e = o.trim();
                  return n5(e) ? parseFloat(e) : e
                }
                return n7(a) ? e(a, n, i + 1) : a
              }(i, t.current);
              void 0 !== s && (e[n] = s), n === e.length - 1 && (this.finalKeyframe = i)
            }
          }
          if (this.resolveNoneKeyframes(), !rd.has(n) || 2 !== e.length) return;
          let [i, s] = e, a = rb(i), o = rb(s);
          if (a !== o) {
            if (rh(a) && rh(o))
              for (let t = 0; t < e.length; t++) {
                let n = e[t];
                "string" == typeof n && (e[t] = parseFloat(n))
              } else this.needsMeasurement = !0
          }
        }
        resolveNoneKeyframes() {
          let {
            unresolvedKeyframes: e,
            name: t
          } = this, n = [];
          for (let t = 0; t < e.length; t++) {
            var i;
            ("number" == typeof(i = e[t]) ? 0 === i : null === i || "none" === i || "0" === i || n2(i)) && n.push(t)
          }
          n.length && function(e, t, n) {
            let i = 0,
              s;
            for (; i < e.length && !s;) {
              let t = e[i];
              "string" == typeof t && !r2.has(t) && rW(t).values.length && (s = e[i]), i++
            }
            if (s && n)
              for (let i of t) e[i] = r0(n, s)
          }(e, n, t)
        }
        measureInitialState() {
          let {
            element: e,
            unresolvedKeyframes: t,
            name: n
          } = this;
          if (!e || !e.current) return;
          "height" === n && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = rv[n](e.measureViewportBox(), window.getComputedStyle(e.current)), t[0] = this.measuredOrigin;
          let i = t[t.length - 1];
          void 0 !== i && e.getValue(n, i).jump(i, !1)
        }
        measureEndState() {
          var e;
          let {
            element: t,
            name: n,
            unresolvedKeyframes: i
          } = this;
          if (!t || !t.current) return;
          let s = t.getValue(n);
          s && s.jump(this.measuredOrigin, !1);
          let a = i.length - 1,
            o = i[a];
          i[a] = rv[n](t.measureViewportBox(), window.getComputedStyle(t.current)), null !== o && void 0 === this.finalKeyframe && (this.finalKeyframe = o), !(null === (e = this.removedTransforms) || void 0 === e) && e.length && this.removedTransforms.forEach(e => {
            let [n, i] = e;
            t.getValue(n).set(i)
          }), this.resolveNoneKeyframes()
        }
      }

      function r3(e) {
        return "function" == typeof e
      }

      function r4() {
        i = void 0
      }
      let r6 = {
          now: () => (void 0 === i && r6.set(nz.isProcessing || nN.useManualTiming ? nz.timestamp : performance.now()), i),
          set: e => {
            i = e, queueMicrotask(r4)
          }
        },
        r7 = (e, t) => "zIndex" !== t && !!("number" == typeof e || Array.isArray(e) || "string" == typeof e && (rU.test(e) || "0" === e) && !e.startsWith("url("));
      class r9 {
        constructor({
          autoplay: e = !0,
          delay: t = 0,
          type: n = "keyframes",
          repeat: i = 0,
          repeatDelay: s = 0,
          repeatType: a = "loop",
          ...o
        }) {
          this.isStopped = !1, this.hasAttemptedResolve = !1, this.createdAt = r6.now(), this.options = {
            autoplay: e,
            delay: t,
            type: n,
            repeat: i,
            repeatDelay: s,
            repeatType: a,
            ...o
          }, this.updateFinishedPromise()
        }
        calcStartTime() {
          return this.resolvedAt && this.resolvedAt - this.createdAt > 40 ? this.resolvedAt : this.createdAt
        }
        get resolved() {
          return this._resolved || this.hasAttemptedResolve || (rk(), r_()), this._resolved
        }
        onKeyframesResolved(e, t) {
          this.resolvedAt = r6.now(), this.hasAttemptedResolve = !0;
          let {
            name: n,
            type: i,
            velocity: s,
            delay: a,
            onComplete: o,
            onUpdate: l,
            isGenerator: c
          } = this.options;
          if (!c && ! function(e, t, n, i) {
              let s = e[0];
              if (null === s) return !1;
              if ("display" === t || "visibility" === t) return !0;
              let a = e[e.length - 1],
                o = r7(s, t),
                l = r7(a, t);
              return nH(o === l, `You are trying to animate ${t} from "${s}" to "${a}". ${s} is not an animatable value - to enable this animation set ${s} to a value animatable to ${a} via the \`style\` property.`), !!o && !!l && (function(e) {
                let t = e[0];
                if (1 === e.length) return !0;
                for (let n = 0; n < e.length; n++)
                  if (e[n] !== t) return !0
              }(e) || ("spring" === n || r3(n)) && i)
            }(e, n, i, s)) {
            if (a) this.options.duration = 0;
            else {
              null == l || l(nO(e, this.options, t)), null == o || o(), this.resolveFinishedPromise();
              return
            }
          }
          let u = this.initPlayback(e, t);
          !1 !== u && (this._resolved = {
            keyframes: e,
            finalKeyframe: t,
            ...u
          }, this.onPostResolved())
        }
        onPostResolved() {}
        then(e, t) {
          return this.currentFinishedPromise.then(e, t)
        }
        flatten() {
          this.options.type = "keyframes", this.options.ease = "linear"
        }
        updateFinishedPromise() {
          this.currentFinishedPromise = new Promise(e => {
            this.resolveFinishedPromise = e
          })
        }
      }

      function r8(e, t, n) {
        var i, s;
        let a = Math.max(t - 5, 0);
        return i = n - e(a), (s = t - a) ? 1e3 / s * i : 0
      }

      function ie(e, t) {
        return e * Math.sqrt(1 - t * t)
      }
      let it = ["duration", "bounce"],
        ir = ["stiffness", "damping", "mass"];

      function ii(e, t) {
        return t.some(t => void 0 !== e[t])
      }

      function is(e) {
        let t, {
            keyframes: n,
            restDelta: i,
            restSpeed: s,
            ...a
          } = e,
          o = n[0],
          l = n[n.length - 1],
          c = {
            done: !1,
            value: o
          },
          {
            stiffness: u,
            damping: d,
            mass: h,
            duration: p,
            velocity: m,
            isResolvedFromDuration: f
          } = function(e) {
            let t = {
              velocity: 0,
              stiffness: 100,
              damping: 10,
              mass: 1,
              isResolvedFromDuration: !1,
              ...e
            };
            if (!ii(e, ir) && ii(e, it)) {
              let n = function(e) {
                let t, n, {
                  duration: i = 800,
                  bounce: s = .25,
                  velocity: a = 0,
                  mass: o = 1
                } = e;
                nH(i <= nE(10), "Spring duration must be 10 seconds or less");
                let l = 1 - s;
                l = re(.05, 1, l), i = re(.01, 10, nP(i)), l < 1 ? (t = e => {
                  let t = e * l,
                    n = t * i;
                  return .001 - (t - a) / ie(e, l) * Math.exp(-n)
                }, n = e => {
                  let n = e * l * i,
                    s = Math.pow(l, 2) * Math.pow(e, 2) * i,
                    o = ie(Math.pow(e, 2), l);
                  return (-t(e) + .001 > 0 ? -1 : 1) * ((n * a + a - s) * Math.exp(-n)) / o
                }) : (t = e => -.001 + Math.exp(-e * i) * ((e - a) * i + 1), n = e => i * i * (a - e) * Math.exp(-e * i));
                let c = function(e, t, n) {
                  let i = n;
                  for (let n = 1; n < 12; n++) i -= e(i) / t(i);
                  return i
                }(t, n, 5 / i);
                if (i = nE(i), isNaN(c)) return {
                  stiffness: 100,
                  damping: 10,
                  duration: i
                };
                {
                  let e = Math.pow(c, 2) * o;
                  return {
                    stiffness: e,
                    damping: 2 * l * Math.sqrt(o * e),
                    duration: i
                  }
                }
              }(e);
              (t = {
                ...t,
                ...n,
                mass: 1
              }).isResolvedFromDuration = !0
            }
            return t
          }({
            ...a,
            velocity: -nP(a.velocity || 0)
          }),
          g = m || 0,
          v = d / (2 * Math.sqrt(u * h)),
          y = l - o,
          x = nP(Math.sqrt(u / h)),
          b = 5 > Math.abs(y);
        if (s || (s = b ? .01 : 2), i || (i = b ? .005 : .5), v < 1) {
          let e = ie(x, v);
          t = t => l - Math.exp(-v * x * t) * ((g + v * x * y) / e * Math.sin(e * t) + y * Math.cos(e * t))
        } else if (1 === v) t = e => l - Math.exp(-x * e) * (y + (g + x * y) * e);
        else {
          let e = x * Math.sqrt(v * v - 1);
          t = t => {
            let n = Math.exp(-v * x * t),
              i = Math.min(e * t, 300);
            return l - n * ((g + v * x * y) * Math.sinh(i) + e * y * Math.cosh(i)) / e
          }
        }
        return {
          calculatedDuration: f && p || null,
          next: e => {
            let n = t(e);
            if (f) c.done = e >= p;
            else {
              let a = 0;
              v < 1 && (a = 0 === e ? nE(g) : r8(t, e, n));
              let o = Math.abs(a) <= s,
                u = Math.abs(l - n) <= i;
              c.done = o && u
            }
            return c.value = c.done ? l : n, c
          }
        }
      }

      function ia(e) {
        let t, n, {
            keyframes: i,
            velocity: s = 0,
            power: a = .8,
            timeConstant: o = 325,
            bounceDamping: l = 10,
            bounceStiffness: c = 500,
            modifyTarget: u,
            min: d,
            max: h,
            restDelta: p = .5,
            restSpeed: m
          } = e,
          f = i[0],
          g = {
            done: !1,
            value: f
          },
          v = e => void 0 !== d && e < d || void 0 !== h && e > h,
          y = e => void 0 === d ? h : void 0 === h || Math.abs(d - e) < Math.abs(h - e) ? d : h,
          x = a * s,
          b = f + x,
          C = void 0 === u ? b : u(b);
        C !== b && (x = C - f);
        let w = e => -x * Math.exp(-e / o),
          j = e => C + w(e),
          _ = e => {
            let t = w(e),
              n = j(e);
            g.done = Math.abs(t) <= p, g.value = g.done ? C : n
          },
          k = e => {
            v(g.value) && (t = e, n = is({
              keyframes: [g.value, y(g.value)],
              velocity: r8(j, e, g.value),
              damping: l,
              stiffness: c,
              restDelta: p,
              restSpeed: m
            }))
          };
        return k(0), {
          calculatedDuration: null,
          next: e => {
            let i = !1;
            return n || void 0 !== t || (i = !0, _(e), k(e)), void 0 !== t && e >= t ? n.next(e - t) : (i || _(e), g)
          }
        }
      }
      let io = nU(.42, 0, 1, 1),
        il = nU(0, 0, .58, 1),
        ic = nU(.42, 0, .58, 1),
        iu = e => Array.isArray(e) && "number" != typeof e[0],
        id = e => Array.isArray(e) && "number" == typeof e[0],
        ih = {
          linear: nH,
          easeIn: io,
          easeInOut: ic,
          easeOut: il,
          circIn: nJ,
          circInOut: n0,
          circOut: n1,
          backIn: nK,
          backInOut: nG,
          backOut: nY,
          anticipate: nQ
        },
        ip = e => {
          if (id(e)) {
            nH(4 === e.length, "Cubic bezier arrays must contain four numerical values.");
            let [t, n, i, s] = e;
            return nU(t, n, i, s)
          }
          return "string" == typeof e ? (nH(void 0 !== ih[e], `Invalid easing type '${e}'`), ih[e]) : e
        },
        im = (e, t) => n => t(e(n)),
        ig = function() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return t.reduce(im)
        },
        iv = (e, t, n) => {
          let i = t - e;
          return 0 === i ? 1 : (n - e) / i
        },
        iy = (e, t, n) => e + (t - e) * n;

      function ix(e, t, n) {
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e
      }

      function ib(e, t) {
        return n => n > 0 ? t : e
      }
      let iC = (e, t, n) => {
          let i = e * e,
            s = n * (t * t - i) + i;
          return s < 0 ? 0 : Math.sqrt(s)
        },
        iw = [rN, rR, rD],
        ij = e => iw.find(t => t.test(e));

      function i_(e) {
        let t = ij(e);
        if (nH(!!t, `'${e}' is not an animatable color. Use the equivalent color code instead.`), !t) return !1;
        let n = t.parse(e);
        return t === rD && (n = function(e) {
          let {
            hue: t,
            saturation: n,
            lightness: i,
            alpha: s
          } = e;
          t /= 360, n /= 100, i /= 100;
          let a = 0,
            o = 0,
            l = 0;
          if (n) {
            let e = i < .5 ? i * (1 + n) : i + n - i * n,
              s = 2 * i - e;
            a = ix(s, e, t + 1 / 3), o = ix(s, e, t), l = ix(s, e, t - 1 / 3)
          } else a = o = l = i;
          return {
            red: Math.round(255 * a),
            green: Math.round(255 * o),
            blue: Math.round(255 * l),
            alpha: s
          }
        }(n)), n
      }
      let ik = (e, t) => {
          let n = i_(e),
            i = i_(t);
          if (!n || !i) return ib(e, t);
          let s = {
            ...n
          };
          return e => (s.red = iC(n.red, i.red, e), s.green = iC(n.green, i.green, e), s.blue = iC(n.blue, i.blue, e), s.alpha = iy(n.alpha, i.alpha, e), rR.transform(s))
        },
        iS = new Set(["none", "hidden"]);

      function iE(e, t) {
        return n => iy(e, t, n)
      }

      function iP(e) {
        return "number" == typeof e ? iE : "string" == typeof e ? n7(e) ? ib : rO.test(e) ? ik : iL : Array.isArray(e) ? iM : "object" == typeof e ? rO.test(e) ? ik : iT : ib
      }

      function iM(e, t) {
        let n = [...e],
          i = n.length,
          s = e.map((e, n) => iP(e)(e, t[n]));
        return e => {
          for (let t = 0; t < i; t++) n[t] = s[t](e);
          return n
        }
      }

      function iT(e, t) {
        let n = {
            ...e,
            ...t
          },
          i = {};
        for (let s in n) void 0 !== e[s] && void 0 !== t[s] && (i[s] = iP(e[s])(e[s], t[s]));
        return e => {
          for (let t in i) n[t] = i[t](e);
          return n
        }
      }
      let iL = (e, t) => {
        let n = rU.createTransformer(t),
          i = rW(e),
          s = rW(t);
        return i.indexes.var.length === s.indexes.var.length && i.indexes.color.length === s.indexes.color.length && i.indexes.number.length >= s.indexes.number.length ? iS.has(e) && !s.values.length || iS.has(t) && !i.values.length ? iS.has(e) ? n => n <= 0 ? e : t : n => n >= 1 ? t : e : ig(iM(function(e, t) {
          var n;
          let i = [],
            s = {
              color: 0,
              var: 0,
              number: 0
            };
          for (let a = 0; a < t.values.length; a++) {
            let o = t.types[a],
              l = e.indexes[o][s[o]],
              c = null !== (n = e.values[l]) && void 0 !== n ? n : 0;
            i[a] = c, s[o]++
          }
          return i
        }(i, s), s.values), n) : (nH(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), ib(e, t))
      };

      function iA(e, t, n) {
        return "number" == typeof e && "number" == typeof t && "number" == typeof n ? iy(e, t, n) : iP(e)(e, t)
      }

      function iV(e, t) {
        let {
          clamp: n = !0,
          ease: i,
          mixer: s
        } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, a = e.length;
        if (nH(a === t.length, "Both input and output ranges must be the same length"), 1 === a) return () => t[0];
        if (2 === a && e[0] === e[1]) return () => t[1];
        e[0] > e[a - 1] && (e = [...e].reverse(), t = [...t].reverse());
        let o = function(e, t, n) {
            let i = [],
              s = n || iA,
              a = e.length - 1;
            for (let n = 0; n < a; n++) {
              let a = s(e[n], e[n + 1]);
              t && (a = ig(Array.isArray(t) ? t[n] || nH : t, a)), i.push(a)
            }
            return i
          }(t, i, s),
          l = o.length,
          c = t => {
            let n = 0;
            if (l > 1)
              for (; n < e.length - 2 && !(t < e[n + 1]); n++);
            let i = iv(e[n], e[n + 1], t);
            return o[n](i)
          };
        return n ? t => c(re(e[0], e[a - 1], t)) : c
      }

      function iR(e, t) {
        let n = e[e.length - 1];
        for (let i = 1; i <= t; i++) {
          let s = iv(0, t, i);
          e.push(iy(n, 1, s))
        }
      }

      function iN(e) {
        let t = [0];
        return iR(t, e.length - 1), t
      }

      function iD(e) {
        let {
          duration: t = 300,
          keyframes: n,
          times: i,
          ease: s = "easeInOut"
        } = e, a = iu(s) ? s.map(ip) : ip(s), o = {
          done: !1,
          value: n[0]
        }, l = iV((i && i.length === n.length ? i : iN(n)).map(e => e * t), n, {
          ease: Array.isArray(a) ? a : n.map(() => a || ic).splice(0, n.length - 1)
        });
        return {
          calculatedDuration: t,
          next: e => (o.value = l(e), o.done = e >= t, o)
        }
      }

      function iO(e) {
        let t = 0,
          n = e.next(t);
        for (; !n.done && t < 2e4;) t += 50, n = e.next(t);
        return t >= 2e4 ? 1 / 0 : t
      }
      let iH = e => {
          let t = t => {
            let {
              timestamp: n
            } = t;
            return e(n)
          };
          return {
            start: () => nF.update(t, !0),
            stop: () => nW(t),
            now: () => nz.isProcessing ? nz.timestamp : r6.now()
          }
        },
        iI = {
          decay: ia,
          inertia: ia,
          tween: iD,
          keyframes: iD,
          spring: is
        },
        iB = e => e / 100;
      class iF extends r9 {
        constructor(e) {
          super(e), this.holdTime = null, this.cancelTime = null, this.currentTime = 0, this.playbackSpeed = 1, this.pendingPlayState = "running", this.startTime = null, this.state = "idle", this.stop = () => {
            if (this.resolver.cancel(), this.isStopped = !0, "idle" === this.state) return;
            this.teardown();
            let {
              onStop: e
            } = this.options;
            e && e()
          };
          let {
            name: t,
            motionValue: n,
            element: i,
            keyframes: s
          } = this.options, a = (null == i ? void 0 : i.KeyframeResolver) || rS;
          this.resolver = new a(s, (e, t) => this.onKeyframesResolved(e, t), t, n, i), this.resolver.scheduleResolve()
        }
        flatten() {
          super.flatten(), this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes))
        }
        initPlayback(e) {
          let t, n;
          let {
            type: i = "keyframes",
            repeat: s = 0,
            repeatDelay: a = 0,
            repeatType: o,
            velocity: l = 0
          } = this.options, c = r3(i) ? i : iI[i] || iD;
          c !== iD && "number" != typeof e[0] && (t = ig(iB, iA(e[0], e[1])), e = [0, 100]);
          let u = c({
            ...this.options,
            keyframes: e
          });
          "mirror" === o && (n = c({
            ...this.options,
            keyframes: [...e].reverse(),
            velocity: -l
          })), null === u.calculatedDuration && (u.calculatedDuration = iO(u));
          let {
            calculatedDuration: d
          } = u, h = d + a;
          return {
            generator: u,
            mirroredGenerator: n,
            mapPercentToKeyframes: t,
            calculatedDuration: d,
            resolvedDuration: h,
            totalDuration: h * (s + 1) - a
          }
        }
        onPostResolved() {
          let {
            autoplay: e = !0
          } = this.options;
          this.play(), "paused" !== this.pendingPlayState && e ? this.state = this.pendingPlayState : this.pause()
        }
        tick(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            {
              resolved: n
            } = this;
          if (!n) {
            let {
              keyframes: e
            } = this.options;
            return {
              done: !0,
              value: e[e.length - 1]
            }
          }
          let {
            finalKeyframe: i,
            generator: s,
            mirroredGenerator: a,
            mapPercentToKeyframes: o,
            keyframes: l,
            calculatedDuration: c,
            totalDuration: u,
            resolvedDuration: d
          } = n;
          if (null === this.startTime) return s.next(0);
          let {
            delay: h,
            repeat: p,
            repeatType: m,
            repeatDelay: f,
            onUpdate: g
          } = this.options;
          this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - u / this.speed, this.startTime)), t ? this.currentTime = e : null !== this.holdTime ? this.currentTime = this.holdTime : this.currentTime = Math.round(e - this.startTime) * this.speed;
          let v = this.currentTime - h * (this.speed >= 0 ? 1 : -1),
            y = this.speed >= 0 ? v < 0 : v > u;
          this.currentTime = Math.max(v, 0), "finished" === this.state && null === this.holdTime && (this.currentTime = u);
          let x = this.currentTime,
            b = s;
          if (p) {
            let e = Math.min(this.currentTime, u) / d,
              t = Math.floor(e),
              n = e % 1;
            !n && e >= 1 && (n = 1), 1 === n && t--, (t = Math.min(t, p + 1)) % 2 && ("reverse" === m ? (n = 1 - n, f && (n -= f / d)) : "mirror" === m && (b = a)), x = re(0, 1, n) * d
          }
          let C = y ? {
            done: !1,
            value: l[0]
          } : b.next(x);
          o && (C.value = o(C.value));
          let {
            done: w
          } = C;
          y || null === c || (w = this.speed >= 0 ? this.currentTime >= u : this.currentTime <= 0);
          let j = null === this.holdTime && ("finished" === this.state || "running" === this.state && w);
          return j && void 0 !== i && (C.value = nO(l, this.options, i)), g && g(C.value), j && this.finish(), C
        }
        get duration() {
          let {
            resolved: e
          } = this;
          return e ? nP(e.calculatedDuration) : 0
        }
        get time() {
          return nP(this.currentTime)
        }
        set time(e) {
          e = nE(e), this.currentTime = e, null !== this.holdTime || 0 === this.speed ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.speed)
        }
        get speed() {
          return this.playbackSpeed
        }
        set speed(e) {
          let t = this.playbackSpeed !== e;
          this.playbackSpeed = e, t && (this.time = nP(this.currentTime))
        }
        play() {
          if (this.resolver.isScheduled || this.resolver.resume(), !this._resolved) {
            this.pendingPlayState = "running";
            return
          }
          if (this.isStopped) return;
          let {
            driver: e = iH,
            onPlay: t,
            startTime: n
          } = this.options;
          this.driver || (this.driver = e(e => this.tick(e))), t && t();
          let i = this.driver.now();
          null !== this.holdTime ? this.startTime = i - this.holdTime : this.startTime ? "finished" === this.state && (this.startTime = i) : this.startTime = n ?? this.calcStartTime(), "finished" === this.state && this.updateFinishedPromise(), this.cancelTime = this.startTime, this.holdTime = null, this.state = "running", this.driver.start()
        }
        pause() {
          var e;
          if (!this._resolved) {
            this.pendingPlayState = "paused";
            return
          }
          this.state = "paused", this.holdTime = null !== (e = this.currentTime) && void 0 !== e ? e : 0
        }
        complete() {
          "running" !== this.state && this.play(), this.pendingPlayState = this.state = "finished", this.holdTime = null
        }
        finish() {
          this.teardown(), this.state = "finished";
          let {
            onComplete: e
          } = this.options;
          e && e()
        }
        cancel() {
          null !== this.cancelTime && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise()
        }
        teardown() {
          this.state = "idle", this.stopDriver(), this.resolveFinishedPromise(), this.updateFinishedPromise(), this.startTime = this.cancelTime = null, this.resolver.cancel()
        }
        stopDriver() {
          this.driver && (this.driver.stop(), this.driver = void 0)
        }
        sample(e) {
          return this.startTime = 0, this.tick(e, !0)
        }
      }
      let iW = new Set(["opacity", "clipPath", "filter", "transform"]),
        iz = (e, t) => {
          let n = "",
            i = Math.max(Math.round(t / 10), 2);
          for (let t = 0; t < i; t++) n += e(iv(0, i - 1, t)) + ", ";
          return `linear(${n.substring(0,n.length-2)})`
        };

      function i$(e) {
        let t;
        return () => (void 0 === t && (t = e()), t)
      }
      let iZ = {
          linearEasing: void 0
        },
        iU = function(e, t) {
          let n = i$(e);
          return () => {
            var e;
            return null !== (e = iZ[t]) && void 0 !== e ? e : n()
          }
        }(() => {
          try {
            document.createElement("div").animate({
              opacity: 0
            }, {
              easing: "linear(0, 1)"
            })
          } catch {
            return !1
          }
          return !0
        }, "linearEasing"),
        iq = e => {
          let [t, n, i, s] = e;
          return `cubic-bezier(${t}, ${n}, ${i}, ${s})`
        },
        iX = {
          linear: "linear",
          ease: "ease",
          easeIn: "ease-in",
          easeOut: "ease-out",
          easeInOut: "ease-in-out",
          circIn: iq([0, .65, .55, 1]),
          circOut: iq([.55, 0, 1, .45]),
          backIn: iq([.31, .01, .66, -.59]),
          backOut: iq([.33, 1.53, .69, .99])
        };

      function iY(e, t) {
        e.timeline = t, e.onfinish = null
      }
      let iK = i$(() => Object.hasOwnProperty.call(Element.prototype, "animate")),
        iG = {
          anticipate: nQ,
          backInOut: nG,
          circInOut: n0
        };
      class iQ extends r9 {
        constructor(e) {
          super(e);
          let {
            name: t,
            motionValue: n,
            element: i,
            keyframes: s
          } = this.options;
          this.resolver = new r5(s, (e, t) => this.onKeyframesResolved(e, t), t, n, i), this.resolver.scheduleResolve()
        }
        initPlayback(e, t) {
          var n, i;
          let {
            duration: s = 300,
            times: a,
            ease: o,
            type: l,
            motionValue: c,
            name: u,
            startTime: d
          } = this.options;
          if (!(!(null === (n = c.owner) || void 0 === n) && n.current)) return !1;
          if ("string" == typeof o && iU() && o in iG && (o = iG[o]), r3((i = this.options).type) || "spring" === i.type || ! function e(t) {
              return !!("function" == typeof t && iU() || !t || "string" == typeof t && (t in iX || iU()) || id(t) || Array.isArray(t) && t.every(e))
            }(i.ease)) {
            let {
              onComplete: t,
              onUpdate: n,
              motionValue: i,
              element: c,
              ...u
            } = this.options, d = function(e, t) {
              let n = new iF({
                  ...t,
                  keyframes: e,
                  repeat: 0,
                  delay: 0,
                  isGenerator: !0
                }),
                i = {
                  done: !1,
                  value: e[0]
                },
                s = [],
                a = 0;
              for (; !i.done && a < 2e4;) s.push((i = n.sample(a)).value), a += 10;
              return {
                times: void 0,
                keyframes: s,
                duration: a - 10,
                ease: "linear"
              }
            }(e, u);
            1 === (e = d.keyframes).length && (e[1] = e[0]), s = d.duration, a = d.times, o = d.ease, l = "keyframes"
          }
          let h = function(e, t, n) {
            let {
              delay: i = 0,
              duration: s = 300,
              repeat: a = 0,
              repeatType: o = "loop",
              ease: l = "easeInOut",
              times: c
            } = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, u = {
              [t]: n
            };
            c && (u.offset = c);
            let d = function e(t, n) {
              if (t) return "function" == typeof t && iU() ? iz(t, n) : id(t) ? iq(t) : Array.isArray(t) ? t.map(t => e(t, n) || iX.easeOut) : iX[t]
            }(l, s);
            return Array.isArray(d) && (u.easing = d), e.animate(u, {
              delay: i,
              duration: s,
              easing: Array.isArray(d) ? "linear" : d,
              fill: "both",
              iterations: a + 1,
              direction: "reverse" === o ? "alternate" : "normal"
            })
          }(c.owner.current, u, e, {
            ...this.options,
            duration: s,
            times: a,
            ease: o
          });
          return h.startTime = d ?? this.calcStartTime(), this.pendingTimeline ? (iY(h, this.pendingTimeline), this.pendingTimeline = void 0) : h.onfinish = () => {
            let {
              onComplete: n
            } = this.options;
            c.set(nO(e, this.options, t)), n && n(), this.cancel(), this.resolveFinishedPromise()
          }, {
            animation: h,
            duration: s,
            times: a,
            type: l,
            ease: o,
            keyframes: e
          }
        }
        get duration() {
          let {
            resolved: e
          } = this;
          if (!e) return 0;
          let {
            duration: t
          } = e;
          return nP(t)
        }
        get time() {
          let {
            resolved: e
          } = this;
          if (!e) return 0;
          let {
            animation: t
          } = e;
          return nP(t.currentTime || 0)
        }
        set time(e) {
          let {
            resolved: t
          } = this;
          if (!t) return;
          let {
            animation: n
          } = t;
          n.currentTime = nE(e)
        }
        get speed() {
          let {
            resolved: e
          } = this;
          if (!e) return 1;
          let {
            animation: t
          } = e;
          return t.playbackRate
        }
        set speed(e) {
          let {
            resolved: t
          } = this;
          if (!t) return;
          let {
            animation: n
          } = t;
          n.playbackRate = e
        }
        get state() {
          let {
            resolved: e
          } = this;
          if (!e) return "idle";
          let {
            animation: t
          } = e;
          return t.playState
        }
        get startTime() {
          let {
            resolved: e
          } = this;
          if (!e) return null;
          let {
            animation: t
          } = e;
          return t.startTime
        }
        attachTimeline(e) {
          if (this._resolved) {
            let {
              resolved: t
            } = this;
            if (!t) return nH;
            let {
              animation: n
            } = t;
            iY(n, e)
          } else this.pendingTimeline = e;
          return nH
        }
        play() {
          if (this.isStopped) return;
          let {
            resolved: e
          } = this;
          if (!e) return;
          let {
            animation: t
          } = e;
          "finished" === t.playState && this.updateFinishedPromise(), t.play()
        }
        pause() {
          let {
            resolved: e
          } = this;
          if (!e) return;
          let {
            animation: t
          } = e;
          t.pause()
        }
        stop() {
          if (this.resolver.cancel(), this.isStopped = !0, "idle" === this.state) return;
          this.resolveFinishedPromise(), this.updateFinishedPromise();
          let {
            resolved: e
          } = this;
          if (!e) return;
          let {
            animation: t,
            keyframes: n,
            duration: i,
            type: s,
            ease: a,
            times: o
          } = e;
          if ("idle" === t.playState || "finished" === t.playState) return;
          if (this.time) {
            let {
              motionValue: e,
              onUpdate: t,
              onComplete: l,
              element: c,
              ...u
            } = this.options, d = new iF({
              ...u,
              keyframes: n,
              duration: i,
              type: s,
              ease: a,
              times: o,
              isGenerator: !0
            }), h = nE(this.time);
            e.setWithVelocity(d.sample(h - 10).value, d.sample(h).value, 10)
          }
          let {
            onStop: l
          } = this.options;
          l && l(), this.cancel()
        }
        complete() {
          let {
            resolved: e
          } = this;
          e && e.animation.finish()
        }
        cancel() {
          let {
            resolved: e
          } = this;
          e && e.animation.cancel()
        }
        static supports(e) {
          let {
            motionValue: t,
            name: n,
            repeatDelay: i,
            repeatType: s,
            damping: a,
            type: o
          } = e;
          return iK() && n && iW.has(n) && t && t.owner && t.owner.current instanceof HTMLElement && !t.owner.getProps().onUpdate && !i && "mirror" !== s && 0 !== a && "inertia" !== o
        }
      }
      let iJ = i$(() => void 0 !== window.ScrollTimeline);
      class i1 {
        constructor(e) {
          this.stop = () => this.runAll("stop"), this.animations = e.filter(Boolean)
        }
        then(e, t) {
          return Promise.all(this.animations).then(e).catch(t)
        }
        getAll(e) {
          return this.animations[0][e]
        }
        setAll(e, t) {
          for (let n = 0; n < this.animations.length; n++) this.animations[n][e] = t
        }
        attachTimeline(e, t) {
          let n = this.animations.map(n => iJ() && n.attachTimeline ? n.attachTimeline(e) : t(n));
          return () => {
            n.forEach((e, t) => {
              e && e(), this.animations[t].stop()
            })
          }
        }
        get time() {
          return this.getAll("time")
        }
        set time(e) {
          this.setAll("time", e)
        }
        get speed() {
          return this.getAll("speed")
        }
        set speed(e) {
          this.setAll("speed", e)
        }
        get startTime() {
          return this.getAll("startTime")
        }
        get duration() {
          let e = 0;
          for (let t = 0; t < this.animations.length; t++) e = Math.max(e, this.animations[t].duration);
          return e
        }
        runAll(e) {
          this.animations.forEach(t => t[e]())
        }
        flatten() {
          this.runAll("flatten")
        }
        play() {
          this.runAll("play")
        }
        pause() {
          this.runAll("pause")
        }
        cancel() {
          this.runAll("cancel")
        }
        complete() {
          this.runAll("complete")
        }
      }
      let i0 = function(e, t, n) {
          let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            s = arguments.length > 4 ? arguments[4] : void 0,
            a = arguments.length > 5 ? arguments[5] : void 0;
          return o => {
            let l = nR(i, e) || {},
              c = l.delay || i.delay || 0,
              {
                elapsed: u = 0
              } = i;
            u -= nE(c);
            let d = {
              keyframes: Array.isArray(n) ? n : [null, n],
              ease: "easeOut",
              velocity: t.getVelocity(),
              ...l,
              delay: -u,
              onUpdate: e => {
                t.set(e), l.onUpdate && l.onUpdate(e)
              },
              onComplete: () => {
                o(), l.onComplete && l.onComplete()
              },
              name: e,
              motionValue: t,
              element: a ? void 0 : s
            };
            (function(e) {
              let {
                when: t,
                delay: n,
                delayChildren: i,
                staggerChildren: s,
                staggerDirection: a,
                repeat: o,
                repeatType: l,
                repeatDelay: c,
                from: u,
                elapsed: d,
                ...h
              } = e;
              return !!Object.keys(h).length
            })(l) || (d = {
              ...d,
              ...nV(e, d)
            }), d.duration && (d.duration = nE(d.duration)), d.repeatDelay && (d.repeatDelay = nE(d.repeatDelay)), void 0 !== d.from && (d.keyframes[0] = d.from);
            let h = !1;
            if (!1 !== d.type && (0 !== d.duration || d.repeatDelay) || (d.duration = 0, 0 !== d.delay || (h = !0)), h && !a && void 0 !== t.get()) {
              let e = nO(d.keyframes, l);
              if (void 0 !== e) return nF.update(() => {
                d.onUpdate(e), d.onComplete()
              }), new i1([])
            }
            return !a && iQ.supports(d) ? new iQ(d) : new iF(d)
          }
        },
        i2 = e => !!(e && "object" == typeof e && e.mix && e.toValue),
        i5 = e => nv(e) ? e[e.length - 1] || 0 : e;

      function i3(e, t) {
        -1 === e.indexOf(t) && e.push(t)
      }

      function i4(e, t) {
        let n = e.indexOf(t);
        n > -1 && e.splice(n, 1)
      }
      class i6 {
        constructor() {
          this.subscriptions = []
        }
        add(e) {
          return i3(this.subscriptions, e), () => i4(this.subscriptions, e)
        }
        notify(e, t, n) {
          let i = this.subscriptions.length;
          if (i) {
            if (1 === i) this.subscriptions[0](e, t, n);
            else
              for (let s = 0; s < i; s++) {
                let i = this.subscriptions[s];
                i && i(e, t, n)
              }
          }
        }
        getSize() {
          return this.subscriptions.length
        }
        clear() {
          this.subscriptions.length = 0
        }
      }
      let i7 = e => !isNaN(parseFloat(e)),
        i9 = {
          current: void 0
        };
      class i8 {
        constructor(e, t = {}) {
          var n = this;
          this.version = "11.11.17", this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = function(e) {
            let t = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1],
              i = r6.now();
            n.updatedAt !== i && n.setPrevFrameValue(), n.prev = n.current, n.setCurrent(e), n.current !== n.prev && n.events.change && n.events.change.notify(n.current), t && n.events.renderRequest && n.events.renderRequest.notify(n.current)
          }, this.hasAnimated = !1, this.setCurrent(e), this.owner = t.owner
        }
        setCurrent(e) {
          this.current = e, this.updatedAt = r6.now(), null === this.canTrackVelocity && void 0 !== e && (this.canTrackVelocity = i7(this.current))
        }
        setPrevFrameValue() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.current;
          this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt
        }
        onChange(e) {
          return this.on("change", e)
        }
        on(e, t) {
          this.events[e] || (this.events[e] = new i6);
          let n = this.events[e].add(t);
          return "change" === e ? () => {
            n(), nF.read(() => {
              this.events.change.getSize() || this.stop()
            })
          } : n
        }
        clearListeners() {
          for (let e in this.events) this.events[e].clear()
        }
        attach(e, t) {
          this.passiveEffect = e, this.stopPassiveEffect = t
        }
        set(e) {
          let t = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1];
          t && this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e, t)
        }
        setWithVelocity(e, t, n) {
          this.set(t), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - n
        }
        jump(e) {
          let t = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1];
          this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, t && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect()
        }
        get() {
          return i9.current && i9.current.push(this), this.current
        }
        getPrevious() {
          return this.prev
        }
        getVelocity() {
          var e;
          let t = r6.now();
          if (!this.canTrackVelocity || void 0 === this.prevFrameValue || t - this.updatedAt > 30) return 0;
          let n = Math.min(this.updatedAt - this.prevUpdatedAt, 30);
          return e = parseFloat(this.current) - parseFloat(this.prevFrameValue), n ? 1e3 / n * e : 0
        }
        start(e) {
          return this.stop(), new Promise(t => {
            this.hasAnimated = !0, this.animation = e(t), this.events.animationStart && this.events.animationStart.notify()
          }).then(() => {
            this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation()
          })
        }
        stop() {
          this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation()
        }
        isAnimating() {
          return !!this.animation
        }
        clearAnimation() {
          delete this.animation
        }
        destroy() {
          this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect()
        }
      }

      function se(e, t) {
        return new i8(e, t)
      }
      let st = e => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
        sn = "data-" + st("framerAppearId"),
        sr = e => !!(e && e.getVelocity);

      function si(e, t) {
        let n = e.getValue("willChange");
        if (sr(n) && n.add) return n.add(t)
      }

      function ss(e, t) {
        var n;
        let {
          delay: i = 0,
          transitionOverride: s,
          type: a
        } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, {
          transition: o = e.getDefaultTransition(),
          transitionEnd: l,
          ...c
        } = t;
        s && (o = s);
        let u = [],
          d = a && e.animationState && e.animationState.getState()[a];
        for (let t in c) {
          let s = e.getValue(t, null !== (n = e.latestValues[t]) && void 0 !== n ? n : null),
            a = c[t];
          if (void 0 === a || d && function(e, t) {
              let {
                protectedKeys: n,
                needsAnimating: i
              } = e, s = n.hasOwnProperty(t) && !0 !== i[t];
              return i[t] = !1, s
            }(d, t)) continue;
          let l = {
              delay: i,
              ...nR(o || {}, t)
            },
            h = !1;
          if (window.MotionHandoffAnimation) {
            let n = e.props[sn];
            if (n) {
              let e = window.MotionHandoffAnimation(n, t, nF);
              null !== e && (l.startTime = e, h = !0)
            }
          }
          si(e, t), s.start(i0(t, s, a, e.shouldReduceMotion && nS.has(t) ? {
            type: !1
          } : l, e, h));
          let p = s.animation;
          p && u.push(p)
        }
        return l && Promise.all(u).then(() => {
          nF.update(() => {
            l && function(e, t) {
              let {
                transitionEnd: n = {},
                transition: i = {},
                ...s
              } = nw(e, t) || {};
              for (let t in s = {
                  ...s,
                  ...n
                }) {
                let n = i5(s[t]);
                e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, se(n))
              }
            }(e, l)
          })
        }), u
      }

      function sa(e, t) {
        var n;
        let i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          s = nw(e, t, "exit" === i.type ? null === (n = e.presenceContext) || void 0 === n ? void 0 : n.custom : void 0),
          {
            transition: a = e.getDefaultTransition() || {}
          } = s || {};
        i.transitionOverride && (a = i.transitionOverride);
        let o = s ? () => Promise.all(ss(e, s, i)) : () => Promise.resolve(),
          l = e.variantChildren && e.variantChildren.size ? function() {
            let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
              {
                delayChildren: s = 0,
                staggerChildren: o,
                staggerDirection: l
              } = a;
            return function(e, t) {
              let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
                a = arguments.length > 5 ? arguments[5] : void 0,
                o = [],
                l = (e.variantChildren.size - 1) * i,
                c = 1 === s ? function() {
                  let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                  return e * i
                } : function() {
                  let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                  return l - e * i
                };
              return Array.from(e.variantChildren).sort(so).forEach((e, i) => {
                e.notify("AnimationStart", t), o.push(sa(e, t, {
                  ...a,
                  delay: n + c(i)
                }).then(() => e.notify("AnimationComplete", t)))
              }), Promise.all(o)
            }(e, t, s + n, o, l, i)
          } : () => Promise.resolve(),
          {
            when: c
          } = a;
        if (!c) return Promise.all([o(), l(i.delay)]);
        {
          let [e, t] = "beforeChildren" === c ? [o, l] : [l, o];
          return e().then(() => t())
        }
      }

      function so(e, t) {
        return e.sortNodePosition(t)
      }
      let sl = n_.length,
        sc = [...nj].reverse(),
        su = nj.length;

      function sd() {
        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return {
          isActive: e,
          protectedKeys: {},
          needsAnimating: {},
          prevResolvedValues: {}
        }
      }

      function sh() {
        return {
          animate: sd(!0),
          whileInView: sd(),
          whileHover: sd(),
          whileTap: sd(),
          whileDrag: sd(),
          whileFocus: sd(),
          exit: sd()
        }
      }
      class sp {
        constructor(e) {
          this.isMounted = !1, this.node = e
        }
        update() {}
      }
      class sm extends sp {
        constructor(e) {
          super(e), e.animationState || (e.animationState = function(e) {
            let t = t => Promise.all(t.map(t => {
                let {
                  animation: n,
                  options: i
                } = t;
                return function(e, t) {
                  let n, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                  if (e.notify("AnimationStart", t), Array.isArray(t)) n = Promise.all(t.map(t => sa(e, t, i)));
                  else if ("string" == typeof t) n = sa(e, t, i);
                  else {
                    let s = "function" == typeof t ? nw(e, t, i.custom) : t;
                    n = Promise.all(ss(e, s, i))
                  }
                  return n.then(() => {
                    e.notify("AnimationComplete", t)
                  })
                }(e, n, i)
              })),
              n = sh(),
              i = !0,
              s = t => (n, i) => {
                var s;
                let a = nw(e, i, "exit" === t ? null === (s = e.presenceContext) || void 0 === s ? void 0 : s.custom : void 0);
                if (a) {
                  let {
                    transition: e,
                    transitionEnd: t,
                    ...i
                  } = a;
                  n = {
                    ...n,
                    ...i,
                    ...t
                  }
                }
                return n
              };

            function a(a) {
              let {
                props: o
              } = e, l = function e(t) {
                if (!t) return;
                if (!t.isControllingVariants) {
                  let n = t.parent && e(t.parent) || {};
                  return void 0 !== t.props.initial && (n.initial = t.props.initial), n
                }
                let n = {};
                for (let e = 0; e < sl; e++) {
                  let i = n_[e],
                    s = t.props[i];
                  (nx(s) || !1 === s) && (n[i] = s)
                }
                return n
              }(e.parent) || {}, c = [], u = new Set, d = {}, h = 1 / 0;
              for (let t = 0; t < su; t++) {
                var p;
                let m = sc[t],
                  f = n[m],
                  g = void 0 !== o[m] ? o[m] : l[m],
                  v = nx(g),
                  y = m === a ? f.isActive : null;
                !1 === y && (h = t);
                let x = g === l[m] && g !== o[m] && v;
                if (x && i && e.manuallyAnimateOnMount && (x = !1), f.protectedKeys = {
                    ...d
                  }, !f.isActive && null === y || !g && !f.prevProp || ng(g) || "boolean" == typeof g) continue;
                let b = (p = f.prevProp, "string" == typeof g ? g !== p : !!Array.isArray(g) && !ny(g, p)),
                  C = b || m === a && f.isActive && !x && v || t > h && v,
                  w = !1,
                  j = Array.isArray(g) ? g : [g],
                  _ = j.reduce(s(m), {});
                !1 === y && (_ = {});
                let {
                  prevResolvedValues: k = {}
                } = f, S = {
                  ...k,
                  ..._
                }, E = t => {
                  C = !0, u.has(t) && (w = !0, u.delete(t)), f.needsAnimating[t] = !0;
                  let n = e.getValue(t);
                  n && (n.liveStyle = !1)
                };
                for (let e in S) {
                  let t = _[e],
                    n = k[e];
                  if (!d.hasOwnProperty(e))(nv(t) && nv(n) ? ny(t, n) : t === n) ? void 0 !== t && u.has(e) ? E(e) : f.protectedKeys[e] = !0 : null != t ? E(e) : u.add(e)
                }
                f.prevProp = g, f.prevResolvedValues = _, f.isActive && (d = {
                  ...d,
                  ..._
                }), i && e.blockInitialAnimation && (C = !1), C && (!(x && b) || w) && c.push(...j.map(e => ({
                  animation: e,
                  options: {
                    type: m
                  }
                })))
              }
              if (u.size) {
                let t = {};
                u.forEach(n => {
                  let i = e.getBaseTarget(n),
                    s = e.getValue(n);
                  s && (s.liveStyle = !0), t[n] = i ?? null
                }), c.push({
                  animation: t
                })
              }
              let m = !!c.length;
              return i && (!1 === o.initial || o.initial === o.animate) && !e.manuallyAnimateOnMount && (m = !1), i = !1, m ? t(c) : Promise.resolve()
            }
            return {
              animateChanges: a,
              setActive: function(t, i) {
                var s;
                if (n[t].isActive === i) return Promise.resolve();
                null === (s = e.variantChildren) || void 0 === s || s.forEach(e => {
                  var n;
                  return null === (n = e.animationState) || void 0 === n ? void 0 : n.setActive(t, i)
                }), n[t].isActive = i;
                let o = a(t);
                for (let e in n) n[e].protectedKeys = {};
                return o
              },
              setAnimateFunction: function(n) {
                t = n(e)
              },
              getState: () => n,
              reset: () => {
                n = sh(), i = !0
              }
            }
          }(e))
        }
        updateAnimationControlsSubscription() {
          let {
            animate: e
          } = this.node.getProps();
          ng(e) && (this.unmountControls = e.subscribe(this.node))
        }
        mount() {
          this.updateAnimationControlsSubscription()
        }
        update() {
          let {
            animate: e
          } = this.node.getProps(), {
            animate: t
          } = this.node.prevProps || {};
          e !== t && this.updateAnimationControlsSubscription()
        }
        unmount() {
          var e;
          this.node.animationState.reset(), null === (e = this.unmountControls) || void 0 === e || e.call(this)
        }
      }
      let sf = 0;
      class sg extends sp {
        constructor() {
          super(...arguments), this.id = sf++
        }
        update() {
          if (!this.node.presenceContext) return;
          let {
            isPresent: e,
            onExitComplete: t
          } = this.node.presenceContext, {
            isPresent: n
          } = this.node.prevPresenceContext || {};
          if (!this.node.animationState || e === n) return;
          let i = this.node.animationState.setActive("exit", !e);
          t && !e && i.then(() => t(this.id))
        }
        mount() {
          let {
            register: e
          } = this.node.presenceContext || {};
          e && (this.unmount = e(this.id))
        }
        unmount() {}
      }
      let sv = e => "mouse" === e.pointerType ? "number" != typeof e.button || e.button <= 0 : !1 !== e.isPrimary;

      function sy(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "page";
        return {
          point: {
            x: e[`${t}X`],
            y: e[`${t}Y`]
          }
        }
      }
      let sx = e => t => sv(t) && e(t, sy(t));

      function sb(e, t, n) {
        let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
          passive: !0
        };
        return e.addEventListener(t, n, i), () => e.removeEventListener(t, n)
      }

      function sC(e, t, n, i) {
        return sb(e, t, sx(n), i)
      }
      let sw = (e, t) => Math.abs(e - t);
      class sj {
        constructor(e, t, {
          transformPagePoint: n,
          contextWindow: i,
          dragSnapToOrigin: s = !1
        } = {}) {
          if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.updatePoint = () => {
              var e, t;
              if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
              let n = sS(this.lastMoveEventInfo, this.history),
                i = null !== this.startEvent,
                s = (e = n.offset, t = {
                  x: 0,
                  y: 0
                }, Math.sqrt(sw(e.x, t.x) ** 2 + sw(e.y, t.y) ** 2) >= 3);
              if (!i && !s) return;
              let {
                point: a
              } = n, {
                timestamp: o
              } = nz;
              this.history.push({
                ...a,
                timestamp: o
              });
              let {
                onStart: l,
                onMove: c
              } = this.handlers;
              i || (l && l(this.lastMoveEvent, n), this.startEvent = this.lastMoveEvent), c && c(this.lastMoveEvent, n)
            }, this.handlePointerMove = (e, t) => {
              this.lastMoveEvent = e, this.lastMoveEventInfo = s_(t, this.transformPagePoint), nF.update(this.updatePoint, !0)
            }, this.handlePointerUp = (e, t) => {
              this.end();
              let {
                onEnd: n,
                onSessionEnd: i,
                resumeAnimation: s
              } = this.handlers;
              if (this.dragSnapToOrigin && s && s(), !(this.lastMoveEvent && this.lastMoveEventInfo)) return;
              let a = sS("pointercancel" === e.type ? this.lastMoveEventInfo : s_(t, this.transformPagePoint), this.history);
              this.startEvent && n && n(e, a), i && i(e, a)
            }, !sv(e)) return;
          this.dragSnapToOrigin = s, this.handlers = t, this.transformPagePoint = n, this.contextWindow = i || window;
          let a = s_(sy(e), this.transformPagePoint),
            {
              point: o
            } = a,
            {
              timestamp: l
            } = nz;
          this.history = [{
            ...o,
            timestamp: l
          }];
          let {
            onSessionStart: c
          } = t;
          c && c(e, sS(a, this.history)), this.removeListeners = ig(sC(this.contextWindow, "pointermove", this.handlePointerMove), sC(this.contextWindow, "pointerup", this.handlePointerUp), sC(this.contextWindow, "pointercancel", this.handlePointerUp))
        }
        updateHandlers(e) {
          this.handlers = e
        }
        end() {
          this.removeListeners && this.removeListeners(), nW(this.updatePoint)
        }
      }

      function s_(e, t) {
        return t ? {
          point: t(e.point)
        } : e
      }

      function sk(e, t) {
        return {
          x: e.x - t.x,
          y: e.y - t.y
        }
      }

      function sS(e, t) {
        let {
          point: n
        } = e;
        return {
          point: n,
          delta: sk(n, sE(t)),
          offset: sk(n, t[0]),
          velocity: function(e, t) {
            if (e.length < 2) return {
              x: 0,
              y: 0
            };
            let n = e.length - 1,
              i = null,
              s = sE(e);
            for (; n >= 0 && (i = e[n], !(s.timestamp - i.timestamp > nE(.1)));) n--;
            if (!i) return {
              x: 0,
              y: 0
            };
            let a = nP(s.timestamp - i.timestamp);
            if (0 === a) return {
              x: 0,
              y: 0
            };
            let o = {
              x: (s.x - i.x) / a,
              y: (s.y - i.y) / a
            };
            return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o
          }(t, 0)
        }
      }

      function sE(e) {
        return e[e.length - 1]
      }

      function sP(e) {
        let t = null;
        return () => null === t && (t = e, () => {
          t = null
        })
      }
      let sM = sP("dragHorizontal"),
        sT = sP("dragVertical");

      function sL(e) {
        let t = !1;
        if ("y" === e) t = sT();
        else if ("x" === e) t = sM();
        else {
          let e = sM(),
            n = sT();
          e && n ? t = () => {
            e(), n()
          } : (e && e(), n && n())
        }
        return t
      }

      function sA() {
        let e = sL(!0);
        return !e || (e(), !1)
      }

      function sV(e) {
        return e && "object" == typeof e && Object.prototype.hasOwnProperty.call(e, "current")
      }

      function sR(e) {
        return e.max - e.min
      }

      function sN(e, t, n) {
        let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
        e.origin = i, e.originPoint = iy(t.min, t.max, e.origin), e.scale = sR(n) / sR(t), e.translate = iy(n.min, n.max, e.origin) - e.originPoint, (e.scale >= .9999 && e.scale <= 1.0001 || isNaN(e.scale)) && (e.scale = 1), (e.translate >= -.01 && e.translate <= .01 || isNaN(e.translate)) && (e.translate = 0)
      }

      function sD(e, t, n, i) {
        sN(e.x, t.x, n.x, i ? i.originX : void 0), sN(e.y, t.y, n.y, i ? i.originY : void 0)
      }

      function sO(e, t, n) {
        e.min = n.min + t.min, e.max = e.min + sR(t)
      }

      function sH(e, t, n) {
        e.min = t.min - n.min, e.max = e.min + sR(t)
      }

      function sI(e, t, n) {
        sH(e.x, t.x, n.x), sH(e.y, t.y, n.y)
      }

      function sB(e, t, n) {
        return {
          min: void 0 !== t ? e.min + t : void 0,
          max: void 0 !== n ? e.max + n - (e.max - e.min) : void 0
        }
      }

      function sF(e, t) {
        let n = t.min - e.min,
          i = t.max - e.max;
        return t.max - t.min < e.max - e.min && ([n, i] = [i, n]), {
          min: n,
          max: i
        }
      }

      function sW(e, t, n) {
        return {
          min: sz(e, t),
          max: sz(e, n)
        }
      }

      function sz(e, t) {
        return "number" == typeof e ? e : e[t] || 0
      }
      let s$ = () => ({
          translate: 0,
          scale: 1,
          origin: 0,
          originPoint: 0
        }),
        sZ = () => ({
          x: s$(),
          y: s$()
        }),
        sU = () => ({
          min: 0,
          max: 0
        }),
        sq = () => ({
          x: sU(),
          y: sU()
        });

      function sX(e) {
        return [e("x"), e("y")]
      }

      function sY(e) {
        let {
          top: t,
          left: n,
          right: i,
          bottom: s
        } = e;
        return {
          x: {
            min: n,
            max: i
          },
          y: {
            min: t,
            max: s
          }
        }
      }

      function sK(e) {
        return void 0 === e || 1 === e
      }

      function sG(e) {
        let {
          scale: t,
          scaleX: n,
          scaleY: i
        } = e;
        return !sK(t) || !sK(n) || !sK(i)
      }

      function sQ(e) {
        return sG(e) || sJ(e) || e.z || e.rotate || e.rotateX || e.rotateY || e.skewX || e.skewY
      }

      function sJ(e) {
        var t, n;
        return (t = e.x) && "0%" !== t || (n = e.y) && "0%" !== n
      }

      function s1(e, t, n, i, s) {
        return void 0 !== s && (e = i + s * (e - i)), i + n * (e - i) + t
      }

      function s0(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
          i = arguments.length > 3 ? arguments[3] : void 0,
          s = arguments.length > 4 ? arguments[4] : void 0;
        e.min = s1(e.min, t, n, i, s), e.max = s1(e.max, t, n, i, s)
      }

      function s2(e, t) {
        let {
          x: n,
          y: i
        } = t;
        s0(e.x, n.translate, n.scale, n.originPoint), s0(e.y, i.translate, i.scale, i.originPoint)
      }

      function s5(e, t) {
        e.min = e.min + t, e.max = e.max + t
      }

      function s3(e, t, n, i) {
        let s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : .5,
          a = iy(e.min, e.max, s);
        s0(e, t, n, a, i)
      }

      function s4(e, t) {
        s3(e.x, t.x, t.scaleX, t.scale, t.originX), s3(e.y, t.y, t.scaleY, t.scale, t.originY)
      }

      function s6(e, t) {
        return sY(function(e, t) {
          if (!t) return e;
          let n = t({
              x: e.left,
              y: e.top
            }),
            i = t({
              x: e.right,
              y: e.bottom
            });
          return {
            top: n.y,
            left: n.x,
            bottom: i.y,
            right: i.x
          }
        }(e.getBoundingClientRect(), t))
      }
      let s7 = e => {
          let {
            current: t
          } = e;
          return t ? t.ownerDocument.defaultView : null
        },
        s9 = new WeakMap;
      class s8 {
        constructor(e) {
          this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = {
            x: 0,
            y: 0
          }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = sq(), this.visualElement = e
        }
        start(e) {
          let {
            snapToCursor: t = !1
          } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
            presenceContext: n
          } = this.visualElement;
          if (n && !1 === n.isPresent) return;
          let {
            dragSnapToOrigin: i
          } = this.getProps();
          this.panSession = new sj(e, {
            onSessionStart: e => {
              let {
                dragSnapToOrigin: n
              } = this.getProps();
              n ? this.pauseAnimation() : this.stopAnimation(), t && this.snapToCursor(sy(e, "page").point)
            },
            onStart: (e, t) => {
              let {
                drag: n,
                dragPropagation: i,
                onDragStart: s
              } = this.getProps();
              if (n && !i && (this.openGlobalLock && this.openGlobalLock(), this.openGlobalLock = sL(n), !this.openGlobalLock)) return;
              this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), sX(e => {
                let t = this.getAxisMotionValue(e).get() || 0;
                if (ra.test(t)) {
                  let {
                    projection: n
                  } = this.visualElement;
                  if (n && n.layout) {
                    let i = n.layout.layoutBox[e];
                    i && (t = sR(i) * (parseFloat(t) / 100))
                  }
                }
                this.originPoint[e] = t
              }), s && nF.postRender(() => s(e, t)), si(this.visualElement, "transform");
              let {
                animationState: a
              } = this.visualElement;
              a && a.setActive("whileDrag", !0)
            },
            onMove: (e, t) => {
              let {
                dragPropagation: n,
                dragDirectionLock: i,
                onDirectionLock: s,
                onDrag: a
              } = this.getProps();
              if (!n && !this.openGlobalLock) return;
              let {
                offset: o
              } = t;
              if (i && null === this.currentDirection) {
                this.currentDirection = function(e) {
                  let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
                    n = null;
                  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n
                }(o), null !== this.currentDirection && s && s(this.currentDirection);
                return
              }
              this.updateAxis("x", t.point, o), this.updateAxis("y", t.point, o), this.visualElement.render(), a && a(e, t)
            },
            onSessionEnd: (e, t) => this.stop(e, t),
            resumeAnimation: () => sX(e => {
              var t;
              return "paused" === this.getAnimationState(e) && (null === (t = this.getAxisMotionValue(e).animation) || void 0 === t ? void 0 : t.play())
            })
          }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: i,
            contextWindow: s7(this.visualElement)
          })
        }
        stop(e, t) {
          let n = this.isDragging;
          if (this.cancel(), !n) return;
          let {
            velocity: i
          } = t;
          this.startAnimation(i);
          let {
            onDragEnd: s
          } = this.getProps();
          s && nF.postRender(() => s(e, t))
        }
        cancel() {
          this.isDragging = !1;
          let {
            projection: e,
            animationState: t
          } = this.visualElement;
          e && (e.isAnimationBlocked = !1), this.panSession && this.panSession.end(), this.panSession = void 0;
          let {
            dragPropagation: n
          } = this.getProps();
          !n && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), t && t.setActive("whileDrag", !1)
        }
        updateAxis(e, t, n) {
          let {
            drag: i
          } = this.getProps();
          if (!n || !ae(e, i, this.currentDirection)) return;
          let s = this.getAxisMotionValue(e),
            a = this.originPoint[e] + n[e];
          this.constraints && this.constraints[e] && (a = function(e, t, n) {
            let {
              min: i,
              max: s
            } = t;
            return void 0 !== i && e < i ? e = n ? iy(i, e, n.min) : Math.max(e, i) : void 0 !== s && e > s && (e = n ? iy(s, e, n.max) : Math.min(e, s)), e
          }(a, this.constraints[e], this.elastic[e])), s.set(a)
        }
        resolveConstraints() {
          var e;
          let {
            dragConstraints: t,
            dragElastic: n
          } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : null === (e = this.visualElement.projection) || void 0 === e ? void 0 : e.layout, s = this.constraints;
          t && sV(t) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : t && i ? this.constraints = function(e, t) {
            let {
              top: n,
              left: i,
              bottom: s,
              right: a
            } = t;
            return {
              x: sB(e.x, i, a),
              y: sB(e.y, n, s)
            }
          }(i.layoutBox, t) : this.constraints = !1, this.elastic = function() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : .35;
            return !1 === e ? e = 0 : !0 === e && (e = .35), {
              x: sW(e, "left", "right"),
              y: sW(e, "top", "bottom")
            }
          }(n), s !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && sX(e => {
            !1 !== this.constraints && this.getAxisMotionValue(e) && (this.constraints[e] = function(e, t) {
              let n = {};
              return void 0 !== t.min && (n.min = t.min - e.min), void 0 !== t.max && (n.max = t.max - e.min), n
            }(i.layoutBox[e], this.constraints[e]))
          })
        }
        resolveRefConstraints() {
          var e;
          let {
            dragConstraints: t,
            onMeasureDragConstraints: n
          } = this.getProps();
          if (!t || !sV(t)) return !1;
          let i = t.current;
          nH(null !== i, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
          let {
            projection: s
          } = this.visualElement;
          if (!s || !s.layout) return !1;
          let a = function(e, t, n) {
              let i = s6(e, n),
                {
                  scroll: s
                } = t;
              return s && (s5(i.x, s.offset.x), s5(i.y, s.offset.y)), i
            }(i, s.root, this.visualElement.getTransformPagePoint()),
            o = {
              x: sF((e = s.layout.layoutBox).x, a.x),
              y: sF(e.y, a.y)
            };
          if (n) {
            let e = n(function(e) {
              let {
                x: t,
                y: n
              } = e;
              return {
                top: n.min,
                right: t.max,
                bottom: n.max,
                left: t.min
              }
            }(o));
            this.hasMutatedConstraints = !!e, e && (o = sY(e))
          }
          return o
        }
        startAnimation(e) {
          let {
            drag: t,
            dragMomentum: n,
            dragElastic: i,
            dragTransition: s,
            dragSnapToOrigin: a,
            onDragTransitionEnd: o
          } = this.getProps(), l = this.constraints || {};
          return Promise.all(sX(o => {
            if (!ae(o, t, this.currentDirection)) return;
            let c = l && l[o] || {};
            a && (c = {
              min: 0,
              max: 0
            });
            let u = {
              type: "inertia",
              velocity: n ? e[o] : 0,
              bounceStiffness: i ? 200 : 1e6,
              bounceDamping: i ? 40 : 1e7,
              timeConstant: 750,
              restDelta: 1,
              restSpeed: 10,
              ...s,
              ...c
            };
            return this.startAxisValueAnimation(o, u)
          })).then(o)
        }
        startAxisValueAnimation(e, t) {
          let n = this.getAxisMotionValue(e);
          return si(this.visualElement, e), n.start(i0(e, n, 0, t, this.visualElement, !1))
        }
        stopAnimation() {
          sX(e => this.getAxisMotionValue(e).stop())
        }
        pauseAnimation() {
          sX(e => {
            var t;
            return null === (t = this.getAxisMotionValue(e).animation) || void 0 === t ? void 0 : t.pause()
          })
        }
        getAnimationState(e) {
          var t;
          return null === (t = this.getAxisMotionValue(e).animation) || void 0 === t ? void 0 : t.state
        }
        getAxisMotionValue(e) {
          let t = `_drag${e.toUpperCase()}`,
            n = this.visualElement.getProps();
          return n[t] || this.visualElement.getValue(e, (n.initial ? n.initial[e] : void 0) || 0)
        }
        snapToCursor(e) {
          sX(t => {
            let {
              drag: n
            } = this.getProps();
            if (!ae(t, n, this.currentDirection)) return;
            let {
              projection: i
            } = this.visualElement, s = this.getAxisMotionValue(t);
            if (i && i.layout) {
              let {
                min: n,
                max: a
              } = i.layout.layoutBox[t];
              s.set(e[t] - iy(n, a, .5))
            }
          })
        }
        scalePositionWithinConstraints() {
          if (!this.visualElement.current) return;
          let {
            drag: e,
            dragConstraints: t
          } = this.getProps(), {
            projection: n
          } = this.visualElement;
          if (!sV(t) || !n || !this.constraints) return;
          this.stopAnimation();
          let i = {
            x: 0,
            y: 0
          };
          sX(e => {
            let t = this.getAxisMotionValue(e);
            if (t && !1 !== this.constraints) {
              let n = t.get();
              i[e] = function(e, t) {
                let n = .5,
                  i = sR(e),
                  s = sR(t);
                return s > i ? n = iv(t.min, t.max - i, e.min) : i > s && (n = iv(e.min, e.max - s, t.min)), re(0, 1, n)
              }({
                min: n,
                max: n
              }, this.constraints[e])
            }
          });
          let {
            transformTemplate: s
          } = this.visualElement.getProps();
          this.visualElement.current.style.transform = s ? s({}, "") : "none", n.root && n.root.updateScroll(), n.updateLayout(), this.resolveConstraints(), sX(t => {
            if (!ae(t, e, null)) return;
            let n = this.getAxisMotionValue(t),
              {
                min: s,
                max: a
              } = this.constraints[t];
            n.set(iy(s, a, i[t]))
          })
        }
        addListeners() {
          if (!this.visualElement.current) return;
          s9.set(this.visualElement, this);
          let e = sC(this.visualElement.current, "pointerdown", e => {
              let {
                drag: t,
                dragListener: n = !0
              } = this.getProps();
              t && n && this.start(e)
            }),
            t = () => {
              let {
                dragConstraints: e
              } = this.getProps();
              sV(e) && e.current && (this.constraints = this.resolveRefConstraints())
            },
            {
              projection: n
            } = this.visualElement,
            i = n.addEventListener("measure", t);
          n && !n.layout && (n.root && n.root.updateScroll(), n.updateLayout()), nF.read(t);
          let s = sb(window, "resize", () => this.scalePositionWithinConstraints()),
            a = n.addEventListener("didUpdate", e => {
              let {
                delta: t,
                hasLayoutChanged: n
              } = e;
              this.isDragging && n && (sX(e => {
                let n = this.getAxisMotionValue(e);
                n && (this.originPoint[e] += t[e].translate, n.set(n.get() + t[e].translate))
              }), this.visualElement.render())
            });
          return () => {
            s(), e(), i(), a && a()
          }
        }
        getProps() {
          let e = this.visualElement.getProps(),
            {
              drag: t = !1,
              dragDirectionLock: n = !1,
              dragPropagation: i = !1,
              dragConstraints: s = !1,
              dragElastic: a = .35,
              dragMomentum: o = !0
            } = e;
          return {
            ...e,
            drag: t,
            dragDirectionLock: n,
            dragPropagation: i,
            dragConstraints: s,
            dragElastic: a,
            dragMomentum: o
          }
        }
      }

      function ae(e, t, n) {
        return (!0 === t || t === e) && (null === n || n === e)
      }
      class at extends sp {
        constructor(e) {
          super(e), this.removeGroupControls = nH, this.removeListeners = nH, this.controls = new s8(e)
        }
        mount() {
          let {
            dragControls: e
          } = this.node.getProps();
          e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || nH
        }
        unmount() {
          this.removeGroupControls(), this.removeListeners()
        }
      }
      let an = e => (t, n) => {
        e && nF.postRender(() => e(t, n))
      };
      class ar extends sp {
        constructor() {
          super(...arguments), this.removePointerDownListener = nH
        }
        onPointerDown(e) {
          this.session = new sj(e, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: s7(this.node)
          })
        }
        createPanHandlers() {
          let {
            onPanSessionStart: e,
            onPanStart: t,
            onPan: n,
            onPanEnd: i
          } = this.node.getProps();
          return {
            onSessionStart: an(e),
            onStart: an(t),
            onMove: n,
            onEnd: (e, t) => {
              delete this.session, i && nF.postRender(() => i(e, t))
            }
          }
        }
        mount() {
          this.removePointerDownListener = sC(this.node.current, "pointerdown", e => this.onPointerDown(e))
        }
        update() {
          this.session && this.session.updateHandlers(this.createPanHandlers())
        }
        unmount() {
          this.removePointerDownListener(), this.session && this.session.end()
        }
      }
      let ai = (0, o.createContext)(null),
        as = (0, o.createContext)({}),
        aa = (0, o.createContext)({}),
        ao = {
          hasAnimatedSinceResize: !0,
          hasEverUpdated: !1
        };

      function al(e, t) {
        return t.max === t.min ? 0 : e / (t.max - t.min) * 100
      }
      let ac = {
          correct: (e, t) => {
            if (!t.target) return e;
            if ("string" == typeof e) {
              if (!ro.test(e)) return e;
              e = parseFloat(e)
            }
            let n = al(e, t.target.x),
              i = al(e, t.target.y);
            return `${n}% ${i}%`
          }
        },
        au = {},
        {
          schedule: ad,
          cancel: ah
        } = nB(queueMicrotask, !1);
      class ap extends o.Component {
        componentDidMount() {
          let {
            visualElement: e,
            layoutGroup: t,
            switchLayoutGroup: n,
            layoutId: i
          } = this.props, {
            projection: s
          } = e;
          Object.assign(au, af), s && (t.group && t.group.add(s), n && n.register && i && n.register(s), s.root.didUpdate(), s.addEventListener("animationComplete", () => {
            this.safeToRemove()
          }), s.setOptions({
            ...s.options,
            onExitComplete: () => this.safeToRemove()
          })), ao.hasEverUpdated = !0
        }
        getSnapshotBeforeUpdate(e) {
          let {
            layoutDependency: t,
            visualElement: n,
            drag: i,
            isPresent: s
          } = this.props, a = n.projection;
          return a && (a.isPresent = s, i || e.layoutDependency !== t || void 0 === t ? a.willUpdate() : this.safeToRemove(), e.isPresent !== s && (s ? a.promote() : a.relegate() || nF.postRender(() => {
            let e = a.getStack();
            e && e.members.length || this.safeToRemove()
          }))), null
        }
        componentDidUpdate() {
          let {
            projection: e
          } = this.props.visualElement;
          e && (e.root.didUpdate(), ad.postRender(() => {
            !e.currentAnimation && e.isLead() && this.safeToRemove()
          }))
        }
        componentWillUnmount() {
          let {
            visualElement: e,
            layoutGroup: t,
            switchLayoutGroup: n
          } = this.props, {
            projection: i
          } = e;
          i && (i.scheduleCheckAfterUnmount(), t && t.group && t.group.remove(i), n && n.deregister && n.deregister(i))
        }
        safeToRemove() {
          let {
            safeToRemove: e
          } = this.props;
          e && e()
        }
        render() {
          return null
        }
      }

      function am(e) {
        let [t, n] = function() {
          let e = (0, o.useContext)(ai);
          if (null === e) return [!0, null];
          let {
            isPresent: t,
            onExitComplete: n,
            register: i
          } = e, s = (0, o.useId)();
          (0, o.useEffect)(() => i(s), []);
          let a = (0, o.useCallback)(() => n && n(s), [s, n]);
          return !t && n ? [!1, a] : [!0]
        }(), i = (0, o.useContext)(as);
        return m.jsx(ap, {
          ...e,
          layoutGroup: i,
          switchLayoutGroup: (0, o.useContext)(aa),
          isPresent: t,
          safeToRemove: n
        })
      }
      let af = {
          borderRadius: {
            ...ac,
            applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
          },
          borderTopLeftRadius: ac,
          borderTopRightRadius: ac,
          borderBottomLeftRadius: ac,
          borderBottomRightRadius: ac,
          boxShadow: {
            correct: (e, t) => {
              let {
                treeScale: n,
                projectionDelta: i
              } = t, s = rU.parse(e);
              if (s.length > 5) return e;
              let a = rU.createTransformer(e),
                o = "number" != typeof s[0] ? 1 : 0,
                l = i.x.scale * n.x,
                c = i.y.scale * n.y;
              s[0 + o] /= l, s[1 + o] /= c;
              let u = iy(l, c, .5);
              return "number" == typeof s[2 + o] && (s[2 + o] /= u), "number" == typeof s[3 + o] && (s[3 + o] /= u), a(s)
            }
          }
        },
        ag = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
        av = ag.length,
        ay = e => "string" == typeof e ? parseFloat(e) : e,
        ax = e => "number" == typeof e || ro.test(e);

      function ab(e, t) {
        return void 0 !== e[t] ? e[t] : e.borderRadius
      }
      let aC = aj(0, .5, n1),
        aw = aj(.5, .95, nH);

      function aj(e, t, n) {
        return i => i < e ? 0 : i > t ? 1 : n(iv(e, t, i))
      }

      function a_(e, t) {
        e.min = t.min, e.max = t.max
      }

      function ak(e, t) {
        a_(e.x, t.x), a_(e.y, t.y)
      }

      function aS(e, t) {
        e.translate = t.translate, e.scale = t.scale, e.originPoint = t.originPoint, e.origin = t.origin
      }

      function aE(e, t, n, i, s) {
        return e -= t, e = i + 1 / n * (e - i), void 0 !== s && (e = i + 1 / s * (e - i)), e
      }

      function aP(e, t, n, i, s) {
        let [a, o, l] = n;
        ! function(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5,
            s = arguments.length > 4 ? arguments[4] : void 0,
            a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : e,
            o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : e;
          if (ra.test(t) && (t = parseFloat(t), t = iy(o.min, o.max, t / 100) - o.min), "number" != typeof t) return;
          let l = iy(a.min, a.max, i);
          e === a && (l -= t), e.min = aE(e.min, t, n, l, s), e.max = aE(e.max, t, n, l, s)
        }(e, t[a], t[o], t[l], t.scale, i, s)
      }
      let aM = ["x", "scaleX", "originX"],
        aT = ["y", "scaleY", "originY"];

      function aL(e, t, n, i) {
        aP(e.x, t, aM, n ? n.x : void 0, i ? i.x : void 0), aP(e.y, t, aT, n ? n.y : void 0, i ? i.y : void 0)
      }

      function aA(e) {
        return 0 === e.translate && 1 === e.scale
      }

      function aV(e) {
        return aA(e.x) && aA(e.y)
      }

      function aR(e, t) {
        return e.min === t.min && e.max === t.max
      }

      function aN(e, t) {
        return Math.round(e.min) === Math.round(t.min) && Math.round(e.max) === Math.round(t.max)
      }

      function aD(e, t) {
        return aN(e.x, t.x) && aN(e.y, t.y)
      }

      function aO(e) {
        return sR(e.x) / sR(e.y)
      }

      function aH(e, t) {
        return e.translate === t.translate && e.scale === t.scale && e.originPoint === t.originPoint
      }
      class aI {
        constructor() {
          this.members = []
        }
        add(e) {
          i3(this.members, e), e.scheduleRender()
        }
        remove(e) {
          if (i4(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
            let e = this.members[this.members.length - 1];
            e && this.promote(e)
          }
        }
        relegate(e) {
          let t;
          let n = this.members.findIndex(t => e === t);
          if (0 === n) return !1;
          for (let e = n; e >= 0; e--) {
            let n = this.members[e];
            if (!1 !== n.isPresent) {
              t = n;
              break
            }
          }
          return !!t && (this.promote(t), !0)
        }
        promote(e, t) {
          let n = this.lead;
          if (e !== n && (this.prevLead = n, this.lead = e, e.show(), n)) {
            n.instance && n.scheduleRender(), e.scheduleRender(), e.resumeFrom = n, t && (e.resumeFrom.preserveOpacity = !0), n.snapshot && (e.snapshot = n.snapshot, e.snapshot.latestValues = n.animationValues || n.latestValues), e.root && e.root.isUpdating && (e.isLayoutDirty = !0);
            let {
              crossfade: i
            } = e.options;
            !1 === i && n.hide()
          }
        }
        exitAnimationComplete() {
          this.members.forEach(e => {
            let {
              options: t,
              resumingFrom: n
            } = e;
            t.onExitComplete && t.onExitComplete(), n && n.options.onExitComplete && n.options.onExitComplete()
          })
        }
        scheduleRender() {
          this.members.forEach(e => {
            e.instance && e.scheduleRender(!1)
          })
        }
        removeLeadSnapshot() {
          this.lead && this.lead.snapshot && (this.lead.snapshot = void 0)
        }
      }
      let aB = (e, t) => e.depth - t.depth;
      class aF {
        constructor() {
          this.children = [], this.isDirty = !1
        }
        add(e) {
          i3(this.children, e), this.isDirty = !0
        }
        remove(e) {
          i4(this.children, e), this.isDirty = !0
        }
        forEach(e) {
          this.isDirty && this.children.sort(aB), this.isDirty = !1, this.children.forEach(e)
        }
      }

      function aW(e) {
        let t = sr(e) ? e.get() : e;
        return i2(t) ? t.toValue() : t
      }

      function az(e) {
        return e instanceof SVGElement && "svg" !== e.tagName
      }

      function a$(e, t, n) {
        let i = sr(e) ? e : se(e);
        return i.start(i0("", i, t, n)), i.animation
      }
      let aZ = {
          type: "projectionFrame",
          totalNodes: 0,
          resolvedTargetDeltas: 0,
          recalculatedProjection: 0
        },
        aU = void 0 !== window.MotionDebug,
        aq = ["", "X", "Y", "Z"],
        aX = {
          visibility: "hidden"
        },
        aY = 0;

      function aK(e, t, n, i) {
        let {
          latestValues: s
        } = t;
        s[e] && (n[e] = s[e], t.setStaticValue(e, 0), i && (i[e] = 0))
      }

      function aG(e) {
        let {
          attachResizeListener: t,
          defaultParent: n,
          measureScroll: i,
          checkIsScrollRoot: s,
          resetTransform: a
        } = e;
        return class {
          constructor(e = {}, t = null == n ? void 0 : n()) {
            this.id = aY++, this.animationId = 0, this.children = new Set, this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = {
              x: 1,
              y: 1
            }, this.eventHandlers = new Map, this.hasTreeAnimated = !1, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
              this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots())
            }, this.updateProjection = () => {
              this.projectionUpdateScheduled = !1, aU && (aZ.totalNodes = aZ.resolvedTargetDeltas = aZ.recalculatedProjection = 0), this.nodes.forEach(a1), this.nodes.forEach(a7), this.nodes.forEach(a9), this.nodes.forEach(a0), aU && window.MotionDebug.record(aZ)
            }, this.resolvedRelativeTargetAt = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = new Map, this.latestValues = e, this.root = t ? t.root || t : this, this.path = t ? [...t.path, t] : [], this.parent = t, this.depth = t ? t.depth + 1 : 0;
            for (let e = 0; e < this.path.length; e++) this.path[e].shouldResetTransform = !0;
            this.root === this && (this.nodes = new aF)
          }
          addEventListener(e, t) {
            return this.eventHandlers.has(e) || this.eventHandlers.set(e, new i6), this.eventHandlers.get(e).add(t)
          }
          notifyListeners(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
            let s = this.eventHandlers.get(e);
            s && s.notify(...n)
          }
          hasListeners(e) {
            return this.eventHandlers.has(e)
          }
          mount(e) {
            let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.root.hasTreeAnimated;
            if (this.instance) return;
            this.isSVG = az(e), this.instance = e;
            let {
              layoutId: i,
              layout: s,
              visualElement: a
            } = this.options;
            if (a && !a.current && a.mount(e), this.root.nodes.add(this), this.parent && this.parent.children.add(this), n && (s || i) && (this.isLayoutDirty = !0), t) {
              let n;
              let i = () => this.root.updateBlockedByResize = !1;
              t(e, () => {
                this.root.updateBlockedByResize = !0, n && n(), n = function(e, t) {
                  let n = r6.now(),
                    i = t => {
                      let {
                        timestamp: s
                      } = t, a = s - n;
                      a >= 250 && (nW(i), e(a - 250))
                    };
                  return nF.read(i, !0), () => nW(i)
                }(i, 0), ao.hasAnimatedSinceResize && (ao.hasAnimatedSinceResize = !1, this.nodes.forEach(a6))
              })
            }
            i && this.root.registerSharedNode(i, this), !1 !== this.options.animate && a && (i || s) && this.addEventListener("didUpdate", e => {
              let {
                delta: t,
                hasLayoutChanged: n,
                hasRelativeTargetChanged: i,
                layout: s
              } = e;
              if (this.isTreeAnimationBlocked()) {
                this.target = void 0, this.relativeTarget = void 0;
                return
              }
              let o = this.options.transition || a.getDefaultTransition() || oi,
                {
                  onLayoutAnimationStart: l,
                  onLayoutAnimationComplete: c
                } = a.getProps(),
                u = !this.targetLayout || !aD(this.targetLayout, s) || i,
                d = !n && i;
              if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || d || n && (u || !this.currentAnimation)) {
                this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0), this.setAnimationOrigin(t, d);
                let e = {
                  ...nR(o, "layout"),
                  onPlay: l,
                  onComplete: c
                };
                (a.shouldReduceMotion || this.options.layoutRoot) && (e.delay = 0, e.type = !1), this.startAnimation(e)
              } else n || a6(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
              this.targetLayout = s
            })
          }
          unmount() {
            this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
            let e = this.getStack();
            e && e.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, nW(this.updateProjection)
          }
          blockUpdate() {
            this.updateManuallyBlocked = !0
          }
          unblockUpdate() {
            this.updateManuallyBlocked = !1
          }
          isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize
          }
          isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1
          }
          startUpdate() {
            this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(a8), this.animationId++)
          }
          getTransformTemplate() {
            let {
              visualElement: e
            } = this.options;
            return e && e.getProps().transformTemplate
          }
          willUpdate() {
            let e = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0];
            if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
              this.options.onExitComplete && this.options.onExitComplete();
              return
            }
            if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && function e(t) {
                if (t.hasCheckedOptimisedAppear = !0, t.root === t) return;
                let {
                  visualElement: n
                } = t.options;
                if (!n) return;
                let i = n.props[sn];
                if (window.MotionHasOptimisedAnimation(i, "transform")) {
                  let {
                    layout: e,
                    layoutId: n
                  } = t.options;
                  window.MotionCancelOptimisedAnimation(i, "transform", nF, !(e || n))
                }
                let {
                  parent: s
                } = t;
                s && !s.hasCheckedOptimisedAppear && e(s)
              }(this), this.root.isUpdating || this.root.startUpdate(), this.isLayoutDirty) return;
            this.isLayoutDirty = !0;
            for (let e = 0; e < this.path.length; e++) {
              let t = this.path[e];
              t.shouldResetTransform = !0, t.updateScroll("snapshot"), t.options.layoutRoot && t.willUpdate(!1)
            }
            let {
              layoutId: t,
              layout: n
            } = this.options;
            if (void 0 === t && !n) return;
            let i = this.getTransformTemplate();
            this.prevTransformTemplateValue = i ? i(this.latestValues, "") : void 0, this.updateSnapshot(), e && this.notifyListeners("willUpdate")
          }
          update() {
            if (this.updateScheduled = !1, this.isUpdateBlocked()) {
              this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(a5);
              return
            }
            this.isUpdating || this.nodes.forEach(a3), this.isUpdating = !1, this.nodes.forEach(a4), this.nodes.forEach(aQ), this.nodes.forEach(aJ), this.clearAllSnapshots();
            let e = r6.now();
            nz.delta = re(0, 1e3 / 60, e - nz.timestamp), nz.timestamp = e, nz.isProcessing = !0, n$.update.process(nz), n$.preRender.process(nz), n$.render.process(nz), nz.isProcessing = !1
          }
          didUpdate() {
            this.updateScheduled || (this.updateScheduled = !0, ad.read(this.scheduleUpdate))
          }
          clearAllSnapshots() {
            this.nodes.forEach(a2), this.sharedNodes.forEach(oe)
          }
          scheduleUpdateProjection() {
            this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, nF.preRender(this.updateProjection, !1, !0))
          }
          scheduleCheckAfterUnmount() {
            nF.postRender(() => {
              this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed()
            })
          }
          updateSnapshot() {
            this.snapshot || !this.instance || (this.snapshot = this.measure())
          }
          updateLayout() {
            if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)) return;
            if (this.resumeFrom && !this.resumeFrom.instance)
              for (let e = 0; e < this.path.length; e++) this.path[e].updateScroll();
            let e = this.layout;
            this.layout = this.measure(!1), this.layoutCorrected = sq(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
            let {
              visualElement: t
            } = this.options;
            t && t.notify("LayoutMeasure", this.layout.layoutBox, e ? e.layoutBox : void 0)
          }
          updateScroll() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "measure",
              t = !!(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === e && (t = !1), t) {
              let t = s(this.instance);
              this.scroll = {
                animationId: this.root.animationId,
                phase: e,
                isRoot: t,
                offset: i(this.instance),
                wasRoot: this.scroll ? this.scroll.isRoot : t
              }
            }
          }
          resetTransform() {
            if (!a) return;
            let e = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout,
              t = this.projectionDelta && !aV(this.projectionDelta),
              n = this.getTransformTemplate(),
              i = n ? n(this.latestValues, "") : void 0,
              s = i !== this.prevTransformTemplateValue;
            e && (t || sQ(this.latestValues) || s) && (a(this.instance, i), this.shouldResetTransform = !1, this.scheduleRender())
          }
          measure() {
            var e;
            let t = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0],
              n = this.measurePageBox(),
              i = this.removeElementScroll(n);
            return t && (i = this.removeTransform(i)), oo((e = i).x), oo(e.y), {
              animationId: this.root.animationId,
              measuredBox: n,
              layoutBox: i,
              latestValues: {},
              source: this.id
            }
          }
          measurePageBox() {
            var e;
            let {
              visualElement: t
            } = this.options;
            if (!t) return sq();
            let n = t.measureViewportBox();
            if (!((null === (e = this.scroll) || void 0 === e ? void 0 : e.wasRoot) || this.path.some(oc))) {
              let {
                scroll: e
              } = this.root;
              e && (s5(n.x, e.offset.x), s5(n.y, e.offset.y))
            }
            return n
          }
          removeElementScroll(e) {
            var t;
            let n = sq();
            if (ak(n, e), !(null === (t = this.scroll) || void 0 === t) && t.wasRoot) return n;
            for (let t = 0; t < this.path.length; t++) {
              let i = this.path[t],
                {
                  scroll: s,
                  options: a
                } = i;
              i !== this.root && s && a.layoutScroll && (s.wasRoot && ak(n, e), s5(n.x, s.offset.x), s5(n.y, s.offset.y))
            }
            return n
          }
          applyTransform(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = sq();
            ak(n, e);
            for (let e = 0; e < this.path.length; e++) {
              let i = this.path[e];
              !t && i.options.layoutScroll && i.scroll && i !== i.root && s4(n, {
                x: -i.scroll.offset.x,
                y: -i.scroll.offset.y
              }), sQ(i.latestValues) && s4(n, i.latestValues)
            }
            return sQ(this.latestValues) && s4(n, this.latestValues), n
          }
          removeTransform(e) {
            let t = sq();
            ak(t, e);
            for (let e = 0; e < this.path.length; e++) {
              let n = this.path[e];
              if (!n.instance || !sQ(n.latestValues)) continue;
              sG(n.latestValues) && n.updateSnapshot();
              let i = sq();
              ak(i, n.measurePageBox()), aL(t, n.latestValues, n.snapshot ? n.snapshot.layoutBox : void 0, i)
            }
            return sQ(this.latestValues) && aL(t, this.latestValues), t
          }
          setTargetDelta(e) {
            this.targetDelta = e, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0
          }
          setOptions(e) {
            this.options = {
              ...this.options,
              ...e,
              crossfade: void 0 === e.crossfade || e.crossfade
            }
          }
          clearMeasurements() {
            this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1
          }
          forceRelativeParentToResolveTarget() {
            this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== nz.timestamp && this.relativeParent.resolveTargetDelta(!0)
          }
          resolveTargetDelta() {
            var e, t, n, i;
            let s = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              a = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
            let o = !!this.resumingFrom || this !== a;
            if (!(s || o && this.isSharedProjectionDirty || this.isProjectionDirty || !(null === (e = this.parent) || void 0 === e) && e.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize)) return;
            let {
              layout: l,
              layoutId: c
            } = this.options;
            if (!(!this.layout || !(l || c))) {
              if (this.resolvedRelativeTargetAt = nz.timestamp, !this.targetDelta && !this.relativeTarget) {
                let e = this.getClosestProjectingParent();
                e && e.layout && 1 !== this.animationProgress ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = sq(), this.relativeTargetOrigin = sq(), sI(this.relativeTargetOrigin, this.layout.layoutBox, e.layout.layoutBox), ak(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0
              }
              if (!(!this.relativeTarget && !this.targetDelta)) {
                if (this.target || (this.target = sq(), this.targetWithTransforms = sq()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), t = this.target, n = this.relativeTarget, i = this.relativeParent.target, sO(t.x, n.x, i.x), sO(t.y, n.y, i.y)) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.layoutBox) : ak(this.target, this.layout.layoutBox), s2(this.target, this.targetDelta)) : ak(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget) {
                  this.attemptToResolveRelativeTarget = !1;
                  let e = this.getClosestProjectingParent();
                  e && !!e.resumingFrom == !!this.resumingFrom && !e.options.layoutScroll && e.target && 1 !== this.animationProgress ? (this.relativeParent = e, this.forceRelativeParentToResolveTarget(), this.relativeTarget = sq(), this.relativeTargetOrigin = sq(), sI(this.relativeTargetOrigin, this.target, e.target), ak(this.relativeTarget, this.relativeTargetOrigin)) : this.relativeParent = this.relativeTarget = void 0
                }
                aU && aZ.resolvedTargetDeltas++
              }
            }
          }
          getClosestProjectingParent() {
            if (!(!this.parent || sG(this.parent.latestValues) || sJ(this.parent.latestValues))) return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent()
          }
          isProjecting() {
            return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout)
          }
          calcProjection() {
            var e;
            let t = this.getLead(),
              n = !!this.resumingFrom || this !== t,
              i = !0;
            if ((this.isProjectionDirty || !(null === (e = this.parent) || void 0 === e) && e.isProjectionDirty) && (i = !1), n && (this.isSharedProjectionDirty || this.isTransformDirty) && (i = !1), this.resolvedRelativeTargetAt === nz.timestamp && (i = !1), i) return;
            let {
              layout: s,
              layoutId: a
            } = this.options;
            if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(s || a)) return;
            ak(this.layoutCorrected, this.layout.layoutBox);
            let o = this.treeScale.x,
              l = this.treeScale.y;
            (function(e, t, n) {
              let i, s, a = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
                o = n.length;
              if (o) {
                t.x = t.y = 1;
                for (let l = 0; l < o; l++) {
                  s = (i = n[l]).projectionDelta;
                  let {
                    visualElement: o
                  } = i.options;
                  o && o.props.style && "contents" === o.props.style.display || (a && i.options.layoutScroll && i.scroll && i !== i.root && s4(e, {
                    x: -i.scroll.offset.x,
                    y: -i.scroll.offset.y
                  }), s && (t.x *= s.x.scale, t.y *= s.y.scale, s2(e, s)), a && sQ(i.latestValues) && s4(e, i.latestValues))
                }
                t.x < 1.0000000000001 && t.x > .999999999999 && (t.x = 1), t.y < 1.0000000000001 && t.y > .999999999999 && (t.y = 1)
              }
            })(this.layoutCorrected, this.treeScale, this.path, n), t.layout && !t.target && (1 !== this.treeScale.x || 1 !== this.treeScale.y) && (t.target = t.layout.layoutBox, t.targetWithTransforms = sq());
            let {
              target: c
            } = t;
            if (!c) {
              this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
              return
            }
            this.projectionDelta && this.prevProjectionDelta ? (aS(this.prevProjectionDelta.x, this.projectionDelta.x), aS(this.prevProjectionDelta.y, this.projectionDelta.y)) : this.createProjectionDeltas(), sD(this.projectionDelta, this.layoutCorrected, c, this.latestValues), this.treeScale.x === o && this.treeScale.y === l && aH(this.projectionDelta.x, this.prevProjectionDelta.x) && aH(this.projectionDelta.y, this.prevProjectionDelta.y) || (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", c)), aU && aZ.recalculatedProjection++
          }
          hide() {
            this.isVisible = !1
          }
          show() {
            this.isVisible = !0
          }
          scheduleRender() {
            var e;
            let t = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0];
            if (null === (e = this.options.visualElement) || void 0 === e || e.scheduleRender(), t) {
              let e = this.getStack();
              e && e.scheduleRender()
            }
            this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0)
          }
          createProjectionDeltas() {
            this.prevProjectionDelta = sZ(), this.projectionDelta = sZ(), this.projectionDeltaWithTransform = sZ()
          }
          setAnimationOrigin(e) {
            let t, n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              i = this.snapshot,
              s = i ? i.latestValues : {},
              a = {
                ...this.latestValues
              },
              o = sZ();
            this.relativeParent && this.relativeParent.options.layoutRoot || (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !n;
            let l = sq(),
              c = (i ? i.source : void 0) !== (this.layout ? this.layout.source : void 0),
              u = this.getStack(),
              d = !u || u.members.length <= 1,
              h = !!(c && !d && !0 === this.options.crossfade && !this.path.some(or));
            this.animationProgress = 0, this.mixTargetDelta = n => {
              var i, u, p, m;
              let f = n / 1e3;
              ot(o.x, e.x, f), ot(o.y, e.y, f), this.setTargetDelta(o), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (sI(l, this.layout.layoutBox, this.relativeParent.layout.layoutBox), p = this.relativeTarget, m = this.relativeTargetOrigin, on(p.x, m.x, l.x, f), on(p.y, m.y, l.y, f), t && (i = this.relativeTarget, u = t, aR(i.x, u.x) && aR(i.y, u.y)) && (this.isProjectionDirty = !1), t || (t = sq()), ak(t, this.relativeTarget)), c && (this.animationValues = a, function(e, t, n, i, s, a) {
                s ? (e.opacity = iy(0, void 0 !== n.opacity ? n.opacity : 1, aC(i)), e.opacityExit = iy(void 0 !== t.opacity ? t.opacity : 1, 0, aw(i))) : a && (e.opacity = iy(void 0 !== t.opacity ? t.opacity : 1, void 0 !== n.opacity ? n.opacity : 1, i));
                for (let s = 0; s < av; s++) {
                  let a = `border${ag[s]}Radius`,
                    o = ab(t, a),
                    l = ab(n, a);
                  (void 0 !== o || void 0 !== l) && (o || (o = 0), l || (l = 0), 0 === o || 0 === l || ax(o) === ax(l) ? (e[a] = Math.max(iy(ay(o), ay(l), i), 0), (ra.test(l) || ra.test(o)) && (e[a] += "%")) : e[a] = l)
                }(t.rotate || n.rotate) && (e.rotate = iy(t.rotate || 0, n.rotate || 0, i))
              }(a, s, this.latestValues, f, h, d)), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = f
            }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0)
          }
          startAnimation(e) {
            this.notifyListeners("animationStart"), this.currentAnimation && this.currentAnimation.stop(), this.resumingFrom && this.resumingFrom.currentAnimation && this.resumingFrom.currentAnimation.stop(), this.pendingAnimation && (nW(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = nF.update(() => {
              ao.hasAnimatedSinceResize = !0, this.currentAnimation = a$(0, 1e3, {
                ...e,
                onUpdate: t => {
                  this.mixTargetDelta(t), e.onUpdate && e.onUpdate(t)
                },
                onComplete: () => {
                  e.onComplete && e.onComplete(), this.completeAnimation()
                }
              }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0
            })
          }
          completeAnimation() {
            this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
            let e = this.getStack();
            e && e.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete")
          }
          finishAnimation() {
            this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(1e3), this.currentAnimation.stop()), this.completeAnimation()
          }
          applyTransformsToTarget() {
            let e = this.getLead(),
              {
                targetWithTransforms: t,
                target: n,
                layout: i,
                latestValues: s
              } = e;
            if (!(!t || !n || !i)) {
              if (this !== e && this.layout && i && ol(this.options.animationType, this.layout.layoutBox, i.layoutBox)) {
                n = this.target || sq();
                let t = sR(this.layout.layoutBox.x);
                n.x.min = e.target.x.min, n.x.max = n.x.min + t;
                let i = sR(this.layout.layoutBox.y);
                n.y.min = e.target.y.min, n.y.max = n.y.min + i
              }
              ak(t, n), s4(t, s), sD(this.projectionDeltaWithTransform, this.layoutCorrected, t, s)
            }
          }
          registerSharedNode(e, t) {
            this.sharedNodes.has(e) || this.sharedNodes.set(e, new aI), this.sharedNodes.get(e).add(t);
            let n = t.options.initialPromotionConfig;
            t.promote({
              transition: n ? n.transition : void 0,
              preserveFollowOpacity: n && n.shouldPreserveFollowOpacity ? n.shouldPreserveFollowOpacity(t) : void 0
            })
          }
          isLead() {
            let e = this.getStack();
            return !e || e.lead === this
          }
          getLead() {
            var e;
            let {
              layoutId: t
            } = this.options;
            return t && (null === (e = this.getStack()) || void 0 === e ? void 0 : e.lead) || this
          }
          getPrevLead() {
            var e;
            let {
              layoutId: t
            } = this.options;
            return t ? null === (e = this.getStack()) || void 0 === e ? void 0 : e.prevLead : void 0
          }
          getStack() {
            let {
              layoutId: e
            } = this.options;
            if (e) return this.root.sharedNodes.get(e)
          }
          promote() {
            let {
              needsReset: e,
              transition: t,
              preserveFollowOpacity: n
            } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, i = this.getStack();
            i && i.promote(this, n), e && (this.projectionDelta = void 0, this.needsReset = !0), t && this.setOptions({
              transition: t
            })
          }
          relegate() {
            let e = this.getStack();
            return !!e && e.relegate(this)
          }
          resetSkewAndRotation() {
            let {
              visualElement: e
            } = this.options;
            if (!e) return;
            let t = !1,
              {
                latestValues: n
              } = e;
            if ((n.z || n.rotate || n.rotateX || n.rotateY || n.rotateZ || n.skewX || n.skewY) && (t = !0), !t) return;
            let i = {};
            n.z && aK("z", e, i, this.animationValues);
            for (let t = 0; t < aq.length; t++) aK(`rotate${aq[t]}`, e, i, this.animationValues), aK(`skew${aq[t]}`, e, i, this.animationValues);
            for (let t in e.render(), i) e.setStaticValue(t, i[t]), this.animationValues && (this.animationValues[t] = i[t]);
            e.scheduleRender()
          }
          getProjectionStyles(e) {
            var t, n;
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) return aX;
            let i = {
                visibility: ""
              },
              s = this.getTransformTemplate();
            if (this.needsReset) return this.needsReset = !1, i.opacity = "", i.pointerEvents = aW(null == e ? void 0 : e.pointerEvents) || "", i.transform = s ? s(this.latestValues, "") : "none", i;
            let a = this.getLead();
            if (!this.projectionDelta || !this.layout || !a.target) {
              let t = {};
              return this.options.layoutId && (t.opacity = void 0 !== this.latestValues.opacity ? this.latestValues.opacity : 1, t.pointerEvents = aW(null == e ? void 0 : e.pointerEvents) || ""), this.hasProjected && !sQ(this.latestValues) && (t.transform = s ? s({}, "") : "none", this.hasProjected = !1), t
            }
            let o = a.animationValues || a.latestValues;
            this.applyTransformsToTarget(), i.transform = function(e, t, n) {
              let i = "",
                s = e.x.translate / t.x,
                a = e.y.translate / t.y,
                o = (null == n ? void 0 : n.z) || 0;
              if ((s || a || o) && (i = `translate3d(${s}px, ${a}px, ${o}px) `), (1 !== t.x || 1 !== t.y) && (i += `scale(${1/t.x}, ${1/t.y}) `), n) {
                let {
                  transformPerspective: e,
                  rotate: t,
                  rotateX: s,
                  rotateY: a,
                  skewX: o,
                  skewY: l
                } = n;
                e && (i = `perspective(${e}px) ${i}`), t && (i += `rotate(${t}deg) `), s && (i += `rotateX(${s}deg) `), a && (i += `rotateY(${a}deg) `), o && (i += `skewX(${o}deg) `), l && (i += `skewY(${l}deg) `)
              }
              let l = e.x.scale * t.x,
                c = e.y.scale * t.y;
              return (1 !== l || 1 !== c) && (i += `scale(${l}, ${c})`), i || "none"
            }(this.projectionDeltaWithTransform, this.treeScale, o), s && (i.transform = s(o, i.transform));
            let {
              x: l,
              y: c
            } = this.projectionDelta;
            for (let e in i.transformOrigin = `${100*l.origin}% ${100*c.origin}% 0`, a.animationValues ? i.opacity = a === this ? null !== (n = null !== (t = o.opacity) && void 0 !== t ? t : this.latestValues.opacity) && void 0 !== n ? n : 1 : this.preserveOpacity ? this.latestValues.opacity : o.opacityExit : i.opacity = a === this ? void 0 !== o.opacity ? o.opacity : "" : void 0 !== o.opacityExit ? o.opacityExit : 0, au) {
              if (void 0 === o[e]) continue;
              let {
                correct: t,
                applyTo: n
              } = au[e], s = "none" === i.transform ? o[e] : t(o[e], a);
              if (n) {
                let e = n.length;
                for (let t = 0; t < e; t++) i[n[t]] = s
              } else i[e] = s
            }
            return this.options.layoutId && (i.pointerEvents = a === this ? aW(null == e ? void 0 : e.pointerEvents) || "" : "none"), i
          }
          clearSnapshot() {
            this.resumeFrom = this.snapshot = void 0
          }
          resetTree() {
            this.root.nodes.forEach(e => {
              var t;
              return null === (t = e.currentAnimation) || void 0 === t ? void 0 : t.stop()
            }), this.root.nodes.forEach(a5), this.root.sharedNodes.clear()
          }
        }
      }

      function aQ(e) {
        e.updateLayout()
      }

      function aJ(e) {
        var t;
        let n = (null === (t = e.resumeFrom) || void 0 === t ? void 0 : t.snapshot) || e.snapshot;
        if (e.isLead() && e.layout && n && e.hasListeners("didUpdate")) {
          let {
            layoutBox: t,
            measuredBox: i
          } = e.layout, {
            animationType: s
          } = e.options, a = n.source !== e.layout.source;
          "size" === s ? sX(e => {
            let i = a ? n.measuredBox[e] : n.layoutBox[e],
              s = sR(i);
            i.min = t[e].min, i.max = i.min + s
          }) : ol(s, n.layoutBox, t) && sX(i => {
            let s = a ? n.measuredBox[i] : n.layoutBox[i],
              o = sR(t[i]);
            s.max = s.min + o, e.relativeTarget && !e.currentAnimation && (e.isProjectionDirty = !0, e.relativeTarget[i].max = e.relativeTarget[i].min + o)
          });
          let o = sZ();
          sD(o, t, n.layoutBox);
          let l = sZ();
          a ? sD(l, e.applyTransform(i, !0), n.measuredBox) : sD(l, t, n.layoutBox);
          let c = !aV(o),
            u = !1;
          if (!e.resumeFrom) {
            let i = e.getClosestProjectingParent();
            if (i && !i.resumeFrom) {
              let {
                snapshot: s,
                layout: a
              } = i;
              if (s && a) {
                let o = sq();
                sI(o, n.layoutBox, s.layoutBox);
                let l = sq();
                sI(l, t, a.layoutBox), aD(o, l) || (u = !0), i.options.layoutRoot && (e.relativeTarget = l, e.relativeTargetOrigin = o, e.relativeParent = i)
              }
            }
          }
          e.notifyListeners("didUpdate", {
            layout: t,
            snapshot: n,
            delta: l,
            layoutDelta: o,
            hasLayoutChanged: c,
            hasRelativeTargetChanged: u
          })
        } else if (e.isLead()) {
          let {
            onExitComplete: t
          } = e.options;
          t && t()
        }
        e.options.transition = void 0
      }

      function a1(e) {
        aU && aZ.totalNodes++, e.parent && (e.isProjecting() || (e.isProjectionDirty = e.parent.isProjectionDirty), e.isSharedProjectionDirty || (e.isSharedProjectionDirty = !!(e.isProjectionDirty || e.parent.isProjectionDirty || e.parent.isSharedProjectionDirty)), e.isTransformDirty || (e.isTransformDirty = e.parent.isTransformDirty))
      }

      function a0(e) {
        e.isProjectionDirty = e.isSharedProjectionDirty = e.isTransformDirty = !1
      }

      function a2(e) {
        e.clearSnapshot()
      }

      function a5(e) {
        e.clearMeasurements()
      }

      function a3(e) {
        e.isLayoutDirty = !1
      }

      function a4(e) {
        let {
          visualElement: t
        } = e.options;
        t && t.getProps().onBeforeLayoutMeasure && t.notify("BeforeLayoutMeasure"), e.resetTransform()
      }

      function a6(e) {
        e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0, e.isProjectionDirty = !0
      }

      function a7(e) {
        e.resolveTargetDelta()
      }

      function a9(e) {
        e.calcProjection()
      }

      function a8(e) {
        e.resetSkewAndRotation()
      }

      function oe(e) {
        e.removeLeadSnapshot()
      }

      function ot(e, t, n) {
        e.translate = iy(t.translate, 0, n), e.scale = iy(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint
      }

      function on(e, t, n, i) {
        e.min = iy(t.min, n.min, i), e.max = iy(t.max, n.max, i)
      }

      function or(e) {
        return e.animationValues && void 0 !== e.animationValues.opacityExit
      }
      let oi = {
          duration: .45,
          ease: [.4, 0, .1, 1]
        },
        os = e => "u" > typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().includes(e),
        oa = os("applewebkit/") && !os("chrome/") ? Math.round : nH;

      function oo(e) {
        e.min = oa(e.min), e.max = oa(e.max)
      }

      function ol(e, t, n) {
        return "position" === e || "preserve-aspect" === e && !(.2 >= Math.abs(aO(t) - aO(n)))
      }

      function oc(e) {
        var t;
        return e !== e.root && (null === (t = e.scroll) || void 0 === t ? void 0 : t.wasRoot)
      }
      let ou = aG({
          attachResizeListener: (e, t) => sb(e, "resize", t),
          measureScroll: () => ({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
          }),
          checkIsScrollRoot: () => !0
        }),
        od = {
          current: void 0
        },
        oh = aG({
          measureScroll: e => ({
            x: e.scrollLeft,
            y: e.scrollTop
          }),
          defaultParent: () => {
            if (!od.current) {
              let e = new ou({});
              e.mount(window), e.setOptions({
                layoutScroll: !0
              }), od.current = e
            }
            return od.current
          },
          resetTransform: (e, t) => {
            e.style.transform = void 0 !== t ? t : "none"
          },
          checkIsScrollRoot: e => "fixed" === window.getComputedStyle(e).position
        });

      function op(e, t) {
        let n = t ? "onHoverStart" : "onHoverEnd";
        return sC(e.current, t ? "pointerenter" : "pointerleave", (i, s) => {
          if ("touch" === i.pointerType || sA()) return;
          let a = e.getProps();
          e.animationState && a.whileHover && e.animationState.setActive("whileHover", t);
          let o = a[n];
          o && nF.postRender(() => o(i, s))
        }, {
          passive: !e.getProps()[n]
        })
      }
      class om extends sp {
        mount() {
          this.unmount = ig(op(this.node, !0), op(this.node, !1))
        }
        unmount() {}
      }
      class of extends sp {
        constructor() {
          super(...arguments), this.isActive = !1
        }
        onFocus() {
          let e = !1;
          try {
            e = this.node.current.matches(":focus-visible")
          } catch {
            e = !0
          }
          e && this.node.animationState && (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0)
        }
        onBlur() {
          this.isActive && this.node.animationState && (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1)
        }
        mount() {
          this.unmount = ig(sb(this.node.current, "focus", () => this.onFocus()), sb(this.node.current, "blur", () => this.onBlur()))
        }
        unmount() {}
      }
      let og = (e, t) => !!t && (e === t || og(e, t.parentElement));

      function ov(e, t) {
        if (!t) return;
        let n = new PointerEvent("pointer" + e);
        t(n, sy(n))
      }
      class oy extends sp {
        constructor() {
          super(...arguments), this.removeStartListeners = nH, this.removeEndListeners = nH, this.removeAccessibleListeners = nH, this.startPointerPress = (e, t) => {
            if (this.isPressing) return;
            this.removeEndListeners();
            let n = this.node.getProps(),
              i = sC(window, "pointerup", (e, t) => {
                if (!this.checkPressEnd()) return;
                let {
                  onTap: n,
                  onTapCancel: i,
                  globalTapTarget: s
                } = this.node.getProps(), a = s || og(this.node.current, e.target) ? n : i;
                a && nF.update(() => a(e, t))
              }, {
                passive: !(n.onTap || n.onPointerUp)
              }),
              s = sC(window, "pointercancel", (e, t) => this.cancelPress(e, t), {
                passive: !(n.onTapCancel || n.onPointerCancel)
              });
            this.removeEndListeners = ig(i, s), this.startPress(e, t)
          }, this.startAccessiblePress = () => {
            let e = sb(this.node.current, "keydown", e => {
                "Enter" !== e.key || this.isPressing || (this.removeEndListeners(), this.removeEndListeners = sb(this.node.current, "keyup", e => {
                  "Enter" === e.key && this.checkPressEnd() && ov("up", (e, t) => {
                    let {
                      onTap: n
                    } = this.node.getProps();
                    n && nF.postRender(() => n(e, t))
                  })
                }), ov("down", (e, t) => {
                  this.startPress(e, t)
                }))
              }),
              t = sb(this.node.current, "blur", () => {
                this.isPressing && ov("cancel", (e, t) => this.cancelPress(e, t))
              });
            this.removeAccessibleListeners = ig(e, t)
          }
        }
        startPress(e, t) {
          this.isPressing = !0;
          let {
            onTapStart: n,
            whileTap: i
          } = this.node.getProps();
          i && this.node.animationState && this.node.animationState.setActive("whileTap", !0), n && nF.postRender(() => n(e, t))
        }
        checkPressEnd() {
          return this.removeEndListeners(), this.isPressing = !1, this.node.getProps().whileTap && this.node.animationState && this.node.animationState.setActive("whileTap", !1), !sA()
        }
        cancelPress(e, t) {
          if (!this.checkPressEnd()) return;
          let {
            onTapCancel: n
          } = this.node.getProps();
          n && nF.postRender(() => n(e, t))
        }
        mount() {
          let e = this.node.getProps(),
            t = sC(e.globalTapTarget ? window : this.node.current, "pointerdown", this.startPointerPress, {
              passive: !(e.onTapStart || e.onPointerStart)
            }),
            n = sb(this.node.current, "focus", this.startAccessiblePress);
          this.removeStartListeners = ig(t, n)
        }
        unmount() {
          this.removeStartListeners(), this.removeEndListeners(), this.removeAccessibleListeners()
        }
      }
      let ox = new WeakMap,
        ob = new WeakMap,
        oC = e => {
          let t = ox.get(e.target);
          t && t(e)
        },
        ow = e => {
          e.forEach(oC)
        },
        oj = {
          some: 0,
          all: 1
        };
      class o_ extends sp {
        constructor() {
          super(...arguments), this.hasEnteredView = !1, this.isInView = !1
        }
        startObserver() {
          this.unmount();
          let {
            viewport: e = {}
          } = this.node.getProps(), {
            root: t,
            margin: n,
            amount: i = "some",
            once: s
          } = e, a = {
            root: t ? t.current : void 0,
            rootMargin: n,
            threshold: "number" == typeof i ? i : oj[i]
          };
          return function(e, t, n) {
            let i = function(e) {
              let {
                root: t,
                ...n
              } = e, i = t || document;
              ob.has(i) || ob.set(i, {});
              let s = ob.get(i),
                a = JSON.stringify(n);
              return s[a] || (s[a] = new IntersectionObserver(ow, {
                root: t,
                ...n
              })), s[a]
            }(t);
            return ox.set(e, n), i.observe(e), () => {
              ox.delete(e), i.unobserve(e)
            }
          }(this.node.current, a, e => {
            let {
              isIntersecting: t
            } = e;
            if (this.isInView === t || (this.isInView = t, s && !t && this.hasEnteredView)) return;
            t && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", t);
            let {
              onViewportEnter: n,
              onViewportLeave: i
            } = this.node.getProps(), a = t ? n : i;
            a && a(e)
          })
        }
        mount() {
          this.startObserver()
        }
        update() {
          if (typeof IntersectionObserver > "u") return;
          let {
            props: e,
            prevProps: t
          } = this.node;
          ["amount", "margin", "root"].some(function(e) {
            let {
              viewport: t = {}
            } = e, {
              viewport: n = {}
            } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return e => t[e] !== n[e]
          }(e, t)) && this.startObserver()
        }
        unmount() {}
      }
      let ok = (0, o.createContext)({
          transformPagePoint: e => e,
          isStatic: !1,
          reducedMotion: "never"
        }),
        oS = (0, o.createContext)({}),
        oE = o.useLayoutEffect,
        oP = (0, o.createContext)({
          strict: !1
        });

      function oM(e) {
        return ng(e.animate) || n_.some(t => nx(e[t]))
      }

      function oT(e) {
        return !!(oM(e) || e.variants)
      }

      function oL(e) {
        return Array.isArray(e) ? e.join(" ") : e
      }
      let oA = {
          animation: ["animate", "variants", "whileHover", "whileTap", "exit", "whileInView", "whileFocus", "whileDrag"],
          exit: ["exit"],
          drag: ["drag", "dragControls"],
          focus: ["whileFocus"],
          hover: ["whileHover", "onHoverStart", "onHoverEnd"],
          tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
          pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
          inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
          layout: ["layout", "layoutId"]
        },
        oV = {};
      for (let e in oA) oV[e] = {
        isEnabled: t => oA[e].some(e => !!t[e])
      };
      let oR = Symbol.for("motionComponentSymbol"),
        oN = ["animate", "circle", "defs", "desc", "ellipse", "g", "image", "line", "filter", "marker", "mask", "metadata", "path", "pattern", "polygon", "polyline", "rect", "stop", "switch", "symbol", "svg", "text", "tspan", "use", "view"];

      function oD(e) {
        return !("string" != typeof e || e.includes("-")) && !!(oN.indexOf(e) > -1 || /[A-Z]/u.test(e))
      }

      function oO(e, t, n, i) {
        let {
          style: s,
          vars: a
        } = t;
        for (let t in Object.assign(e.style, s, i && i.getProjectionStyles(n)), a) e.style.setProperty(t, a[t])
      }
      let oH = new Set(["baseFrequency", "diffuseConstant", "kernelMatrix", "kernelUnitLength", "keySplines", "keyTimes", "limitingConeAngle", "markerHeight", "markerWidth", "numOctaves", "targetX", "targetY", "surfaceScale", "specularConstant", "specularExponent", "stdDeviation", "tableValues", "viewBox", "gradientTransform", "pathLength", "startOffset", "textLength", "lengthAdjust"]);

      function oI(e, t, n, i) {
        for (let n in oO(e, t, void 0, i), t.attrs) e.setAttribute(oH.has(n) ? n : st(n), t.attrs[n])
      }

      function oB(e, t) {
        let {
          layout: n,
          layoutId: i
        } = t;
        return nS.has(e) || e.startsWith("origin") || (n || void 0 !== i) && (!!au[e] || "opacity" === e)
      }

      function oF(e, t, n) {
        var i;
        let {
          style: s
        } = e, a = {};
        for (let o in s)(sr(s[o]) || t.style && sr(t.style[o]) || oB(o, e) || (null === (i = null == n ? void 0 : n.getValue(o)) || void 0 === i ? void 0 : i.liveStyle) !== void 0) && (a[o] = s[o]);
        return a
      }

      function oW(e, t, n) {
        let i = oF(e, t, n);
        for (let n in e)(sr(e[n]) || sr(t[n])) && (i[-1 !== nk.indexOf(n) ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n] = e[n]);
        return i
      }

      function oz(e) {
        let t = (0, o.useRef)(null);
        return null === t.current && (t.current = e()), t.current
      }
      let o$ = e => (t, n) => {
          let i = (0, o.useContext)(oS),
            s = (0, o.useContext)(ai),
            a = () => (function(e, t, n, i) {
              let {
                scrapeMotionValuesFromProps: s,
                createRenderState: a,
                onMount: o
              } = e, l = {
                latestValues: function(e, t, n, i) {
                  let s = {},
                    a = i(e, {});
                  for (let e in a) s[e] = aW(a[e]);
                  let {
                    initial: o,
                    animate: l
                  } = e, c = oM(e), u = oT(e);
                  t && u && !c && !1 !== e.inherit && (void 0 === o && (o = t.initial), void 0 === l && (l = t.animate));
                  let d = !!n && !1 === n.initial,
                    h = (d = d || !1 === o) ? l : o;
                  if (h && "boolean" != typeof h && !ng(h)) {
                    let t = Array.isArray(h) ? h : [h];
                    for (let n = 0; n < t.length; n++) {
                      let i = nC(e, t[n]);
                      if (i) {
                        let {
                          transitionEnd: e,
                          transition: t,
                          ...n
                        } = i;
                        for (let e in n) {
                          let t = n[e];
                          if (Array.isArray(t)) {
                            let e = d ? t.length - 1 : 0;
                            t = t[e]
                          }
                          null !== t && (s[e] = t)
                        }
                        for (let t in e) s[t] = e[t]
                      }
                    }
                  }
                  return s
                }(t, n, i, s),
                renderState: a()
              };
              return o && (l.mount = e => o(t, e, l)), l
            })(e, t, i, s);
          return n ? a() : oz(a)
        },
        oZ = () => ({
          style: {},
          transform: {},
          transformOrigin: {},
          vars: {}
        }),
        oU = () => ({
          ...oZ(),
          attrs: {}
        }),
        oq = (e, t) => t && "number" == typeof e ? t.transform(e) : e,
        oX = {
          x: "translateX",
          y: "translateY",
          z: "translateZ",
          transformPerspective: "perspective"
        },
        oY = nk.length;

      function oK(e, t, n) {
        let {
          style: i,
          vars: s,
          transformOrigin: a
        } = e, o = !1, l = !1;
        for (let e in t) {
          let n = t[e];
          if (nS.has(e)) {
            o = !0;
            continue
          }
          if (n4(e)) {
            s[e] = n;
            continue
          } {
            let t = oq(n, rQ[e]);
            e.startsWith("origin") ? (l = !0, a[e] = t) : i[e] = t
          }
        }
        if (t.transform || (o || n ? i.transform = function(e, t, n) {
            let i = "",
              s = !0;
            for (let a = 0; a < oY; a++) {
              let o = nk[a],
                l = e[o];
              if (void 0 === l) continue;
              let c = !0;
              if (!(c = "number" == typeof l ? l === (o.startsWith("scale") ? 1 : 0) : 0 === parseFloat(l)) || n) {
                let e = oq(l, rQ[o]);
                if (!c) {
                  s = !1;
                  let t = oX[o] || o;
                  i += `${t}(${e}) `
                }
                n && (t[o] = e)
              }
            }
            return i = i.trim(), n ? i = n(t, s ? "" : i) : s && (i = "none"), i
          }(t, e.transform, n) : i.transform && (i.transform = "none")), l) {
          let {
            originX: e = "50%",
            originY: t = "50%",
            originZ: n = 0
          } = a;
          i.transformOrigin = `${e} ${t} ${n}`
        }
      }

      function oG(e, t, n) {
        return "string" == typeof e ? e : ro.transform(t + n * e)
      }
      let oQ = {
          offset: "stroke-dashoffset",
          array: "stroke-dasharray"
        },
        oJ = {
          offset: "strokeDashoffset",
          array: "strokeDasharray"
        };

      function o1(e, t, n, i) {
        let {
          attrX: s,
          attrY: a,
          attrScale: o,
          originX: l,
          originY: c,
          pathLength: u,
          pathSpacing: d = 1,
          pathOffset: h = 0,
          ...p
        } = t;
        if (oK(e, p, i), n) {
          e.style.viewBox && (e.attrs.viewBox = e.style.viewBox);
          return
        }
        e.attrs = e.style, e.style = {};
        let {
          attrs: m,
          style: f,
          dimensions: g
        } = e;
        m.transform && (g && (f.transform = m.transform), delete m.transform), g && (void 0 !== l || void 0 !== c || f.transform) && (f.transformOrigin = function(e, t, n) {
          let i = oG(t, e.x, e.width),
            s = oG(n, e.y, e.height);
          return `${i} ${s}`
        }(g, void 0 !== l ? l : .5, void 0 !== c ? c : .5)), void 0 !== s && (m.x = s), void 0 !== a && (m.y = a), void 0 !== o && (m.scale = o), void 0 !== u && function(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            s = !(arguments.length > 4) || void 0 === arguments[4] || arguments[4];
          e.pathLength = 1;
          let a = s ? oQ : oJ;
          e[a.offset] = ro.transform(-i);
          let o = ro.transform(t),
            l = ro.transform(n);
          e[a.array] = `${o} ${l}`
        }(m, u, d, h, !1)
      }
      let o0 = e => "string" == typeof e && "svg" === e.toLowerCase(),
        o2 = {
          useVisualState: o$({
            scrapeMotionValuesFromProps: oW,
            createRenderState: oU,
            onMount: (e, t, n) => {
              let {
                renderState: i,
                latestValues: s
              } = n;
              nF.read(() => {
                try {
                  i.dimensions = "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect()
                } catch {
                  i.dimensions = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                  }
                }
              }), nF.render(() => {
                o1(i, s, o0(t.tagName), e.transformTemplate), oI(t, i)
              })
            }
          })
        },
        o5 = {
          useVisualState: o$({
            scrapeMotionValuesFromProps: oF,
            createRenderState: oZ
          })
        };

      function o3(e, t, n) {
        for (let i in t) sr(t[i]) || oB(i, n) || (e[i] = t[i])
      }
      let o4 = new Set(["animate", "exit", "variants", "initial", "style", "values", "variants", "transition", "transformTemplate", "custom", "inherit", "onBeforeLayoutMeasure", "onAnimationStart", "onAnimationComplete", "onUpdate", "onDragStart", "onDrag", "onDragEnd", "onMeasureDragConstraints", "onDirectionLock", "onDragTransitionEnd", "_dragX", "_dragY", "onHoverStart", "onHoverEnd", "onViewportEnter", "onViewportLeave", "globalTapTarget", "ignoreStrict", "viewport"]);

      function o6(e) {
        return e.startsWith("while") || e.startsWith("drag") && "draggable" !== e || e.startsWith("layout") || e.startsWith("onTap") || e.startsWith("onPan") || e.startsWith("onLayout") || o4.has(e)
      }
      let o7 = e => !o6(e);
      try {
        (ca = require("@emotion/is-prop-valid").default) && (o7 = e => e.startsWith("on") ? !o6(e) : ca(e))
      } catch {}
      let o9 = {
          current: null
        },
        o8 = {
          current: !1
        };

      function le() {
        if (o8.current = !0, window.matchMedia) {
          let e = window.matchMedia("(prefers-reduced-motion)"),
            t = () => o9.current = e.matches;
          e.addListener(t), t()
        } else o9.current = !1
      }
      let lt = new WeakMap,
        ln = [...rx, rO, rU],
        lr = e => ln.find(ry(e)),
        li = ["AnimationStart", "AnimationComplete", "Update", "BeforeLayoutMeasure", "LayoutMeasure", "LayoutAnimationStart", "LayoutAnimationComplete"];
      class ls {
        scrapeMotionValuesFromProps(e, t, n) {
          return {}
        }
        constructor({
          parent: e,
          props: t,
          presenceContext: n,
          reducedMotionConfig: i,
          blockInitialAnimation: s,
          visualState: a
        }, o = {}) {
          this.current = null, this.children = new Set, this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.values = new Map, this.KeyframeResolver = rS, this.features = {}, this.valueSubscriptions = new Map, this.prevMotionValues = {}, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
            this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection))
          }, this.renderScheduledAt = 0, this.scheduleRender = () => {
            let e = r6.now();
            this.renderScheduledAt < e && (this.renderScheduledAt = e, nF.render(this.render, !1, !0))
          };
          let {
            latestValues: l,
            renderState: c
          } = a;
          this.latestValues = l, this.baseTarget = {
            ...l
          }, this.initialValues = t.initial ? {
            ...l
          } : {}, this.renderState = c, this.parent = e, this.props = t, this.presenceContext = n, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = i, this.options = o, this.blockInitialAnimation = !!s, this.isControllingVariants = oM(t), this.isVariantNode = oT(t), this.isVariantNode && (this.variantChildren = new Set), this.manuallyAnimateOnMount = !!(e && e.current);
          let {
            willChange: u,
            ...d
          } = this.scrapeMotionValuesFromProps(t, {}, this);
          for (let e in d) {
            let t = d[e];
            void 0 !== l[e] && sr(t) && t.set(l[e], !1)
          }
        }
        mount(e) {
          this.current = e, lt.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((e, t) => this.bindToMotionValue(t, e)), o8.current || le(), this.shouldReduceMotion = "never" !== this.reducedMotionConfig && ("always" === this.reducedMotionConfig || o9.current), this.parent && this.parent.children.add(this), this.update(this.props, this.presenceContext)
        }
        unmount() {
          for (let e in lt.delete(this.current), this.projection && this.projection.unmount(), nW(this.notifyUpdate), nW(this.render), this.valueSubscriptions.forEach(e => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent && this.parent.children.delete(this), this.events) this.events[e].clear();
          for (let e in this.features) {
            let t = this.features[e];
            t && (t.unmount(), t.isMounted = !1)
          }
          this.current = null
        }
        bindToMotionValue(e, t) {
          let n;
          this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
          let i = nS.has(e),
            s = t.on("change", t => {
              this.latestValues[e] = t, this.props.onUpdate && nF.preRender(this.notifyUpdate), i && this.projection && (this.projection.isTransformDirty = !0)
            }),
            a = t.on("renderRequest", this.scheduleRender);
          window.MotionCheckAppearSync && (n = window.MotionCheckAppearSync(this, e, t)), this.valueSubscriptions.set(e, () => {
            s(), a(), n && n(), t.owner && t.stop()
          })
        }
        sortNodePosition(e) {
          return this.current && this.sortInstanceNodePosition && this.type === e.type ? this.sortInstanceNodePosition(this.current, e.current) : 0
        }
        updateFeatures() {
          let e = "animation";
          for (e in oV) {
            let t = oV[e];
            if (!t) continue;
            let {
              isEnabled: n,
              Feature: i
            } = t;
            if (!this.features[e] && i && n(this.props) && (this.features[e] = new i(this)), this.features[e]) {
              let t = this.features[e];
              t.isMounted ? t.update() : (t.mount(), t.isMounted = !0)
            }
          }
        }
        triggerBuild() {
          this.build(this.renderState, this.latestValues, this.props)
        }
        measureViewportBox() {
          return this.current ? this.measureInstanceViewportBox(this.current, this.props) : sq()
        }
        getStaticValue(e) {
          return this.latestValues[e]
        }
        setStaticValue(e, t) {
          this.latestValues[e] = t
        }
        update(e, t) {
          (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = t;
          for (let t = 0; t < li.length; t++) {
            let n = li[t];
            this.propEventSubscriptions[n] && (this.propEventSubscriptions[n](), delete this.propEventSubscriptions[n]);
            let i = e["on" + n];
            i && (this.propEventSubscriptions[n] = this.on(n, i))
          }
          this.prevMotionValues = function(e, t, n) {
            for (let i in t) {
              let s = t[i],
                a = n[i];
              if (sr(s)) e.addValue(i, s);
              else if (sr(a)) e.addValue(i, se(s, {
                owner: e
              }));
              else if (a !== s) {
                if (e.hasValue(i)) {
                  let t = e.getValue(i);
                  !0 === t.liveStyle ? t.jump(s) : t.hasAnimated || t.set(s)
                } else {
                  let t = e.getStaticValue(i);
                  e.addValue(i, se(void 0 !== t ? t : s, {
                    owner: e
                  }))
                }
              }
            }
            for (let i in n) void 0 === t[i] && e.removeValue(i);
            return t
          }(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue()
        }
        getProps() {
          return this.props
        }
        getVariant(e) {
          return this.props.variants ? this.props.variants[e] : void 0
        }
        getDefaultTransition() {
          return this.props.transition
        }
        getTransformPagePoint() {
          return this.props.transformPagePoint
        }
        getClosestVariantNode() {
          return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0
        }
        addVariantChild(e) {
          let t = this.getClosestVariantNode();
          if (t) return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e)
        }
        addValue(e, t) {
          let n = this.values.get(e);
          t !== n && (n && this.removeValue(e), this.bindToMotionValue(e, t), this.values.set(e, t), this.latestValues[e] = t.get())
        }
        removeValue(e) {
          this.values.delete(e);
          let t = this.valueSubscriptions.get(e);
          t && (t(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState)
        }
        hasValue(e) {
          return this.values.has(e)
        }
        getValue(e, t) {
          if (this.props.values && this.props.values[e]) return this.props.values[e];
          let n = this.values.get(e);
          return void 0 === n && void 0 !== t && (n = se(null === t ? void 0 : t, {
            owner: this
          }), this.addValue(e, n)), n
        }
        readValue(e, t) {
          var n;
          let i = void 0 === this.latestValues[e] && this.current ? null !== (n = this.getBaseTargetFromProps(this.props, e)) && void 0 !== n ? n : this.readValueFromInstance(this.current, e, this.options) : this.latestValues[e];
          return null != i && ("string" == typeof i && (n5(i) || n2(i)) ? i = parseFloat(i) : !lr(i) && rU.test(t) && (i = r0(e, t)), this.setBaseTarget(e, sr(i) ? i.get() : i)), sr(i) ? i.get() : i
        }
        setBaseTarget(e, t) {
          this.baseTarget[e] = t
        }
        getBaseTarget(e) {
          var t;
          let n;
          let {
            initial: i
          } = this.props;
          if ("string" == typeof i || "object" == typeof i) {
            let s = nC(this.props, i, null === (t = this.presenceContext) || void 0 === t ? void 0 : t.custom);
            s && (n = s[e])
          }
          if (i && void 0 !== n) return n;
          let s = this.getBaseTargetFromProps(this.props, e);
          return void 0 === s || sr(s) ? void 0 !== this.initialValues[e] && void 0 === n ? void 0 : this.baseTarget[e] : s
        }
        on(e, t) {
          return this.events[e] || (this.events[e] = new i6), this.events[e].add(t)
        }
        notify(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++) n[i - 1] = arguments[i];
          this.events[e] && this.events[e].notify(...n)
        }
      }
      class la extends ls {
        constructor() {
          super(...arguments), this.KeyframeResolver = r5
        }
        sortInstanceNodePosition(e, t) {
          return 2 & e.compareDocumentPosition(t) ? 1 : -1
        }
        getBaseTargetFromProps(e, t) {
          return e.style ? e.style[t] : void 0
        }
        removeValueFromRenderState(e, t) {
          let {
            vars: n,
            style: i
          } = t;
          delete n[e], delete i[e]
        }
      }
      class lo extends la {
        constructor() {
          super(...arguments), this.type = "html", this.renderInstance = oO
        }
        readValueFromInstance(e, t) {
          if (nS.has(t)) {
            let e = r1(t);
            return e && e.default || 0
          } {
            let n = window.getComputedStyle(e),
              i = (n4(t) ? n.getPropertyValue(t) : n[t]) || 0;
            return "string" == typeof i ? i.trim() : i
          }
        }
        measureInstanceViewportBox(e, t) {
          let {
            transformPagePoint: n
          } = t;
          return s6(e, n)
        }
        build(e, t, n) {
          oK(e, t, n.transformTemplate)
        }
        scrapeMotionValuesFromProps(e, t, n) {
          return oF(e, t, n)
        }
        handleChildMotionValue() {
          this.childSubscription && (this.childSubscription(), delete this.childSubscription);
          let {
            children: e
          } = this.props;
          sr(e) && (this.childSubscription = e.on("change", e => {
            this.current && (this.current.textContent = `${e}`)
          }))
        }
      }
      class ll extends la {
        constructor() {
          super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = sq
        }
        getBaseTargetFromProps(e, t) {
          return e[t]
        }
        readValueFromInstance(e, t) {
          if (nS.has(t)) {
            let e = r1(t);
            return e && e.default || 0
          }
          return t = oH.has(t) ? t : st(t), e.getAttribute(t)
        }
        scrapeMotionValuesFromProps(e, t, n) {
          return oW(e, t, n)
        }
        build(e, t, n) {
          o1(e, t, this.isSVGTag, n.transformTemplate)
        }
        renderInstance(e, t, n, i) {
          oI(e, t, n, i)
        }
        mount(e) {
          this.isSVGTag = o0(e.tagName), super.mount(e)
        }
      }
      let lc = function(e) {
        if (typeof Proxy > "u") return e;
        let t = new Map;
        return new Proxy(function() {
          for (var t = arguments.length, n = Array(t), i = 0; i < t; i++) n[i] = arguments[i];
          return e(...n)
        }, {
          get: (n, i) => "create" === i ? e : (t.has(i) || t.set(i, e(i)), t.get(i))
        })
      }((co = {
        animation: {
          Feature: sm
        },
        exit: {
          Feature: sg
        },
        inView: {
          Feature: o_
        },
        tap: {
          Feature: oy
        },
        focus: {
          Feature: of
        },
        hover: {
          Feature: om
        },
        pan: {
          Feature: ar
        },
        drag: {
          Feature: at,
          ProjectionNode: oh,
          MeasureLayout: am
        },
        layout: {
          ProjectionNode: oh,
          MeasureLayout: am
        }
      }, cl = (e, t) => oD(e) ? new ll(t) : new lo(t, {
        allowProjection: e !== o.Fragment
      }), function(e) {
        let {
          forwardMotionProps: t
        } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
          forwardMotionProps: !1
        };
        return function(e) {
          let {
            preloadedFeatures: t,
            createVisualElement: n,
            useRender: i,
            useVisualState: s,
            Component: a
          } = e;
          t && function(e) {
            for (let t in e) oV[t] = {
              ...oV[t],
              ...e[t]
            }
          }(t);
          let l = (0, o.forwardRef)(function(e, t) {
            var l;
            let c;
            let u = {
                ...(0, o.useContext)(ok),
                ...e,
                layoutId: function(e) {
                  let {
                    layoutId: t
                  } = e, n = (0, o.useContext)(as).id;
                  return n && void 0 !== t ? n + "-" + t : t
                }(e)
              },
              {
                isStatic: d
              } = u,
              h = function(e) {
                let {
                  initial: t,
                  animate: n
                } = function(e, t) {
                  if (oM(e)) {
                    let {
                      initial: t,
                      animate: n
                    } = e;
                    return {
                      initial: !1 === t || nx(t) ? t : void 0,
                      animate: nx(n) ? n : void 0
                    }
                  }
                  return !1 !== e.inherit ? t : {}
                }(e, (0, o.useContext)(oS));
                return (0, o.useMemo)(() => ({
                  initial: t,
                  animate: n
                }), [oL(t), oL(n)])
              }(e),
              p = s(e, d);
            if (!d) {
              (0, o.useContext)(oP).strict;
              let e = function(e) {
                let {
                  drag: t,
                  layout: n
                } = oV;
                if (!t && !n) return {};
                let i = {
                  ...t,
                  ...n
                };
                return {
                  MeasureLayout: null != t && t.isEnabled(e) || null != n && n.isEnabled(e) ? i.MeasureLayout : void 0,
                  ProjectionNode: i.ProjectionNode
                }
              }(u);
              c = e.MeasureLayout, h.visualElement = function(e, t, n, i, s) {
                var a, l;
                let {
                  visualElement: c
                } = (0, o.useContext)(oS), u = (0, o.useContext)(oP), d = (0, o.useContext)(ai), h = (0, o.useContext)(ok).reducedMotion, p = (0, o.useRef)();
                i = i || u.renderer, !p.current && i && (p.current = i(e, {
                  visualState: t,
                  parent: c,
                  props: n,
                  presenceContext: d,
                  blockInitialAnimation: !!d && !1 === d.initial,
                  reducedMotionConfig: h
                }));
                let m = p.current,
                  f = (0, o.useContext)(aa);
                m && !m.projection && s && ("html" === m.type || "svg" === m.type) && function(e, t, n, i) {
                  let {
                    layoutId: s,
                    layout: a,
                    drag: o,
                    dragConstraints: l,
                    layoutScroll: c,
                    layoutRoot: u
                  } = t;
                  e.projection = new n(e.latestValues, t["data-framer-portal-id"] ? void 0 : function e(t) {
                    if (t) return !1 !== t.options.allowProjection ? t.projection : e(t.parent)
                  }(e.parent)), e.projection.setOptions({
                    layoutId: s,
                    layout: a,
                    alwaysMeasureLayout: !!o || l && sV(l),
                    visualElement: e,
                    animationType: "string" == typeof a ? a : "both",
                    initialPromotionConfig: i,
                    layoutScroll: c,
                    layoutRoot: u
                  })
                }(p.current, n, s, f);
                let g = (0, o.useRef)(!1);
                (0, o.useInsertionEffect)(() => {
                  m && g.current && m.update(n, d)
                });
                let v = n[sn],
                  y = (0, o.useRef)(!!v && !(!(null === (a = window.MotionHandoffIsComplete) || void 0 === a) && a.call(window, v)) && (null === (l = window.MotionHasOptimisedAnimation) || void 0 === l ? void 0 : l.call(window, v)));
                return oE(() => {
                  m && (g.current = !0, window.MotionIsMounted = !0, m.updateFeatures(), ad.render(m.render), y.current && m.animationState && m.animationState.animateChanges())
                }), (0, o.useEffect)(() => {
                  m && (!y.current && m.animationState && m.animationState.animateChanges(), y.current && (queueMicrotask(() => {
                    var e;
                    null === (e = window.MotionHandoffMarkAsComplete) || void 0 === e || e.call(window, v)
                  }), y.current = !1))
                }), m
              }(a, p, u, n, e.ProjectionNode)
            }
            return m.jsxs(oS.Provider, {
              value: h,
              children: [c && h.visualElement ? m.jsx(c, {
                visualElement: h.visualElement,
                ...u
              }) : null, i(a, e, (l = h.visualElement, (0, o.useCallback)(e => {
                e && p.mount && p.mount(e), l && (e ? l.mount(e) : l.unmount()), t && ("function" == typeof t ? t(e) : sV(t) && (t.current = e))
              }, [l])), p, d, h.visualElement)]
            })
          });
          return l[oR] = a, l
        }({
          ...oD(e) ? o2 : o5,
          preloadedFeatures: co,
          useRender: function() {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return (t, n, i, s, a) => {
              let {
                latestValues: l
              } = s, c = (oD(t) ? function(e, t, n, i) {
                let s = (0, o.useMemo)(() => {
                  let n = oU();
                  return o1(n, t, o0(i), e.transformTemplate), {
                    ...n.attrs,
                    style: {
                      ...n.style
                    }
                  }
                }, [t]);
                if (e.style) {
                  let t = {};
                  o3(t, e.style, e), s.style = {
                    ...t,
                    ...s.style
                  }
                }
                return s
              } : function(e, t) {
                let n = {},
                  i = function(e, t) {
                    let n = e.style || {},
                      i = {};
                    return o3(i, n, e), Object.assign(i, function(e, t) {
                      let {
                        transformTemplate: n
                      } = e;
                      return (0, o.useMemo)(() => {
                        let e = oZ();
                        return oK(e, t, n), Object.assign({}, e.vars, e.style)
                      }, [t])
                    }(e, t)), i
                  }(e, t);
                return e.drag && !1 !== e.dragListener && (n.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = !0 === e.drag ? "none" : `pan-${"x"===e.drag?"y":"x"}`), void 0 === e.tabIndex && (e.onTap || e.onTapStart || e.whileTap) && (n.tabIndex = 0), n.style = i, n
              })(n, l, a, t), u = function(e, t, n) {
                let i = {};
                for (let s in e) "values" === s && "object" == typeof e.values || (o7(s) || !0 === n && o6(s) || !t && !o6(s) || e.draggable && s.startsWith("onDrag")) && (i[s] = e[s]);
                return i
              }(n, "string" == typeof t, e), d = t !== o.Fragment ? {
                ...u,
                ...c,
                ref: i
              } : {}, {
                children: h
              } = n, p = (0, o.useMemo)(() => sr(h) ? h.get() : h, [h]);
              return (0, o.createElement)(t, {
                ...d,
                children: p
              })
            }
          }(t),
          createVisualElement: cl,
          Component: e
        })
      }));
      class lu extends o.Component {
        getSnapshotBeforeUpdate(e) {
          let t = this.props.childRef.current;
          if (t && e.isPresent && !this.props.isPresent) {
            let e = this.props.sizeRef.current;
            e.height = t.offsetHeight || 0, e.width = t.offsetWidth || 0, e.top = t.offsetTop, e.left = t.offsetLeft
          }
          return null
        }
        componentDidUpdate() {}
        render() {
          return this.props.children
        }
      }

      function ld(e) {
        let {
          children: t,
          isPresent: n
        } = e, i = (0, o.useId)(), s = (0, o.useRef)(null), a = (0, o.useRef)({
          width: 0,
          height: 0,
          top: 0,
          left: 0
        }), {
          nonce: l
        } = (0, o.useContext)(ok);
        return (0, o.useInsertionEffect)(() => {
          let {
            width: e,
            height: t,
            top: o,
            left: c
          } = a.current;
          if (n || !s.current || !e || !t) return;
          s.current.dataset.motionPopId = i;
          let u = document.createElement("style");
          return l && (u.nonce = l), document.head.appendChild(u), u.sheet && u.sheet.insertRule(`
          [data-motion-pop-id="${i}"] {
            position: absolute !important;
            width: ${e}px !important;
            height: ${t}px !important;
            top: ${o}px !important;
            left: ${c}px !important;
          }
        `), () => {
            document.head.removeChild(u)
          }
        }, [n]), m.jsx(lu, {
          isPresent: n,
          childRef: s,
          sizeRef: a,
          children: o.cloneElement(t, {
            ref: s
          })
        })
      }
      let lh = e => {
        let {
          children: t,
          initial: n,
          isPresent: i,
          onExitComplete: s,
          custom: a,
          presenceAffectsLayout: l,
          mode: c
        } = e, u = oz(lp), d = (0, o.useId)(), h = (0, o.useCallback)(e => {
          for (let t of (u.set(e, !0), u.values()))
            if (!t) return;
          s && s()
        }, [u, s]), p = (0, o.useMemo)(() => ({
          id: d,
          initial: n,
          isPresent: i,
          custom: a,
          onExitComplete: h,
          register: e => (u.set(e, !1), () => u.delete(e))
        }), l ? [Math.random(), h] : [i, h]);
        return (0, o.useMemo)(() => {
          u.forEach((e, t) => u.set(t, !1))
        }, [i]), o.useEffect(() => {
          i || u.size || !s || s()
        }, [i]), "popLayout" === c && (t = m.jsx(ld, {
          isPresent: i,
          children: t
        })), m.jsx(ai.Provider, {
          value: p,
          children: t
        })
      };

      function lp() {
        return new Map
      }
      let lm = e => e.key || "";

      function lf(e) {
        let t = [];
        return o.Children.forEach(e, e => {
          (0, o.isValidElement)(e) && t.push(e)
        }), t
      }
      let lg = e => {
        let {
          children: t,
          exitBeforeEnter: n,
          custom: i,
          initial: s = !0,
          onExitComplete: a,
          presenceAffectsLayout: l = !0,
          mode: c = "sync"
        } = e;
        nH(!n, "Replace exitBeforeEnter with mode='wait'");
        let u = (0, o.useMemo)(() => lf(t), [t]),
          d = u.map(lm),
          h = (0, o.useRef)(!0),
          p = (0, o.useRef)(u),
          f = oz(() => new Map),
          [g, v] = (0, o.useState)(u),
          [y, x] = (0, o.useState)(u);
        oE(() => {
          h.current = !1, p.current = u;
          for (let e = 0; e < y.length; e++) {
            let t = lm(y[e]);
            d.includes(t) ? f.delete(t) : !0 !== f.get(t) && f.set(t, !1)
          }
        }, [y, d.length, d.join("-")]);
        let b = [];
        if (u !== g) {
          let e = [...u];
          for (let t = 0; t < y.length; t++) {
            let n = y[t],
              i = lm(n);
            d.includes(i) || (e.splice(t, 0, n), b.push(n))
          }
          "wait" === c && b.length && (e = b), x(lf(e)), v(u);
          return
        }
        let {
          forceRender: C
        } = (0, o.useContext)(as);
        return m.jsx(m.Fragment, {
          children: y.map(e => {
            let t = lm(e),
              n = u === y || d.includes(t);
            return m.jsx(lh, {
              isPresent: n,
              initial: (!h.current || !!s) && void 0,
              custom: n ? void 0 : i,
              presenceAffectsLayout: l,
              mode: c,
              onExitComplete: n ? void 0 : () => {
                if (!f.has(t)) return;
                f.set(t, !0);
                let e = !0;
                f.forEach(t => {
                  t || (e = !1)
                }), e && (null == C || C(), x(p.current), a && a())
              },
              children: e
            }, t)
          })
        })
      };

      function lv(e) {
        let t = oz(() => se(e)),
          {
            isStatic: n
          } = (0, o.useContext)(ok);
        if (n) {
          let [, n] = (0, o.useState)(e);
          (0, o.useEffect)(() => t.on("change", n), [])
        }
        return t
      }

      function ly(e, t) {
        let n = lv(t()),
          i = () => n.set(t());
        return i(), oE(() => {
          let t = () => nF.preRender(i, !1, !0),
            n = e.map(e => e.on("change", t));
          return () => {
            n.forEach(e => e()), nW(i)
          }
        }), n
      }
      let lx = e => e && "object" == typeof e && e.mix,
        lb = e => lx(e) ? e.mix : void 0;

      function lC(e, t, n, i) {
        if ("function" == typeof e) return function(e) {
          i9.current = [], e();
          let t = ly(i9.current, e);
          return i9.current = void 0, t
        }(e);
        let s = "function" == typeof t ? t : function() {
          for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          let i = !Array.isArray(t[0]),
            s = i ? 0 : -1,
            a = t[0 + s],
            o = t[1 + s],
            l = t[2 + s],
            c = t[3 + s],
            u = iV(o, l, {
              mixer: lb(l[0]),
              ...c
            });
          return i ? u(a) : u
        }(t, n, i);
        return Array.isArray(e) ? lw(e, s) : lw([e], e => {
          let [t] = e;
          return s(t)
        })
      }

      function lw(e, t) {
        let n = oz(() => []);
        return ly(e, () => {
          n.length = 0;
          let i = e.length;
          for (let t = 0; t < i; t++) n[t] = e[t].get();
          return t(n)
        })
      }

      function lj(e) {
        return "object" == typeof e && !Array.isArray(e)
      }

      function l_(e, t, n, i) {
        return "string" == typeof e && lj(t) ? function(e, t, n) {
          var i;
          if ("string" == typeof e) {
            let s = document;
            t && (nH(!!t.current, "Scope provided, but no element detected."), s = t.current), n ? (null !== (i = n[e]) && void 0 !== i || (n[e] = s.querySelectorAll(e)), e = n[e]) : e = s.querySelectorAll(e)
          } else e instanceof Element && (e = [e]);
          return Array.from(e || [])
        }(e, n, i) : e instanceof NodeList ? Array.from(e) : Array.isArray(e) ? e : [e]
      }

      function lk(e, t, n, i) {
        var s;
        return "number" == typeof t ? t : t.startsWith("-") || t.startsWith("+") ? Math.max(0, e + parseFloat(t)) : "<" === t ? n : null !== (s = i.get(t)) && void 0 !== s ? s : e
      }
      let lS = (e, t, n) => {
        let i = t - e;
        return ((n - e) % i + i) % i + e
      };

      function lE(e, t) {
        return e.at === t.at ? null === e.value ? 1 : null === t.value ? -1 : 0 : e.at - t.at
      }

      function lP(e, t) {
        return t.has(e) || t.set(e, {}), t.get(e)
      }

      function lM(e, t) {
        return t[e] || (t[e] = []), t[e]
      }
      let lT = e => "number" == typeof e,
        lL = e => e.every(lT);
      class lA extends ls {
        constructor() {
          super(...arguments), this.type = "object"
        }
        readValueFromInstance(e, t) {
          if (t in e) {
            let n = e[t];
            if ("string" == typeof n || "number" == typeof n) return n
          }
        }
        getBaseTargetFromProps() {}
        removeValueFromRenderState(e, t) {
          delete t.output[e]
        }
        measureInstanceViewportBox() {
          return sq()
        }
        build(e, t) {
          Object.assign(e.output, t)
        }
        renderInstance(e, t) {
          let {
            output: n
          } = t;
          Object.assign(e, n)
        }
        sortInstanceNodePosition() {
          return 0
        }
      }

      function lV(e) {
        let t = {
            presenceContext: null,
            props: {},
            visualState: {
              renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
              },
              latestValues: {}
            }
          },
          n = az(e) ? new ll(t) : new lo(t);
        n.mount(e), lt.set(e, n)
      }

      function lR(e) {
        let t = new lA({
          presenceContext: null,
          props: {},
          visualState: {
            renderState: {
              output: {}
            },
            latestValues: {}
          }
        });
        t.mount(e), lt.set(e, t)
      }

      function lN(e, t, n, i) {
        let s = [];
        if (sr(e) || "number" == typeof e || "string" == typeof e && !lj(t)) s.push(a$(e, lj(t) && t.default || t, n && (n.default || n)));
        else {
          let a = l_(e, t, i),
            o = a.length;
          nH(!!o, "No valid elements provided.");
          for (let e = 0; e < o; e++) {
            let i = a[e],
              l = i instanceof Element ? lV : lR;
            lt.has(i) || l(i);
            let c = lt.get(i),
              u = {
                ...n
              };
            "delay" in u && "function" == typeof u.delay && (u.delay = u.delay(e, o)), s.push(...ss(c, {
              ...t,
              transition: u
            }, {}))
          }
        }
        return s
      }
      let lD = function(e, t, n) {
          let i = new i1(Array.isArray(e) && Array.isArray(e[0]) ? function(e, t, n) {
            let i = [];
            return (function(e) {
              let {
                defaultTransition: t = {},
                ...n
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, i = arguments.length > 2 ? arguments[2] : void 0, s = arguments.length > 3 ? arguments[3] : void 0, a = t.duration || .3, o = new Map, l = new Map, c = {}, u = new Map, d = 0, h = 0, p = 0;
              for (let n = 0; n < e.length; n++) {
                let o = e[n];
                if ("string" == typeof o) {
                  u.set(o, h);
                  continue
                }
                if (!Array.isArray(o)) {
                  u.set(o.name, lk(h, o.at, d, u));
                  continue
                }
                let [m, f, g = {}] = o;
                void 0 !== g.at && (h = lk(h, g.at, d, u));
                let v = 0,
                  y = function(e, n, i) {
                    let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
                      l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                      c = Array.isArray(e) ? e : [e],
                      {
                        delay: u = 0,
                        times: d = iN(c),
                        type: m = "keyframes",
                        ...f
                      } = n,
                      {
                        ease: g = t.ease || "easeOut",
                        duration: y
                      } = n,
                      x = "function" == typeof u ? u(o, l) : u,
                      b = c.length,
                      C = r3(m) ? m : null == s ? void 0 : s[m];
                    if (b <= 2 && C) {
                      let e = 100;
                      2 === b && lL(c) && (e = Math.abs(c[1] - c[0]));
                      let t = {
                        ...f
                      };
                      void 0 !== y && (t.duration = nE(y));
                      let n = function(e) {
                        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100,
                          n = arguments.length > 2 ? arguments[2] : void 0,
                          i = n({
                            ...e,
                            keyframes: [0, t]
                          }),
                          s = Math.min(iO(i), 2e4);
                        return {
                          type: "keyframes",
                          ease: e => i.next(s * e).value / t,
                          duration: nP(s)
                        }
                      }(t, e, C);
                      g = n.ease, y = n.duration
                    }
                    y ?? (y = a);
                    let w = h + x,
                      j = w + y;
                    1 === d.length && 0 === d[0] && (d[1] = 1);
                    let _ = d.length - c.length;
                    _ > 0 && iR(d, _), 1 === c.length && c.unshift(null),
                      function(e, t, n, i, s, a) {
                        ! function(e, t, n) {
                          for (let i = 0; i < e.length; i++) {
                            let s = e[i];
                            s.at > t && s.at < n && (i4(e, s), i--)
                          }
                        }(e, s, a);
                        for (let l = 0; l < t.length; l++) {
                          var o;
                          e.push({
                            value: t[l],
                            at: iy(s, a, i[l]),
                            easing: (o = l, iu(n) ? n[lS(0, n.length, o)] : n)
                          })
                        }
                      }(i, c, g, d, w, j), v = Math.max(x + y, v), p = Math.max(j, p)
                  };
                if (sr(m)) y(f, g, lM("default", lP(m, l)));
                else {
                  let e = l_(m, f, i, c),
                    t = e.length;
                  for (let n = 0; n < t; n++) {
                    let i = lP(e[n], l);
                    for (let e in f) y(f[e], g && g[e] ? {
                      ...g,
                      ...g[e]
                    } : {
                      ...g
                    }, lM(e, i), n, t)
                  }
                }
                d = h, h += v
              }
              return l.forEach((e, i) => {
                for (let s in e) {
                  let a = e[s];
                  a.sort(lE);
                  let l = [],
                    c = [],
                    u = [];
                  for (let e = 0; e < a.length; e++) {
                    let {
                      at: t,
                      value: n,
                      easing: i
                    } = a[e];
                    l.push(n), c.push(iv(0, p, t)), u.push(i || "easeOut")
                  }
                  0 !== c[0] && (c.unshift(0), l.unshift(l[0]), u.unshift("easeInOut")), 1 !== c[c.length - 1] && (c.push(1), l.push(null)), o.has(i) || o.set(i, {
                    keyframes: {},
                    transition: {}
                  });
                  let d = o.get(i);
                  d.keyframes[s] = l, d.transition[s] = {
                    ...t,
                    duration: p,
                    ease: u,
                    times: c,
                    ...n
                  }
                }
              }), o
            })(e, t, n, {
              spring: is
            }).forEach((e, t) => {
              let {
                keyframes: n,
                transition: s
              } = e;
              i.push(...lN(t, n, s))
            }), i
          }(e, t, void 0) : lN(e, t, n, cc));
          return cc && cc.animations.push(i), i
        },
        lO = o.useLayoutEffect;

      function lH() {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        return function() {
          for (var e = arguments.length, n = Array(e), i = 0; i < e; i++) n[i] = arguments[i];
          for (let e of t) "function" == typeof e && e(...n)
        }
      }
      let lI = new Map,
        lB = new Set;

      function lF() {
        let e = t => {
          let n = lI.get(t.target);
          if (n && (n.delete(t.propertyName), 0 === n.size && (t.target.removeEventListener("transitioncancel", e), lI.delete(t.target)), 0 === lI.size)) {
            for (let e of lB) e();
            lB.clear()
          }
        };
        document.body.addEventListener("transitionrun", t => {
          let n = lI.get(t.target);
          n || (n = new Set, lI.set(t.target, n), t.target.addEventListener("transitioncancel", e)), n.add(t.propertyName)
        }), document.body.addEventListener("transitionend", e)
      }

      function lW(e) {
        for (lz(e) && (e = e.parentElement); e && !lz(e);) e = e.parentElement;
        return e || document.scrollingElement || document.documentElement
      }

      function lz(e) {
        let t = window.getComputedStyle(e);
        return /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY)
      }

      function l$(e) {
        var t;
        return null != window.navigator && e.test((null === (t = window.navigator.userAgentData) || void 0 === t ? void 0 : t.platform) || window.navigator.platform)
      }

      function lZ() {
        return (lZ = Object.assign ? Object.assign.bind() : function(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
          }
          return e
        }).apply(this, arguments)
      }

      function lU(e, t) {
        if (null == e) return {};
        var n, i, s = {},
          a = Object.keys(e);
        for (i = 0; i < a.length; i++) n = a[i], t.indexOf(n) >= 0 || (s[n] = e[n]);
        return s
      }
      "u" > typeof document && ("loading" !== document.readyState ? lF() : document.addEventListener("DOMContentLoaded", lF));
      var lq = "calc(100% - env(safe-area-inset-top) - 34px)",
        lX = {
          ease: "easeOut",
          duration: .2
        },
        lY = {
          ease: "linear",
          duration: .01
        };

      function lK(e, t) {
        for (var n = e[0], i = Math.abs(e[0] - t), s = 1; s < e.length; s++) {
          var a = Math.abs(e[s] - t);
          a < i && (n = e[s], i = a)
        }
        return n
      }

      function lG(e) {
        var t = document.querySelector("body"),
          n = document.getElementById(e);
        n && (n.style.removeProperty("border-top-right-radius"), n.style.removeProperty("border-top-left-radius"), n.style.removeProperty("transform"), n.addEventListener("transitionend", function e() {
          n.style.removeProperty("overflow"), n.style.removeProperty("will-change"), n.style.removeProperty("transition"), t.style.removeProperty("background-color"), n.removeEventListener("transitionend", e)
        }))
      }

      function lQ(e) {
        var t = e.snapTo,
          n = e.sheetHeight;
        return t < 0 && console.warn("Snap point is out of bounds. Sheet height is " + n + " but snap point is " + (n + Math.abs(t)) + "."), Math.max(Math.round(t), 0)
      }

      function lJ(e) {
        return function(t) {
          e.forEach(function(e) {
            "function" == typeof e ? e(t) : e && (e.current = t)
          })
        }
      }
      var l1 = o.useLayoutEffect;

      function l0(e) {
        var t = (0, o.useRef)();
        return (0, o.useEffect)(function() {
          t.current = e
        }), t.current
      }

      function l2(e) {
        var t = (0, o.useRef)();
        return l1(function() {
          t.current = e
        }), (0, o.useCallback)(function() {
          for (var e = t.current, n = arguments.length, i = Array(n), s = 0; s < n; s++) i[s] = arguments[s];
          return null == e ? void 0 : e.apply(void 0, i)
        }, [])
      }
      var l5 = {
        bottom: 0,
        top: 0,
        left: 0,
        right: 0
      };

      function l3() {
        return {
          constraintsRef: (0, o.useRef)(null),
          onMeasureDragConstraints: (0, o.useCallback)(function() {
            return l5
          }, [])
        }
      }
      var l4 = (0, o.createContext)(void 0),
        l6 = function() {
          var e = (0, o.useContext)(l4);
          if (!e) throw Error("Sheet context error");
          return e
        },
        l7 = (0, o.createContext)(void 0);

      function l9(e) {
        var t = e.children,
          n = l6(),
          i = (0, o.useState)(!!n.disableDrag),
          s = i[0],
          a = i[1];
        return (0, o.createElement)(l7.Provider, {
          value: {
            disableDrag: s,
            setDragEnabled: function() {
              n.disableDrag || a(!1)
            },
            setDragDisabled: function() {
              s || a(!0)
            }
          }
        }, t)
      }
      var l8, ce, ct, cn, cr, ci, cs, ca, co, cl, cc, cu, cd = function() {
          var e = (0, o.useContext)(l7);
          if (!e) throw Error("Sheet scroller context error");
          return e
        },
        ch = window.visualViewport,
        cp = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]),
        cm = 0;

      function cf(e, t, n) {
        var i = e.style[t];
        return e.style[t] = n,
          function() {
            e.style[t] = i
          }
      }

      function cg(e, t, n, i) {
        return e.addEventListener(t, n, i),
          function() {
            e.removeEventListener(t, n, i)
          }
      }

      function cv(e) {
        for (var t = document.scrollingElement || document.documentElement; e && e !== t;) {
          var n = lW(e);
          if (n !== document.documentElement && n !== document.body && n !== e) {
            var i = n.getBoundingClientRect().top,
              s = e.getBoundingClientRect().top;
            s > i + e.clientHeight && (n.scrollTop += s - i)
          }
          e = n.parentElement
        }
      }

      function cy(e) {
        return e instanceof HTMLInputElement && !cp.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable
      }
      var cx = {
          wrapper: {
            position: "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            overflow: "hidden",
            pointerEvents: "none"
          },
          backdrop: {
            zIndex: 1,
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            touchAction: "none",
            border: "none"
          },
          container: {
            zIndex: 2,
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "100%",
            backgroundColor: "#fff",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            boxShadow: "0px -2px 16px rgba(0, 0, 0, 0.3)",
            display: "flex",
            flexDirection: "column",
            pointerEvents: "auto"
          },
          headerWrapper: {
            width: "100%"
          },
          header: {
            height: "40px",
            width: "100%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          indicator: {
            width: "18px",
            height: "4px",
            borderRadius: "99px",
            backgroundColor: "#ddd"
          },
          content: {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: "0px",
            position: "relative"
          },
          scroller: {
            height: "100%",
            overflowY: "auto"
          }
        },
        cb = ["onOpenStart", "onOpenEnd", "onClose", "onCloseStart", "onCloseEnd", "onSnap", "children", "disableScrollLocking", "isOpen", "snapPoints", "rootId", "mountPoint", "style", "detent", "initialSnap", "disableDrag", "prefersReducedMotion", "tweenConfig"],
        cC = (0, o.forwardRef)(function(e, t) {
          var n, i, s, a, l, u = e.onOpenStart,
            d = e.onOpenEnd,
            h = e.onClose,
            p = e.onCloseStart,
            m = e.onCloseEnd,
            f = e.onSnap,
            g = e.children,
            v = e.disableScrollLocking,
            y = e.isOpen,
            x = e.snapPoints,
            b = e.rootId,
            C = e.mountPoint,
            w = e.style,
            j = e.detent,
            _ = void 0 === j ? "full-height" : j,
            k = e.initialSnap,
            S = void 0 === k ? 0 : k,
            E = e.disableDrag,
            P = void 0 !== E && E,
            M = e.prefersReducedMotion,
            T = e.tweenConfig,
            L = lU(e, cb),
            A = (0, o.useRef)(null),
            V = lv(0),
            R = (i = (n = (0, o.useState)(0))[0], s = n[1], l1(function() {
              var e = function() {
                return s(window.innerHeight)
              };
              return window.addEventListener("resize", e), e(),
                function() {
                  return window.removeEventListener("resize", e)
                }
            }, []), i),
            N = function() {
              o8.current || le();
              let [e] = (0, o.useState)(o9.current);
              return e
            }(),
            D = !!(void 0 !== M && M || N),
            O = lZ({
              type: "tween"
            }, D ? lY : void 0 === T ? lX : T),
            H = lv(0),
            I = lC(H, function(e) {
              return e >= R ? -1 : 9999999
            }),
            B = lC(H, function(e) {
              return e >= R ? "hidden" : "visible"
            }),
            F = (0, o.useRef)({
              onOpenStart: u,
              onOpenEnd: d,
              onCloseStart: p,
              onCloseEnd: m
            });
          l1(function() {
            F.current = {
              onOpenStart: u,
              onOpenEnd: d,
              onCloseStart: p,
              onCloseEnd: m
            }
          }), x && console.assert(function(e) {
            for (var t = 0; t < e.length; t++)
              if (e[t + 1] > e[t]) return !1;
            return !0
          }(x = x.map(function(e) {
            return e > 0 && e <= 1 ? Math.round(e * R) : e < 0 ? R + e : e
          })) || 0 === R, "Snap points need to be in descending order got: [" + x + "]");
          var W = l2(function(e, t) {
              var n = t.delta,
                i = H.getVelocity();
              i > 0 && V.set(10), i < 0 && V.set(-10), H.set(Math.max(H.get() + n.y, 0))
            }),
            z = l2(function(e, t) {
              if (t.velocity.y > 500) h();
              else {
                var n = A.current.getBoundingClientRect().height,
                  i = H.get(),
                  s = 0;
                if (x) {
                  var a = x.map(function(e) {
                    return n - Math.min(e, n)
                  });
                  "content-height" !== _ || a.includes(0) || a.unshift(0), s = lK(a, i)
                } else i / n > .6 && (s = n);
                if (lD(H, s = lQ({
                    snapTo: s,
                    sheetHeight: n
                  }), O), x && f) {
                  var o = Math.abs(Math.round(x[0] - s));
                  f(x.indexOf(lK(x, o)))
                }
                s >= Math.round(n) && h()
              }
              V.set(0)
            });
          (0, o.useEffect)(function() {
            x && f && f(y ? S : x.length - 1)
          }, [y]), (0, o.useImperativeHandle)(t, function() {
            return {
              y: H,
              snapTo: function(e) {
                var t = A.current;
                if (x && void 0 !== x[e] && null !== t) {
                  var n = t.getBoundingClientRect().height,
                    i = lQ({
                      snapTo: n - x[e],
                      sheetHeight: n
                    });
                  lD(H, i, O), f && f(e), i >= n && h()
                }
              }
            }
          }), a = l0(y), (0, o.useEffect)(function() {
            b && !a && y ? function(e) {
              var t = document.querySelector("body"),
                n = document.querySelector("#" + e);
              if (n) {
                var i = window.innerHeight;
                t.style.backgroundColor = "#000", n.style.overflow = "hidden", n.style.willChange = "transform", n.style.transition = "transform 200ms ease-in-out, border-radius 200ms linear", n.style.transform = "translateY(calc(env(safe-area-inset-top) + 12px)) scale(" + (i - 24) / i + ")", n.style.borderTopRightRadius = "10px", n.style.borderTopLeftRadius = "10px"
              }
            }(b) : b && !y && a && lG(b)
          }, [y, a]), (0, o.useEffect)(function() {
            return function() {
              b && y && lG(b)
            }
          }, [y]), lO(function() {
            if (!l) {
              var e, t, n, i, s, a;
              return 1 == ++cm && (l$(/^iPhone/i) || l$(/^iPad/i) || l$(/^Mac/i) && navigator.maxTouchPoints > 1 ? (t = 0, n = window.pageXOffset, i = window.pageYOffset, s = lH(cf(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"), cf(document.documentElement, "overflow", "hidden"), cf(document.body, "marginTop", "-" + i + "px")), window.scrollTo(0, 0), a = lH(cg(document, "touchstart", function(n) {
                  (e = lW(n.target)) === document.documentElement && e === document.body || (t = n.changedTouches[0].pageY)
                }, {
                  passive: !1,
                  capture: !0
                }), cg(document, "touchmove", function(n) {
                  if (void 0 !== e) {
                    if (e === document.documentElement || e === document.body) {
                      n.preventDefault();
                      return
                    }
                    var i = n.changedTouches[0].pageY,
                      s = e.scrollTop,
                      a = e.scrollHeight - e.clientHeight;
                    0 !== a && ((s <= 0 && i > t || s >= a && i < t) && n.preventDefault(), t = i)
                  }
                }, {
                  passive: !1,
                  capture: !0
                }), cg(document, "touchend", function(e) {
                  var t = e.target;
                  cy(t) && t !== document.activeElement && (e.preventDefault(), t.style.transform = "translateY(-2000px)", t.focus(), requestAnimationFrame(function() {
                    t.style.transform = ""
                  }))
                }, {
                  passive: !1,
                  capture: !0
                }), cg(document, "focus", function(e) {
                  var t = e.target;
                  cy(t) && (t.style.transform = "translateY(-2000px)", requestAnimationFrame(function() {
                    t.style.transform = "", ch && (ch.height < window.innerHeight ? requestAnimationFrame(function() {
                      cv(t)
                    }) : ch.addEventListener("resize", function() {
                      return cv(t)
                    }, {
                      once: !0
                    }))
                  }))
                }, !0), cg(window, "scroll", function() {
                  window.scrollTo(0, 0)
                })), cu = function() {
                  s(), a(), window.scrollTo(n, i)
                }) : cu = lH(cf(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"), cf(document.documentElement, "overflow", "hidden"))),
                function() {
                  0 == --cm && cu()
                }
            }
          }, [l = !0 === (void 0 !== v && v) || !y]);
          var $ = (0, o.useMemo)(function() {
              return P ? void 0 : {
                drag: "y",
                dragElastic: 0,
                dragMomentum: !1,
                dragPropagation: !1,
                onDrag: W,
                onDragEnd: z
              }
            }, [P]),
            Z = {
              y: H,
              sheetRef: A,
              isOpen: y,
              initialSnap: S,
              snapPoints: x,
              detent: _,
              indicatorRotation: V,
              callbacks: F,
              dragProps: $,
              windowHeight: R,
              animationOptions: O,
              reduceMotion: D,
              disableDrag: P
            },
            U = (0, o.createElement)(l4.Provider, {
              value: Z
            }, (0, o.createElement)(lc.div, Object.assign({}, L, {
              ref: t,
              style: lZ({}, cx.wrapper, {
                zIndex: I,
                visibility: B
              }, w)
            }), (0, o.createElement)(lg, null, y ? (0, o.createElement)(l9, null, o.Children.map(g, function(e, t) {
              return (0, o.cloneElement)(e, {
                key: "sheet-child-" + t
              })
            })) : null)));
          return (0, c.createPortal)(U, C ?? document.body)
        }),
        cw = ["children", "style", "className"],
        cj = (0, o.forwardRef)(function(e, t) {
          var n, i, s, a = e.children,
            l = e.style,
            c = e.className,
            u = lU(e, cw),
            d = l6(),
            h = d.y,
            p = d.isOpen,
            m = d.callbacks,
            f = d.snapPoints,
            g = d.initialSnap,
            v = d.sheetRef,
            y = d.windowHeight,
            x = d.detent,
            b = d.animationOptions,
            C = d.reduceMotion,
            w = (n = l0(p), i = (0, o.useRef)(!1), s = (0, o.useCallback)(function() {
              i.current ? (null == m.current.onCloseEnd || m.current.onCloseEnd(), i.current = !1) : (null == m.current.onOpenEnd || m.current.onOpenEnd(), i.current = !0)
            }, [p, n]), (0, o.useEffect)(function() {
              !n && p ? null == m.current.onOpenStart || m.current.onOpenStart() : !p && n && (null == m.current.onCloseStart || m.current.onCloseStart())
            }, [p, n]), {
              handleAnimationComplete: s
            }).handleAnimationComplete,
            j = f ? f[0] - f[void 0 === g ? 0 : g] : 0,
            _ = f ? f[0] : null,
            k = null !== _ ? "min(" + _ + "px, " + lq + ")" : lq;
          return (0, o.createElement)(lc.div, Object.assign({}, u, {
            ref: lJ([v, t]),
            className: "react-modal-sheet-container " + (void 0 === c ? "" : c),
            style: lZ({}, cx.container, void 0 === l ? {} : l, "full-height" === x && {
              height: k
            }, "content-height" === x && {
              maxHeight: k
            }, {
              y: h
            }),
            initial: !C && {
              y: y
            },
            animate: {
              y: j,
              transition: b
            },
            exit: {
              y: y,
              transition: b
            },
            onAnimationComplete: w
          }), a)
        }),
        c_ = ["children", "style", "disableDrag", "className"],
        ck = (0, o.forwardRef)(function(e, t) {
          var n = e.children,
            i = e.style,
            s = e.disableDrag,
            a = e.className,
            l = lU(e, c_),
            c = l6(),
            u = cd(),
            d = l3(),
            h = d.constraintsRef,
            p = d.onMeasureDragConstraints,
            m = s || u.disableDrag ? void 0 : c.dragProps;
          return (0, o.createElement)(lc.div, Object.assign({}, l, {
            ref: lJ([t, h]),
            className: "react-modal-sheet-content " + (void 0 === a ? "" : a),
            style: lZ({}, cx.content, i)
          }, m, {
            dragConstraints: h,
            onMeasureDragConstraints: p
          }), n)
        }),
        cS = ["children", "style", "disableDrag"],
        cE = (0, o.forwardRef)(function(e, t) {
          var n = e.children,
            i = e.style,
            s = e.disableDrag,
            a = lU(e, cS),
            l = l6(),
            c = l.indicatorRotation,
            u = l.dragProps,
            d = l3(),
            h = d.constraintsRef,
            p = d.onMeasureDragConstraints,
            m = lC(c, function(e) {
              return "translateX(2px) rotate(" + e + "deg)"
            }),
            f = lC(c, function(e) {
              return "translateX(-2px) rotate(" + -1 * e + "deg)"
            });
          return (0, o.createElement)(lc.div, Object.assign({}, a, {
            ref: lJ([t, h]),
            style: lZ({}, cx.headerWrapper, i)
          }, s ? void 0 : u, {
            dragConstraints: h,
            onMeasureDragConstraints: p
          }), n || (0, o.createElement)("div", {
            className: "react-modal-sheet-header",
            style: cx.header
          }, (0, o.createElement)(lc.span, {
            className: "react-modal-sheet-drag-indicator",
            style: lZ({}, cx.indicator, {
              transform: m
            })
          }), (0, o.createElement)(lc.span, {
            className: "react-modal-sheet-drag-indicator",
            style: lZ({}, cx.indicator, {
              transform: f
            })
          })))
        }),
        cP = ["style", "className"],
        cM = function(e) {
          return !!e.onClick || !!e.onTap
        },
        cT = (0, o.forwardRef)(function(e, t) {
          var n = e.style,
            i = e.className,
            s = lU(e, cP),
            a = cM(s) ? lc.button : lc.div,
            l = cM(s) ? "auto" : "none";
          return (0, o.createElement)(a, Object.assign({}, s, {
            ref: t,
            className: "react-modal-sheet-backdrop " + (void 0 === i ? "" : i),
            style: lZ({}, cx.backdrop, void 0 === n ? {} : n, {
              pointerEvents: l
            }),
            initial: {
              opacity: 0
            },
            animate: {
              opacity: 1
            },
            exit: {
              opacity: 0
            }
          }))
        }),
        cL = ["draggableAt", "children", "style", "className"],
        cA = (0, o.forwardRef)(function(e, t) {
          var n = e.draggableAt,
            i = void 0 === n ? "top" : n,
            s = e.children,
            a = e.style,
            l = e.className,
            c = lU(e, cL),
            u = cd();

          function d(e) {
            var t = e.scrollTop,
              n = e.scrollHeight,
              s = e.clientHeight;
            if (n > s) {
              var a = t <= 0,
                o = n - t === s;
              "top" === i && a || "bottom" === i && o || "both" === i && (a || o) ? u.setDragEnabled() : u.setDragDisabled()
            }
          }
          var h = "ontouchstart" in window || navigator.maxTouchPoints > 0 ? {
            onScroll: function(e) {
              d(e.currentTarget)
            },
            onTouchStart: function(e) {
              d(e.currentTarget)
            }
          } : void 0;
          return (0, o.createElement)("div", Object.assign({}, c, {
            ref: t,
            className: "react-modal-sheet-scroller " + (void 0 === l ? "" : l),
            style: lZ({}, cx.scroller, a)
          }, h), s)
        });
      cC.Container = cj, cC.Header = cE, cC.Content = ck, cC.Backdrop = cT, cC.Scroller = cA;
      var cV = {
          small: "_1l5ogmzd _1l5ogmzc",
          medium: "_1l5ogmze _1l5ogmzc",
          large: "_1l5ogmzf _1l5ogmzc"
        },
        cR = {
          small: "_1l5ogmzk _1l5ogmzj",
          medium: "_1l5ogmzl _1l5ogmzj",
          large: "_1l5ogmzm _1l5ogmzj"
        };
      let cN = e => {
          let {
            className: t = "",
            size: n = "small",
            showVorwerkLogo: i = !0
          } = e, s = cV[n];
          switch (n) {
            case "small":
              return m.jsx("img", {
                src: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380",
                alt: "Vorwerk Singapore",
                srcSet: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=190 190w, //vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380 380w",
                width: "190",
                height: "72.83333333333333",
                loading: "eager",
                className: "image-element",
                sizes: "190px",
                "data-animate": "fadein"
              });
            case "medium":
              return m.jsx("img", {
                src: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380",
                alt: "Vorwerk Singapore",
                srcSet: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=190 190w, //vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380 380w",
                width: "190",
                height: "72.83333333333333",
                loading: "eager",
                className: "image-element",
                sizes: "190px",
                "data-animate": "fadein"
              });
            case "large":
              return m.jsx("img", {
                src: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380",
                alt: "Vorwerk Singapore",
                srcSet: "//vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=190 190w, //vorwerk.com.sg/cdn/shop/files/vorwerk-logo.svg?v=1725451339&width=380 380w",
                width: "190",
                height: "72.83333333333333",
                loading: "eager",
                className: "image-element",
                sizes: "190px",
                "data-animate": "fadein"
              });
          }
        },
        cD = e => {
          let {
            className: t = "",
            size: n = "small"
          } = e, i = cR[n];
          return m.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "190",
            height: "72",
            fill: "none",
            viewBox: "0 0 190 72",
            className: F(i, t),
            focusable: "false",
            children: [m.jsx("g", {
              clipPath: "url(#clip0_1707_1691)",
              children: m.jsx("path", {
                fill: "currentColor",
                d: "M46.264 56.437h-3.395C48.847 65.796 59.333 72 71.275 72a33.547 33.547 0 0025.943-12.213C103.392 67.238 112.736 72 123.176 72c11.942 0 22.427-6.204 28.406-15.578h-3.41c-5.618 7.737-14.721 12.754-24.996 12.754-10.891 0-20.46-5.633-25.958-14.136-5.498 8.503-15.067 14.136-25.943 14.136-10.29 0-19.393-5.017-24.996-12.739m76.807-11.807v-6.955h11.086v-4.131h-11.086v-6.129h12.453v-4.131h-17.936v25.492h18.507v-4.13h-13.024v-.016zm-22.068 4.131h5.453l7.151-25.492h-4.912l-4.597 17.68-4.011-17.68h-5.168l-4.356 17.756-4.07-17.756h-6.115L87.47 48.76h5.407l4.026-16.344 4.116 16.344zm-22.262 0l-6.58-9.704c1.728-.646 5.483-3.05 5.483-7.376 0-5.438-4.22-8.412-8.667-8.412H57.184V48.76h5.498V27.175h4.672c2.479 0 4.687 1.607 4.687 4.641 0 3.035-2.674 4.702-5.633 4.702-.57 0-1.052 0-1.472-.06l6.94 12.303h6.88zm-63.182 0l9.388-25.492h-5.167l-6.52 18.747v-.045L6.906 23.27H.627l9.539 25.492H15.574zM46.91 35.962c0 5.213-3.32 9.434-7.541 9.434-4.222 0-7.541-4.22-7.541-9.434 0-5.212 3.32-9.433 7.54-9.433 4.222 0 7.541 4.22 7.541 9.433zm-7.541-13.52c-7.376 0-13.355 6.055-13.355 13.52 0 7.466 5.979 13.52 13.354 13.52 7.376 0 13.355-6.054 13.355-13.52 0-7.465-5.979-13.52-13.355-13.52zm108.743-7h3.41C145.528 6.145 135.073-.014 123.191-.014c-10.44 0-19.784 4.762-25.958 12.213C91.043 4.762 81.715 0 71.26 0 59.378 0 48.922 6.174 42.944 15.473h3.41C51.972 7.81 61.045 2.824 71.275 2.824c10.89 0 20.46 5.633 25.958 14.136C102.73 8.457 112.3 2.824 123.19 2.824c10.23 0 19.303 4.972 24.921 12.634m14.541 33.318l-6.579-9.704c1.727-.646 5.483-3.05 5.483-7.376 0-5.438-4.221-8.412-8.668-8.412h-11.807v25.492h5.483V27.19h4.687c2.478 0 4.687 1.607 4.687 4.641 0 3.035-2.674 4.702-5.634 4.702-.571 0-1.051 0-1.472-.06l6.94 12.303h6.88zm3.726 0h5.483V23.27h-5.483v25.507zm22.863 0L178.577 34.64l9.478-11.341h-6.579l-8.893 11.642 9.358 13.85h7.316l-.015-.015z"
              })
            }), m.jsx("defs", {
              children: m.jsx("clipPath", {
                id: "clip0_1707_1691",
                children: m.jsx("path", {
                  fill: "#fff",
                  d: "M0 0H188.615V72H0z",
                  transform: "translate(.627)"
                })
              })
            })]
          })
        };
      var cO = {
        exports: {}
      };
      ! function() {
        var e = {}.hasOwnProperty;

        function t() {
          for (var i = "", s = 0; s < arguments.length; s++) {
            var a = arguments[s];
            a && (i = n(i, function(i) {
              if ("string" == typeof i || "number" == typeof i) return i;
              if ("object" != typeof i) return "";
              if (Array.isArray(i)) return t.apply(null, i);
              if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) return i.toString();
              var s = "";
              for (var a in i) e.call(i, a) && i[a] && (s = n(s, a));
              return s
            }(a)))
          }
          return i
        }

        function n(e, t) {
          return t ? e ? e + " " + t : e + t : e
        }
        cO.exports ? (t.default = t, cO.exports = t) : window.classNames = t
      }();
      let cH = d(cO.exports),
        cI = {
          ModuleImageCarousel: "_ModuleImageCarousel_1sdn7_1",
          ModuleImageCarousel__gallery: "_ModuleImageCarousel__gallery_1sdn7_8",
          ModuleImageCarousel__image: "_ModuleImageCarousel__image_1sdn7_18",
          ModuleImageCarousel__packshot: "_ModuleImageCarousel__packshot_1sdn7_24",
          ModuleImageCarousel__eyecatcher: "_ModuleImageCarousel__eyecatcher_1sdn7_32"
        };
      var cB = {
          purple: "_1mubyh30",
          green: "_1mubyh31",
          yellow: "_1mubyh32",
          orange: "_1mubyh33",
          red: "_1mubyh34",
          blue: "_1mubyh35"
        },
        cF = {
          "5 degrees": "_1mubyh36",
          "-5 degrees": "_1mubyh37",
          none: "_1mubyh38"
        },
        cW = {
          small: "_1mubyh3b",
          medium: "_1mubyh3c",
          large: "_1mubyh3d"
        };
      let cz = e => {
        let {
          firstLine: t,
          secondLine: n,
          thirdLine: i,
          backgroundColor: s = "purple",
          rotation: a = "none",
          size: o = "small"
        } = e;
        return m.jsx("div", {
          className: F("_1mubyh39", cB[s], cW[o]),
          children: m.jsxs("div", {
            className: F("_1mubyh3a", cF[a]),
            children: [t && m.jsx(t4, {
              variant: "paragraph16",
              fontWeight: "regular",
              children: t
            }), n && m.jsx(t4, {
              variant: "paragraph16",
              fontWeight: "bold",
              children: n
            }), i && m.jsx(t4, {
              variant: "paragraph16",
              fontWeight: "regular",
              children: i
            })]
          })
        })
      };
      var c$ = {};
      Object.defineProperty(c$, "__esModule", {
        value: !0
      });
      var cZ = o && "object" == typeof o && "default" in o ? o : {
        default: o
      };
      ! function(e) {
        if (!e) return;
        let t = document.createElement("style");
        t.setAttribute("type", "text/css"), t.innerHTML = e, document.head.appendChild(t)
      }(`.rfm-marquee-container {
  overflow-x: hidden;
  display: flex;
  flex-direction: row;
  position: relative;
  width: var(--width);
  transform: var(--transform);
}
.rfm-marquee-container:hover div {
  animation-play-state: var(--pause-on-hover);
}
.rfm-marquee-container:active div {
  animation-play-state: var(--pause-on-click);
}

.rfm-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}
.rfm-overlay::before, .rfm-overlay::after {
  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));
  content: "";
  height: 100%;
  position: absolute;
  width: var(--gradient-width);
  z-index: 2;
  pointer-events: none;
  touch-action: none;
}
.rfm-overlay::after {
  right: 0;
  top: 0;
  transform: rotateZ(180deg);
}
.rfm-overlay::before {
  left: 0;
  top: 0;
}

.rfm-marquee {
  flex: 0 0 auto;
  min-width: var(--min-width);
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);
  animation-play-state: var(--play);
  animation-delay: var(--delay);
  animation-direction: var(--direction);
}
@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}

.rfm-initial-child-container {
  flex: 0 0 auto;
  display: flex;
  min-width: auto;
  flex-direction: row;
  align-items: center;
}

.rfm-child {
  transform: var(--transform);
}`);
      let cU = o.forwardRef(function(e, t) {
        let {
          style: n = {},
          className: i = "",
          autoFill: s = !1,
          play: a = !0,
          pauseOnHover: l = !1,
          pauseOnClick: c = !1,
          direction: u = "left",
          speed: d = 50,
          delay: h = 0,
          loop: p = 0,
          gradient: m = !1,
          gradientColor: f = "white",
          gradientWidth: g = 200,
          onFinish: v,
          onCycleComplete: y,
          onMount: x,
          children: b
        } = e, [C, w] = o.useState(0), [j, _] = o.useState(0), [k, S] = o.useState(1), [E, P] = o.useState(!1), M = o.useRef(null), T = t || M, L = o.useRef(null), A = o.useCallback(() => {
          if (L.current && T.current) {
            let e = T.current.getBoundingClientRect(),
              t = L.current.getBoundingClientRect(),
              n = e.width,
              i = t.width;
            ("up" === u || "down" === u) && (n = e.height, i = t.height), S(s && n && i && i < n ? Math.ceil(n / i) : 1), w(n), _(i)
          }
        }, [s, T, u]);
        o.useEffect(() => {
          if (E && (A(), L.current && T.current)) {
            let e = new ResizeObserver(() => A());
            return e.observe(T.current), e.observe(L.current), () => {
              e && e.disconnect()
            }
          }
        }, [A, T, E]), o.useEffect(() => {
          A()
        }, [A, b]), o.useEffect(() => {
          P(!0)
        }, []), o.useEffect(() => {
          "function" == typeof x && x()
        }, []);
        let V = o.useMemo(() => s ? j * k / d : j < C ? C / d : j / d, [s, C, j, k, d]),
          R = o.useMemo(() => Object.assign(Object.assign({}, n), {
            "--pause-on-hover": !a || l ? "paused" : "running",
            "--pause-on-click": !a || l && !c || c ? "paused" : "running",
            "--width": "up" === u || "down" === u ? "100vh" : "100%",
            "--transform": "up" === u ? "rotate(-90deg)" : "down" === u ? "rotate(90deg)" : "none"
          }), [n, a, l, c, u]),
          N = o.useMemo(() => ({
            "--gradient-color": f,
            "--gradient-width": "number" == typeof g ? `${g}px` : g
          }), [f, g]),
          D = o.useMemo(() => ({
            "--play": a ? "running" : "paused",
            "--direction": "left" === u ? "normal" : "reverse",
            "--duration": `${V}s`,
            "--delay": `${h}s`,
            "--iteration-count": p ? `${p}` : "infinite",
            "--min-width": s ? "auto" : "100%"
          }), [a, u, V, h, p, s]),
          O = o.useMemo(() => ({
            "--transform": "up" === u ? "rotate(90deg)" : "down" === u ? "rotate(-90deg)" : "none"
          }), [u]),
          H = o.useCallback(e => [...Array(Number.isFinite(e) && e >= 0 ? e : 0)].map((e, t) => cZ.default.createElement(o.Fragment, {
            key: t
          }, o.Children.map(b, e => cZ.default.createElement("div", {
            style: O,
            className: "rfm-child"
          }, e)))), [O, b]);
        return E ? cZ.default.createElement("div", {
          ref: T,
          style: R,
          className: "rfm-marquee-container " + i
        }, m && cZ.default.createElement("div", {
          style: N,
          className: "rfm-overlay"
        }), cZ.default.createElement("div", {
          className: "rfm-marquee",
          style: D,
          onAnimationIteration: y,
          onAnimationEnd: v
        }, cZ.default.createElement("div", {
          className: "rfm-initial-child-container",
          ref: L
        }, o.Children.map(b, e => cZ.default.createElement("div", {
          style: O,
          className: "rfm-child"
        }, e))), H(k - 1)), cZ.default.createElement("div", {
          className: "rfm-marquee",
          style: D
        }, H(k))) : null
      });
      var cq = c$.default = cU;
      let cX = e => {
        let {
          eyecatcher: t,
          productImage: n,
          productImageAlt: i,
          images: s,
          showEyecatcher: a = !0
        } = e;
        return m.jsxs("div", {
          className: cI.ModuleImageCarousel,
          children: [m.jsx("div", {
            className: cI.ModuleImageCarousel__gallery,
            children: m.jsx(cq, {
              autoFill: !0,
              children: s && s.map((e, t) => m.jsx("img", {
                className: cI.ModuleImageCarousel__image,
                src: e.url,
                alt: e.alt,
                title: e.title ? e.title : ""
              }, t))
            })
          }), n && m.jsx("div", {
            className: cI.ModuleImageCarousel__packshot,
            children: m.jsx("img", {
              src: n,
              alt: i
            })
          }), t && a && m.jsx("div", {
            className: cI.ModuleImageCarousel__eyecatcher,
            children: m.jsx(cz, {
              ...t
            })
          })]
        })
      };
      var cY = {
          default: "bb4ht0e bb4ht0d",
          additional: "bb4ht0f bb4ht0d"
        },
        cK = {
          green: "bb4ht04",
          blue: "bb4ht05",
          purple: "bb4ht06",
          red: "bb4ht07",
          orange: "bb4ht08",
          yellow: "bb4ht09",
          anthracite: "bb4ht0a",
          white: "bb4ht0b"
        };
      let cG = e => {
          let {
            children: t,
            eyebrowLine: n,
            subline: i,
            spaceBelow: s,
            strongColor: a = "green"
          } = e, o = s ? cY[s] : "", l = i ? "bb4ht0c" : "", c = cK[a];
          return m.jsxs("div", {
            className: F(o, "bb4ht00", c),
            children: [n && m.jsx("p", {
              className: "bb4ht01",
              children: n
            }), m.jsx("div", {
              className: F("bb4ht03", l),
              children: t
            }), i && m.jsx("p", {
              className: "bb4ht02",
              children: i
            })]
          })
        },
        cQ = {
          sectionContainer: "sectionContainer_4cayh_1",
          gap01: "gap01_4cayh_7",
          gap04: "_gap04_4cayh_11"
        },
        cJ = e => {
          let {
            children: t,
            gap: n
          } = e;
          return m.jsx("div", {
            className: cH(cQ.sectionContainer, "gap01" == n ? cQ.gap01 : "", "gap04" == n ? cQ.gap04 : ""),
            children: t
          })
        },
        c1 = e => m.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [m.jsxs("g", {
            clipPath: "url(#a)",
            children: [m.jsx("path", {
              fill: "currentColor",
              d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16c0 7.986 5.85 14.606 13.5 15.806V20.625H9.435V16H13.5v-3.525c0-4.01 2.39-6.224 6.045-6.224 1.751 0 3.581.313 3.581.313V10.5h-2.017c-1.986 0-2.607 1.232-2.607 2.498V16h4.437l-.709 4.625h-3.728v11.18C26.15 30.607 32 23.986 32 16Z"
            }), m.jsx("path", {
              fill: "none",
              d: "M22.227 20.625 22.936 16h-4.438v-3c0-1.267.619-2.5 2.608-2.5h2.017V6.565s-1.83-.313-3.582-.313c-3.655 0-6.044 2.214-6.044 6.224V16H9.434v4.625h4.063v11.18a16.11 16.11 0 0 0 5.001 0v-11.18h3.729Z"
            })]
          }), m.jsx("defs", {
            children: m.jsx("clipPath", {
              id: "a",
              children: m.jsx("path", {
                fill: "none",
                d: "M0 0h32v32H0z"
              })
            })
          })]
        }),
        c0 = e => m.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [m.jsxs("g", {
            clipPath: "url(#a)",
            children: [m.jsx("path", {
              style: {
                fill: `${tH}`
              },
              d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
            }), m.jsx("path", {
              style: {
                fill: `${tI}`
              },
              d: "M16 4C9.241 4 4 8.953 4 15.64c0 3.498 1.434 6.522 3.768 8.61.195.174.315.42.321.684l.066 2.136a.96.96 0 0 0 1.347.849l2.382-1.05a.964.964 0 0 1 .642-.048c1.095.3 2.259.462 3.474.462 6.759 0 12-4.953 12-11.64S22.759 4 16 4Z"
            }), m.jsx("path", {
              style: {
                fill: `${tB}`
              },
              d: "m8.794 19.045 3.525-5.592a1.8 1.8 0 0 1 2.604-.48l2.805 2.103a.72.72 0 0 0 .867-.003L22.38 12.2c.504-.384 1.164.222.828.76l-3.528 5.588a1.8 1.8 0 0 1-2.604.48l-2.805-2.103a.72.72 0 0 0-.867.003l-3.786 2.874c-.504.384-1.164-.219-.825-.756Z"
            })]
          }), m.jsx("defs", {
            children: m.jsx("clipPath", {
              id: "a",
              children: m.jsx("path", {
                fill: "#fff",
                d: "M0 0h32v32H0z"
              })
            })
          })]
        }),
        c2 = e => m.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [m.jsxs("g", {
            clipPath: "url(#a)",
            children: [m.jsx("path", {
              fill: "currentColor",
              d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
            }), m.jsx("path", {
              style: {
                fill: `${tO}`
              },
              fillRule: "evenodd",
              d: "M7.243 15.831c4.664-2.032 7.774-3.372 9.33-4.019 4.444-1.848 5.367-2.17 5.969-2.18.132-.002.428.03.62.186a.674.674 0 0 1 .228.434c.02.124.047.408.026.63-.24 2.53-1.282 8.669-1.812 11.503-.225 1.199-.666 1.6-1.094 1.64-.929.085-1.635-.614-2.534-1.204-1.409-.923-2.204-1.498-3.571-2.399-1.58-1.04-.556-1.613.345-2.548.235-.244 4.329-3.968 4.408-4.306.01-.042.02-.2-.074-.283-.094-.083-.232-.055-.331-.032-.142.032-2.391 1.52-6.75 4.46-.638.44-1.216.653-1.735.642-.57-.012-1.67-.323-2.487-.589-1.002-.325-1.798-.498-1.729-1.05.036-.289.433-.584 1.19-.885Z",
              clipRule: "evenodd"
            })]
          }), m.jsx("defs", {
            children: m.jsx("clipPath", {
              id: "a",
              children: m.jsx("path", {
                fill: "#fff",
                d: "M0 0h32v32H0z"
              })
            })
          })]
        }),
        c5 = e => m.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [m.jsxs("g", {
            clipPath: "url(#tw)",
            children: [m.jsx("path", {
              fill: "currentColor",
              d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
            }), m.jsx("path", {
              style: {
                fill: `${tO}`
              },
              d: "M17.49 14.775L23.317 8h-1.382l-5.06 5.883L12.834 8H8.172l6.112 8.895L8.172 24h1.381l5.344-6.212L19.166 24h4.662l-6.339-9.225zm-1.892 2.199l-.62-.886-4.927-7.048h2.121l3.977 5.688.619.886 5.17 7.393h-2.122l-4.218-6.033z"
            })]
          }), m.jsx("defs", {
            children: m.jsx("clipPath", {
              id: "tw",
              children: m.jsx("path", {
                fill: "#fff",
                d: "M0 0H32V32H0z"
              })
            })
          })]
        }),
        c3 = e => m.jsxs("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [m.jsxs("g", {
            clipPath: "url(#a)",
            children: [m.jsx("path", {
              fill: "currentColor",
              d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
            }), m.jsx("path", {
              style: {
                fill: `${tO}`
              },
              fillRule: "evenodd",
              d: "M23.697 8.5a10.081 10.081 0 0 0-7.18-2.975c-5.594 0-10.148 4.551-10.15 10.146 0 1.787.467 3.534 1.356 5.072l-1.44 5.258 5.382-1.41a10.137 10.137 0 0 0 4.85 1.234h.004c5.594 0 10.148-4.55 10.15-10.147A10.09 10.09 0 0 0 23.7 8.5h-.002Zm-7.18 15.611h-.002a8.415 8.415 0 0 1-4.293-1.175l-.308-.183-3.193.837.853-3.112-.201-.32a8.417 8.417 0 0 1-1.29-4.487c0-4.651 3.785-8.434 8.44-8.434 2.255 0 4.372.88 5.965 2.472a8.374 8.374 0 0 1 2.467 5.966c0 4.651-3.785 8.434-8.436 8.434l-.002.002Zm4.627-6.317c-.254-.128-1.5-.74-1.733-.825-.232-.085-.4-.128-.571.128-.168.254-.654.825-.804.994-.147.168-.296.19-.55.064-.253-.128-1.071-.394-2.038-1.259-.754-.673-1.264-1.503-1.41-1.756-.148-.254-.017-.392.11-.517.115-.114.255-.296.38-.443.126-.147.168-.254.254-.422.085-.169.042-.318-.022-.444-.064-.128-.57-1.374-.782-1.882-.206-.495-.415-.426-.571-.436-.147-.007-.318-.01-.486-.01a.933.933 0 0 0-.676.318c-.232.254-.886.868-.886 2.115 0 1.246.908 2.453 1.036 2.621.125.169 1.787 2.731 4.333 3.829.604.26 1.078.417 1.446.533a3.475 3.475 0 0 0 1.597.1c.489-.074 1.5-.614 1.712-1.207.21-.593.21-1.1.147-1.207-.064-.106-.233-.168-.486-.296v.002Z",
              clipRule: "evenodd"
            })]
          }), m.jsx("defs", {
            children: m.jsx("clipPath", {
              id: "a",
              children: m.jsx("path", {
                fill: "#fff",
                d: "M0 0h32v32H0z"
              })
            })
          })]
        }),
        c4 = e => {
          let {
            header: t,
            links: n
          } = e;
          return m.jsx(nc, {
            columns: 4,
            children: m.jsxs("div", {
              className: F("_12sdaeq1", "_5yj2ss0"),
              children: [t, n && m.jsx("ul", {
                children: n.map((e, t) => m.jsx("li", {
                  children: e
                }, t))
              })]
            })
          })
        };
      var c6 = {
        "3/2": "_8a58ly1",
        "1/1": "_8a58ly2",
        "4/3": "_8a58ly3",
        "16/9": "_8a58ly4",
        "2/1": "_8a58ly5",
        "21/9": "_8a58ly6",
        "3/1": "_8a58ly7",
        "4/1": "_8a58ly8",
        "n/a": "_8a58ly9"
      };
      let c7 = e => {
        let {
          children: t,
          aspectRatio: n
        } = e;
        return m.jsx("div", {
          className: F(c6[n], "_8a58ly0"),
          children: t
        })
      };
      var c9 = {
        small: "_1wj0mv74 _1wj0mv73",
        medium: "_1wj0mv75 _1wj0mv73",
        large: "_1wj0mv76 _1wj0mv73"
      };
      let c8 = e => {
          let {
            size: t = "medium",
            stock: n,
            price: i,
            lowestPrice: s,
            basePrice: a,
            vat: o,
            delivery: l
          } = e;
          return m.jsxs("div", {
            className: "_1wj0mv70",
            children: [m.jsxs("div", {
              className: "_1wj0mv71",
              children: [m.jsx("span", {
                className: c9[t],
                children: i
              }), s && m.jsx(t4, {
                variant: "paragraph12",
                component: "span",
                className: "_1wj0mv72",
                children: s
              })]
            }), n ? m.jsx(t4, {
              variant: "paragraph10",
              fontWeight: "bold",
              className: "_1wj0mv77",
              children: n
            }) : m.jsxs("div", {
              children: [a && m.jsx(t4, {
                variant: "paragraph10",
                fontWeight: "regular",
                children: a
              }), o && m.jsx(t4, {
                variant: "paragraph10",
                fontWeight: "regular",
                children: o
              }), l && m.jsx(t4, {
                variant: "paragraph10",
                fontWeight: "regular",
                children: l
              })]
            })]
          })
        },
        ue = e => m.jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          focusable: "false",
          ...e,
          children: m.jsx("path", {
            d: "M13.2776 40.0009C13.817 40.2834 14.4334 40.4375 15.0241 40.4375C15.6405 40.4375 16.2313 40.2577 16.7706 39.9238L38.0367 26.9536C38.5503 26.6454 38.9613 26.2088 39.2695 25.6951C39.552 25.1814 39.7061 24.5907 39.7061 24C39.7061 23.4093 39.552 22.8185 39.2695 22.3049C38.987 21.7912 38.5503 21.3546 38.0367 21.0464L16.7706 8.07612C16.2569 7.74223 15.6405 7.58813 15.0241 7.56245C14.4077 7.56245 13.817 7.69087 13.2776 7.99907C12.7383 8.28159 12.3017 8.71821 11.9678 9.25757C11.6596 9.77124 11.4798 10.3876 11.4541 11.0041L11.4541 36.9702C11.4541 37.6123 11.6339 38.203 11.9678 38.7424C12.276 39.2561 12.7383 39.6927 13.2776 40.0009Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
          })
        }),
        ut = e => m.jsx("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
          focusable: "false",
          ...e,
          children: m.jsx("path", {
            d: "M13 12.2002H20.64V35.8002H13V12.2002ZM27.36 12.2002H35V35.8002H27.36V12.2002Z",
            fill: "currentColor"
          })
        });
      var un = n(2804),
        ur = n.n(un),
        ui = e => {
          let {
            tiles: t,
            darkMode: n
          } = e;
          return (0, a.jsx)(nl, {
            children: (0, a.jsx)(nc, {
              columns: 12,
              children: (0, a.jsx)("div", {
                className: `${ur().bentoBoxTiles} ${n?ur().darkModeEnabled:""}`,
                children: t.map((e, t) => (0, a.jsxs)("div", {
                  className: `${ur().bentoBoxTile} ${e.bigTile?ur().tileBig:""}`,
                  children: [e.image && (0, a.jsx)("div", {
                    className: `${ur().tileImageContainer} ${e.imageBottom?ur().tileImageBottom:""}`,
                    children: (0, a.jsx)("img", {
                      src: e.image,
                      alt: e.imageAlt
                    })
                  }), (0, a.jsxs)("div", {
                    className: ur().tileContent,
                    children: [(0, a.jsx)(t4, {
                      className: ur().tileTitle,
                      component: "p",
                      variant: "h1",
                      fontWeight: "bold",
                      children: e.title
                    }), (0, a.jsx)(t4, {
                      className: ur().tileTitleSecondary,
                      component: "p",
                      variant: "h4",
                      fontWeight: "bold",
                      children: e.titleSecondary
                    }), (0, a.jsx)("div", {
                      className: ur().tileText,
                      children: e.text
                    })]
                  })]
                }, t))
              })
            })
          })
        },
        us = n(6760),
        ua = n.n(us),
        uo = n(5447),
        ul = n(2934),
        uc = n(4317),
        uu = n(6665),
        ud = n(5644),
        uh = n.n(ud);

      function up(e) {
        let {
          items: t = [],
          darkMode: n = !1
        } = e, [i, s] = (0, o.useState)("0vh"), [l, c] = (0, o.useState)(t), u = (0, o.useRef)([]), d = (0, o.useRef)(null), {
          scrollYProgress: h
        } = (0, uo.v)({
          target: d
        }), p = () => {
          u.current.forEach(e => {
            if (e) {
              let t = e.play();
              void 0 !== t && t.then(() => {
                e.pause(), e.currentTime = 0
              }).catch(function(e) {
                console.log(e)
              })
            }
          })
        }, m = (e, t) => {
          u.current[t] = e
        }, f = e => u.current[e]?.paused == !1, g = e => {
          let t = u.current[e];
          if (t) {
            let n = t.play();
            void 0 !== n && n.then(() => {
              c(t => t.map((t, n) => ({
                ...t,
                isPlaying: e == n
              })))
            }).catch(function(e) {
              console.log(e)
            })
          }
        }, v = e => {
          u.current[e]?.pause(), c(t => t.map((t, n) => ({
            ...t,
            isPlaying: e != n
          })))
        };
        return (0, o.useEffect)(() => {
          let e = l.length;
          s(String(100 * e) + "vh"), c(t => t.map((t, n) => ({
            ...t,
            scrollMin: 1 / e * n,
            scrollMax: 1 / e * (n + 1),
            isActive: 0 === n
          })))
        }, [s, l.length]), (0, ul.W)(h, "change", e => {
          c(t => t.map((t, n) => {
            let i = e > t?.scrollMin && e <= t?.scrollMax;
            return t.isActive !== i && u.current.length > 0 && p(), i && g(n), t.isActive !== i ? {
              ...t,
              isActive: i
            } : t
          }))
        }), (0, a.jsx)(nl, {
          children: (0, a.jsx)(nc, {
            columns: 12,
            children: (0, a.jsx)("div", {
              ref: d,
              style: {
                height: i
              },
              children: (0, a.jsxs)("article", {
                className: ua()(uh().desktopScrollboxWrapper, n ? uh().darkMode : ""),
                children: [(0, a.jsx)("ul", {
                  className: uh().desktopScrollbox__list,
                  children: l.map((e, t) => {
                    let n = (0, uc.H)(h, [t / l.length, (t + 1) / l.length], ["-100%", "0%"]),
                      i = e.isActive ? uh().active : uh().inactive;
                    return (0, a.jsxs)("li", {
                      className: ua()(i),
                      children: [(0, a.jsx)("div", {
                        className: uh().desktopScrollbox__title,
                        children: (0, a.jsx)("span", {
                          children: e.text
                        })
                      }), (0, a.jsx)("div", {
                        className: uh().desktopScrollbox__progress,
                        children: (0, a.jsx)(uu.E.div, {
                          style: {
                            x: n
                          }
                        })
                      })]
                    }, e.id)
                  })
                }), (0, a.jsx)("div", {
                  className: uh().desktopScrollbox__media,
                  children: l.map((e, t) => {
                    let n = e.isActive ? uh().active : uh().inactive;
                    return (0, a.jsxs)("div", {
                      className: ua()(e.media.type, n),
                      children: ["image" === e.media.type && (0, a.jsx)("img", {
                        src: e.media.src,
                        alt: e.media.alt,
                        title: e.media.title
                      }), "video" === e.media.type && (0, a.jsxs)("div", {
                        className: uh().videoContainer,
                        children: [(0, a.jsx)("video", {
                          ref: e => m(e, t),
                          preload: "metadata",
                          controls: !1,
                          playsInline: !0,
                          muted: !0,
                          loop: !0,
                          children: (0, a.jsx)("source", {
                            src: e.media.src
                          })
                        }), f(t) ? (0, a.jsx)("button", {
                          onClick: () => v(t),
                          children: (0, a.jsx)(ut, {})
                        }) : (0, a.jsx)("button", {
                          onClick: () => g(t),
                          children: (0, a.jsx)(ue, {})
                        })]
                      }), e.description && (0, a.jsx)("p", {
                        className: uh().description,
                        children: e.description
                      })]
                    }, t)
                  })
                })]
              })
            })
          })
        })
      }
      var um = n(9950),
        uf = n.n(um),
        ug = n(8259),
        uv = n.n(ug);

      function uy(e) {
        let {
          items: t = []
        } = e, [n, i] = (0, o.useState)(t), [s, l] = (0, o.useState)(!1), c = (0, o.useRef)([]), u = (0, o.useRef)(null), {
          scrollYProgress: d
        } = (0, uo.v)({
          target: u
        }), h = (e, t) => {
          c.current[t] = e, 0 === t && e && !s && l(!0)
        }, p = e => c.current[e]?.paused == !1, m = e => {
          let t = c.current[e];
          if (t) {
            let n = t.play();
            void 0 !== n && n.then(() => {
              c.current.forEach((t, n) => {
                n !== e && t && (t.pause(), t.currentTime = 0)
              }), i(t => t.map((t, n) => ({
                ...t,
                isPlaying: n === e
              })))
            }).catch(function(e) {
              console.log(e)
            })
          }
        }, f = e => {
          let t = c.current[e];
          t && (t.pause(), t.currentTime = 0), i(t => t.map((t, n) => ({
            ...t,
            isPlaying: n === e
          })))
        };
        return (0, o.useEffect)(() => {
          let e = n.length;
          i(t => t.map((t, n) => ({
            ...t,
            scrollMin: 1 / e * n,
            scrollMax: 1 / e * (n + 1),
            isActive: 0 === n,
            isFolded: !1
          })))
        }, [n.length]), (0, o.useEffect)(() => {
          s && n[0]?.isActive && m(0)
        }, [s, n[0]?.isActive]), (0, ul.W)(d, "change", e => {
          i(t => t.map((t, n) => {
            let i = {
              ...t
            };
            return e > t?.scrollMin && e <= t?.scrollMax ? (i.isActive = !0, i.isFolded = !1, m(n)) : e > t?.scrollMax ? (i.isActive = !1, i.isFolded = !0, f(n)) : (0 === n ? i.isActive = !0 : i.isActive = !1, i.isFolded = !1), i
          }))
        }), (0, a.jsx)(nl, {
          children: (0, a.jsx)(nc, {
            columns: 12,
            children: (0, a.jsx)("div", {
              ref: u,
              style: {
                height: `${100*n.length}vh`
              },
              children: (0, a.jsx)("article", {
                className: ua()(uv().mobileScrollboxWrapper),
                children: (0, a.jsx)("ul", {
                  className: uv().mobileScrollbox__list,
                  children: n.map((e, t) => {
                    let n = (0, uc.H)(d, [e.scrollMin, e.scrollMax], ["-100%", "0%"]),
                      i = e.isActive ? uv().active : e.isFolded ? uv().folded : uv().inactive;
                    return (0, a.jsxs)("li", {
                      className: ua()(i),
                      children: [(0, a.jsx)("div", {
                        className: uv().mobileScrollbox__title,
                        children: (0, a.jsx)("span", {
                          children: e.text
                        })
                      }), (0, a.jsxs)("div", {
                        className: ua()(uv().mediaContainer, e.media.type),
                        children: [(0, a.jsx)("div", {
                          className: uv().mobileScrollbox__progress,
                          children: (0, a.jsx)(uu.E.div, {
                            style: {
                              y: n
                            }
                          })
                        }), "image" === e.media.type && (0, a.jsx)("img", {
                          src: e.media.src,
                          alt: e.media.alt,
                          title: e.media.title
                        }), "video" === e.media.type && (0, a.jsxs)("div", {
                          className: uv().videoContainer,
                          children: [(0, a.jsx)("video", {
                            ref: e => h(e, t),
                            preload: "metadata",
                            controls: !1,
                            playsInline: !0,
                            muted: !0,
                            loop: !0,
                            children: (0, a.jsx)("source", {
                              src: e.media.src
                            })
                          }), p(t) ? (0, a.jsx)("button", {
                            onClick: () => f(t),
                            children: (0, a.jsx)(ut, {})
                          }) : (0, a.jsx)("button", {
                            onClick: () => m(t),
                            children: (0, a.jsx)(ue, {})
                          })]
                        }), (0, a.jsx)(t4, {
                          component: "p",
                          variant: "paragraph16",
                          className: uv().description,
                          children: e.description
                        })]
                      })]
                    }, e.id)
                  })
                })
              })
            })
          })
        })
      }
      let ux = {
        m: "739px"
      };

      function ub(e) {
        let {
          items: t = [],
          darkMode: n = !1
        } = e, [i] = (0, o.useState)([parseInt(ux.m.replace("px", ""))]), [s, l] = (0, o.useState)(!1);
        return (0, o.useEffect)(() => {
          let e = () => {
              let e = window.innerWidth,
                t = i.find(t => e < t);
              return !!t && t.toString() === ux.m.replace("px", "")
            },
            t = () => {
              e() ? l(!0) : l(!1)
            };
          return t(), window.addEventListener("resize", t), () => window.removeEventListener("resize", t)
        }, [l, i]), (0, a.jsx)("div", {
          className: uf().functionsTabWrapper,
          children: s ? (0, a.jsx)(uy, {
            items: t
          }) : (0, a.jsx)(up, {
            items: t,
            darkMode: n
          })
        })
      }
      var uC = n(9467),
        uw = n(3983),
        uj = n.n(uw);
      let u_ = e => {
          let [t, n] = (0, o.useState)(0), [i, s] = (0, o.useState)([]), a = (0, o.useCallback)(t => {
            e && e.scrollTo(t)
          }, [e]), l = (0, o.useCallback)(e => {
            s(e.scrollSnapList())
          }, []), c = (0, o.useCallback)(e => {
            n(e.selectedScrollSnap())
          }, []);
          return (0, o.useEffect)(() => {
            e && (l(e), c(e), e.on("reInit", l).on("reInit", c).on("select", c))
          }, [e, l, c]), {
            selectedIndex: t,
            scrollSnaps: i,
            onDotButtonClick: a
          }
        },
        uk = e => {
          let {
            children: t,
            ...n
          } = e;
          return (0, a.jsx)("span", {
            ...n,
            children: t
          })
        },
        uS = e => {
          let {
            emblaApi: t
          } = e, {
            selectedIndex: n,
            scrollSnaps: i,
            onDotButtonClick: s
          } = u_(t);
          return (0, a.jsx)("div", {
            className: uj().swiper__dots,
            children: (() => {
              let e, t, o;
              let l = [],
                c = 0,
                u = i.length,
                d = i.length > 7,
                h = !!(n >= Math.floor(3.5) && n <= i.length - Math.ceil(3.5)),
                p = n > i.length - Math.ceil(3.5),
                m = !1,
                f = !1;
              d && (h ? (c = n - Math.floor(3.5), u = n + Math.ceil(3.5)) : p ? (c = i.length - 7, u = i.length) : (c = 0, u = 7), m = Math.abs(0 - c) > 0, f = Math.abs(i.length - u) > 0);
              for (let d = 0; d < i.length; d++) {
                e = d === n ? uj().swiper__dotSelected : "", t = void 0, o = void 0;
                let i = d == c && m || d == u - 1 && f,
                  h = d < Math.abs(0 - c) || d > Math.abs(0 - u) - 1;
                l.push((0, a.jsx)(uk, {
                  "data-index": d,
                  onClick: () => s(d),
                  className: ua()(uj().swiper__dot, i ? uj().swiper__dotsmall : "", h ? uj().swiper__dothidden : "", e, o, t)
                }, d))
              }
              return l
            })()
          })
        };
      var uE = n(590),
        uP = n.n(uE);
      let uM = e => {
          let {
            bigImagePosLeft: t = !1,
            images: n = [{
              url: "",
              alt: "",
              title: "",
              description: ""
            }]
          } = e, i = n.length, s = ua()(uP().imageLayoutWrap, uP()["image-variant"], uP()[uT(i)], {
            [uP()["big-left"]]: t
          });
          return (0, a.jsxs)("article", {
            className: uP().imageLayoutWrap,
            children: [1 === i && (0, a.jsx)("div", {
              className: s,
              children: (0, a.jsxs)("div", {
                children: [(0, a.jsx)("img", {
                  src: n[0].url,
                  alt: n[0].alt,
                  title: n[0].title
                }), n[0].description && (0, a.jsx)(nl, {
                  children: (0, a.jsx)(nc, {
                    columns: 7,
                    start: 3,
                    end: 11,
                    className: uP().description,
                    children: (0, a.jsx)(cG, {
                      strongColor: "green",
                      children: (0, a.jsx)(t4, {
                        component: "intro",
                        children: n[0].description
                      })
                    })
                  })
                })]
              })
            }), 2 === i && (0, a.jsxs)("div", {
              className: s,
              children: [(0, a.jsx)("div", {
                style: {
                  backgroundImage: `url(${n[0].url})`
                }
              }), (0, a.jsx)("div", {
                children: (0, a.jsx)("img", {
                  src: n[1].url,
                  alt: n[1].alt,
                  title: n[1].title
                })
              })]
            }), 3 === i && (0, a.jsxs)("div", {
              className: s,
              children: [(0, a.jsxs)("div", {
                children: [(0, a.jsx)("div", {
                  className: uP().c1,
                  style: {
                    backgroundImage: `url(${n[0].url})`
                  }
                }), (0, a.jsx)("div", {
                  className: uP().c2,
                  style: {
                    backgroundImage: `url(${n[1].url})`
                  }
                })]
              }), (0, a.jsx)("div", {
                children: (0, a.jsx)("img", {
                  src: n[2].url,
                  alt: n[2].alt,
                  title: n[2].title
                })
              })]
            })]
          })
        },
        uT = e => e > 0 && e <= 3 ? `layout--${e}` : "layout--1";
      var uL = n(9044),
        uA = n.n(uL);
      let uV = e => {
        let {
          slides: t = [{
            bigImagePosLeft: !1,
            images: [{
              url: "",
              alt: "",
              title: "",
              description: ""
            }]
          }],
          darkMode: n = !1
        } = e, [i, s] = (0, uC.Z)({
          loop: !0
        }), l = (0, o.useCallback)(() => {
          s && s.scrollPrev()
        }, [s]), c = (0, o.useCallback)(() => {
          s && s.scrollNext()
        }, [s]);
        return (0, o.useEffect)(() => {
          let e = e => {
            "ArrowLeft" == e.key && l(), "ArrowRight" == e.key && c()
          };
          return window.addEventListener("keyup", e), () => window.removeEventListener("keyup", e)
        }, [s, l, c]), (0, a.jsx)("div", {
          className: ua()(uA().desktopCarouselWrapper, n ? uA().darkMode : ""),
          children: (0, a.jsxs)("div", {
            className: uA().swiper,
            ref: i,
            children: [(0, a.jsx)("div", {
              className: uA().swiper__container,
              children: t.map((e, t) => (0, a.jsx)("div", {
                className: uA().swiper__slide,
                children: (0, a.jsx)(uM, {
                  bigImagePosLeft: e.bigImagePosLeft,
                  images: e.images
                })
              }, t))
            }), (0, a.jsx)("button", {
              className: ua()(uA().swiper__pagination, uA().swiper__prev),
              onClick: l,
              children: "Prev"
            }), (0, a.jsx)("button", {
              className: ua()(uA().swiper__pagination, uA().swiper__next),
              onClick: c,
              children: "Next"
            }), s && (0, a.jsx)(uS, {
              emblaApi: s
            })]
          })
        })
      };
      var uR = n(4474),
        uN = n.n(uR);
      let uD = e => {
          let {
            mobileCarouselItems: t = [{
              url: "",
              alt: "",
              title: ""
            }]
          } = e, [n, i] = (0, uC.Z)({
            loop: !0
          });
          return (0, a.jsx)("div", {
            className: uN().mobileCarouselWrapper,
            children: (0, a.jsxs)("div", {
              className: uN().swiper,
              ref: n,
              children: [(0, a.jsx)("div", {
                className: uN().swiper__container,
                children: t.map((e, t) => (0, a.jsxs)("div", {
                  className: uN().swiper__slide,
                  children: [(0, a.jsx)("img", {
                    src: e.url,
                    alt: e.alt,
                    title: e.title
                  }), (0, a.jsx)("p", {
                    className: uN().description,
                    children: e.description
                  })]
                }, t))
              }), i && (0, a.jsx)(uS, {
                emblaApi: i
              })]
            })
          })
        },
        uO = {
          l: "935px"
        };
      var uH = e => {
          let {
            desktopSlides: t,
            mobileSlides: n,
            darkMode: i = !1
          } = e, [s] = (0, o.useState)([parseInt(uO.l.replace("px", ""))]), [l, c] = (0, o.useState)(!1);
          return (0, o.useEffect)(() => {
            let e = () => {
              let e = window.innerWidth,
                t = s.find(t => e < t);
              t ? t.toString() === uO.l.replace("px", "") && c(!0) : c(!1)
            };
            return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e)
          }, [s]), n || (n = (e => {
            let t = [],
              n = e => {
                for (let i in e) "images" === i && Array.isArray(e[i]) ? t = t.concat(e[i]) : "object" == typeof e[i] && null !== e[i] && n(e[i])
              };
            return n(e), [{
              mobileCarouselItems: t
            }]
          })(t)), (0, a.jsx)("div", {
            className: ua()(uj().galleryCarouselWrapper, i ? uj().darkMode : ""),
            children: l ? (0, a.jsx)(uD, {
              mobileCarouselItems: n[0].mobileCarouselItems
            }) : (0, a.jsx)(nl, {
              children: (0, a.jsx)(nc, {
                columns: 12,
                children: (0, a.jsx)(uV, {
                  slides: t,
                  darkMode: i
                })
              })
            })
          })
        },
        uI = n(7648),
        uB = n(400),
        uF = n.n(uB);

      function uW(e) {
        let {
          type: t,
          href: n,
          text: i
        } = e;
        return (0, a.jsx)("div", {
          "data-observe": "true",
          className: `${uF().wrapper} ${uF()[t]}`,
          children: n ? (0, a.jsx)(uI.default, {
            href: n,
            target: "_blank",
            rel: "noopener noreferrer",
            passHref: !0,
            className: uF().link,
            children: (0, a.jsx)("button", {
              className: uF().button,
              children: i ?? "Shop now"
            })
          }) : (0, a.jsx)("button", {
            className: uF().button,
            children: i ?? "Shop now"
          })
        })
      }
      var uz = n(3755),
        u$ = n(8175),
        uZ = n.n(u$),
        uU = () => {
          let [e, t] = (0, o.useState)({
            width: 0,
            height: 0
          });
          return (0, o.useEffect)(() => {
            {
              let e = () => {
                t({
                  width: window.innerWidth,
                  height: window.innerHeight
                })
              };
              return e(), window.addEventListener("resize", e), () => {
                window.removeEventListener("resize", e)
              }
            }
          }, []), e
        },
        uq = () => {
          let e = (0, o.useRef)(null),
            [t, n] = (0, o.useState)(0),
            [i, s] = (0, o.useState)(0),
            [l, c] = (0, o.useState)(0),
            u = uU();
          return (0, o.useEffect)(() => {
            let t = e.current;
            if (!t) return;
            t.muted = !0, t.playsInline = !0;
            let n = () => {
              t.play().catch(e => {
                console.error("Video playback failed:", e)
              })
            };
            return t.readyState >= 3 ? n() : t.addEventListener("canplaythrough", n, {
              once: !0
            }), () => {
              t.removeEventListener("canplaythrough", n)
            }
          }, []), (0, o.useEffect)(() => {
            let e = () => {
              let e = window.scrollY,
                t = u.width >= 1268 ? 280 : 80,
                i = u.width >= 1268 ? 445 : 180,
                a = u.width >= 1268 ? 450 : 240;
              n(e >= t ? 1 : 0);
              s(e >= i ? 1 : 0);
              c(e >= a ? 1 : 0)
            };
            return window.addEventListener("scroll", e), () => {
              window.removeEventListener("scroll", e)
            }
          }, [u]), (0, a.jsxs)("div", {
            className: uZ().mainWrapper,
            children: [(0, a.jsxs)("div", {
              className: uZ().heroContainer,
              children: [(0, a.jsxs)("div", {
                className: uZ().videoWrapper,
                children: [(0, a.jsxs)("video", {
                  ref: e,
                  className: uZ().heroVideo,
                  autoPlay: !0,
                  muted: !0,
                  playsInline: !0,
                  loop: !0,
                  preload: "auto",
                  disableRemotePlayback: !0,
                  poster: window.hero.video_image_url,
                  children: [(0, a.jsx)("source", {
                    src: window.hero.video_url,
                    type: "video/mp4"
                  }), "Your browser does not support the video tag."]
                }), (0, a.jsx)("div", {
                  className: uZ().heroOverlay
                })]
              }), (0, a.jsx)("div", {
                className: uZ().headerContainer,
                children: (0, a.jsx)(nd, {
                  isLandingPage: !0,
                  landingPageLogo: (0, a.jsx)(uI.default, {
                    href: "/",
                    children: (0, a.jsx)(cN, {
                      size: "small"
                    })
                  }),
                  logo: (0, a.jsx)(uI.default, {
                    href: "/",
                    children: (0, a.jsx)(cD, {})
                  })
                })
              }), (0, a.jsx)("div", {
                className: uZ().heroContent,
                children: (0, a.jsx)(uz.VS, {
                  translateY: [0, -15, "easeOut"],
                  shouldAlwaysCompleteAnimation: !0,
                  children: (0, a.jsx)(nl, {
                    children: (0, a.jsxs)(nc, {
                      columns: 12,
                      children: [(0, a.jsx)(cG, {
                        strongColor: "green",
                        subline: window.hero.subtitle,
                        spaceBelow: "additional",
                        children: (0, a.jsx)(t4, {
                          component: "h1",
                          children: (0, a.jsxs)("span", {
                            children: [window.hero.title_part_1, (0, a.jsx)("br", {}), " " + window.hero.title_part_2 + " ", (0, a.jsx)("strong", {
                              children: window.hero.title_part_3
                            })]
                          })
                        })
                      }), (0, a.jsx)(uW, {
                        "data-observe": "true",
                        type: "center",
                        href: window.hero.button_url,
                        text: window.hero.button_text
                      })]
                    })
                  })
                })
              })]
            }), (0, a.jsx)("div", {
              className: uZ().parallaxWrapper,
              children: (0, a.jsx)(uz.VS, {
                shouldAlwaysCompleteAnimation: !0,
                translateY: [0, -40, "easeIn"],
                scale: u.width >= 1268 ? [1, 1.2, "easeIn"] : [1, 1.4, "easeInOut"],
                className: uZ().parallax,
                children: (0, a.jsx)(nl, {
                  children: (0, a.jsxs)(nc, {
                    startL: 4,
                    endL: 10,
                    className: uZ().imageWrapper,
                    children: [(0, a.jsx)("img", {
                      src: window.hero.image_1_url,
                      alt: "Device with screen and lights off",
                      className: `${uZ().heroProduct} ${uZ().image1}`,
                      style: {
                        opacity: 1
                      }
                    }), (0, a.jsx)("img", {
                      src: window.hero.image_2_url,
                      alt: "Device with screen on, logo, lights off",
                      className: `${uZ().heroProduct} ${uZ().image2}`,
                      style: {
                        opacity: t
                      }
                    }), (0, a.jsx)("img", {
                      src: window.hero.image_3_url,
                      alt: "Device with screen on, ui, lights off",
                      className: `${uZ().heroProduct} ${uZ().image3}`,
                      style: {
                        opacity: i
                      }
                    }), (0, a.jsx)("img", {
                      src: window.hero.image_4_url,
                      alt: "Device with screen and lights on",
                      className: `${uZ().heroProduct} ${uZ().image4}`,
                      style: {
                        opacity: l
                      }
                    })]
                  })
                })
              })
            })]
          })
        },
        uX = n(3897),
        uY = n(6498),
        uK = n(9498),
        uG = n(7313),
        uQ = n.n(uG),
        uJ = () => {
          let e = (0, o.useRef)(null),
            t = (0, o.useRef)(null),
            n = (0, o.useRef)(null),
            i = (0, o.useRef)([]),
            s = (0, o.useRef)(!1);
          return (0, o.useLayoutEffect)(() => {
            uY.ZP.registerPlugin(uK.i, uX.V)
          }, []), (0, uX.V)(() => {
            let a;
            s.current = window.innerWidth <= 768;
            let o = t.current,
              l = e.current;
            if (!l || !o) return;
            let c = l.getContext("2d", {
              alpha: !1
            });
            if (!c) return;
            c.imageSmoothingEnabled = !0, c.imageSmoothingQuality = "high";
            let u = window.devicePixelRatio || 1,
              d = {
                frame: 0
              },
              h = 0,
              p = e => s.current ? `${window.assetsPath}tm7-landing-tm7_mobile_${e.toString().padStart(3,"0")}.webp` : `${window.assetsPath}tm7-landing-tm7_desktop_${e.toString().padStart(3,"0")}.webp`,
              m = () => {
                i.current = [];
                for (let e = 0; e < 144; e++) {
                  let t = new Image;
                  t.onload = () => {
                    144 == ++h && g()
                  }, t.src = p(e), i.current.push(t)
                }
              },
              f = () => {
                if (!l) return;
                let e = l.getBoundingClientRect();
                l.width = e.width * u, l.height = e.height * u, l.style.width = `${e.width}px`, l.style.height = `${e.height}px`, g()
              },
              g = () => {
                if (!l || !c || !i.current[d.frame]) return;
                c.fillStyle = "#23282a", c.fillRect(0, 0, l.width, l.height);
                let e = i.current[d.frame],
                  t = l.getBoundingClientRect(),
                  n = t.height / e.height,
                  s = t.height,
                  a = e.width * n,
                  o = (t.width - a) / 2;
                c.drawImage(e, o * u, 0 * u, a * u, s * u)
              },
              v = uY.ZP.to(d, {
                frame: 143,
                snap: "frame",
                scrollTrigger: {
                  trigger: o,
                  start: "top top",
                  end: "+=2160",
                  pin: !0,
                  pinSpacing: !0,
                  scrub: 1,
                  anticipatePin: 1,
                  fastScrollEnd: !0,
                  invalidateOnRefresh: !0,
                  onToggle: e => {
                    e.isActive || (d.frame = 0, g())
                  },
                  onUpdate: () => {
                    g()
                  }
                },
                onUpdate: g
              });
            v.scrollTrigger && (n.current = v.scrollTrigger);
            let y = () => {
              clearTimeout(a), a = setTimeout(() => {
                let e = s.current;
                s.current = window.innerWidth <= 768, e !== s.current && (h = 0, m()), f()
              }, 150)
            };
            return window.addEventListener("resize", y), f(), m(), () => {
              window.removeEventListener("resize", y), v.kill(), n.current = null
            }
          }, {
            scope: t
          }), (0, a.jsx)("div", {
            ref: t,
            className: uQ().container,
            children: (0, a.jsx)("canvas", {
              ref: e,
              className: uQ().canvas
            })
          })
        },
        u1 = n(7506),
        u0 = n.n(u1),
        u2 = e => {
          let {
            darkMode: t,
            headline: n,
            price: i,
            ctaText: s,
            image: o,
            imageAlt: l
          } = e;
          return (0, a.jsx)("div", {
            className: `${u0().productBlockWrap} ${t?u0().darkMode:""}`,
            children: (0, a.jsx)("article", {
              className: u0().productBlockWrap__container,
              children: (0, a.jsx)("div", {
                className: u0().productBlockWrap__inner,
                children: (0, a.jsxs)(nl, {
                  children: [(0, a.jsx)(nc, {
                    startXL: 3,
                    endXL: 7,
                    children: (0, a.jsx)("div", {
                      className: u0().productBlockWrap__image,
                      children: (0, a.jsx)("img", {
                        src: o,
                        alt: l
                      })
                    })
                  }), (0, a.jsx)(nc, {
                    columnsXL: 4,
                    children: (0, a.jsxs)("div", {
                      className: u0().productBlockWrap__content,
                      id: "jsc-f",
                      children: [(0, a.jsx)(t4, {
                        component: "p",
                        variant: "h4",
                        fontWeight: "bold",
                        children: n
                      }), (0, a.jsxs)("div", {
                        className: u0().productBlockWrap__shippingWrapper,
                        children: [(0, a.jsx)(c8, {
                          size: "large",
                          price: i
                        }), (0, a.jsx)(t4, {
                          component: "p",
                          variant: "paragraph10",
                          fontWeight: "regular",
                          children: window.productInfo.text_part_2
                        })]
                      }), (0, a.jsx)("div", {
                        "data-observe": "true",
                        className: u0().btnWrap,
                        children: (0, a.jsx)("a", {
                          style: {
                            textDecoration: "none"
                          },
                          href: window.productInfo.button_url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          children: (0, a.jsx)(nf, {
                            sizing: "fill",
                            children: (0, a.jsx)(t1, {
                              size: "large",
                              buttonStyle: "primary",
                              children: s
                            })
                          })
                        })
                      })]
                    })
                  })]
                })
              })
            })
          })
        },
        u5 = n(5301),
        u3 = n.n(u5),
        u4 = () => {
          let [e, t] = (0, o.useState)(!1), n = uU();
          return (0, o.useEffect)(() => {
            let e = document.querySelectorAll('[data-observe="true"]'),
              n = new Set,
              i = new IntersectionObserver(e => {
                e.forEach(e => {
                  e.isIntersecting ? n.add(e.target) : n.delete(e.target)
                }), n.size > 0 ? t(!1) : t(!0)
              }, {
                root: null,
                rootMargin: "0px",
                threshold: .1
              });
            e.forEach(e => i.observe(e));
            let s = !1;
            return e.forEach(e => {
              let t = e.getBoundingClientRect();
              t.top < window.innerHeight && t.bottom >= 0 && t.left < window.innerWidth && t.right >= 0 && (s = !0)
            }), t(!s), () => {
              e.forEach(e => i.unobserve(e)), i.disconnect()
            }
          }, []), (0, a.jsx)("div", {
            className: `${u3().stickyProductBarRoot} ${e?u3().visible:u3().hidden}`,
            children: n.width >= 1268 ? (0, a.jsxs)("div", {
              className: u3().stickyProductBarInner,
              children: [(0, a.jsx)("div", {
                className: u3().imageWrapper,
                children: (0, a.jsx)("img", {
                  src: window.stickyProductInfo.image_url,
                  alt: "TM7"
                })
              }), (0, a.jsxs)("div", {
                className: u3().titleWrapper,
                children: [(0, a.jsx)(t4, {
                  component: "p",
                  variant: "h6",
                  fontWeight: "bold",
                  children: window.stickyProductInfo.title
                }), (0, a.jsx)("span", {
                  children: window.stickyProductInfo.text
                })]
              }), (0, a.jsx)("div", {
                className: u3().buttonWrapper,
                children: (0, a.jsx)("a", {
                  style: {
                    textDecoration: "none"
                  },
                  href: window.stickyProductInfo.button_url,
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(t1, {
                    buttonStyle: "primary",
                    size: "medium",
                    href: window.stickyProductInfo.button_url,
                    children: window.stickyProductInfo.button_text
                  })
                })
              })]
            }) : (0, a.jsx)(nl, {
              children: (0, a.jsx)(nc, {
                columns: 12,
                children: (0, a.jsxs)("div", {
                  className: u3().stickyProductBarInner,
                  children: [(0, a.jsxs)("div", {
                    className: u3().titleWrapper,
                    children: [(0, a.jsx)(t4, {
                      component: "p",
                      variant: "h6",
                      fontWeight: "bold",
                      children: window.stickyProductInfo.title
                    }), (0, a.jsx)("span", {
                      children: window.stickyProductInfo.text
                    })]
                  }), (0, a.jsx)("div", {
                    className: u3().buttonWrapper,
                    children: (0, a.jsx)("a", {
                      style: {
                        textDecoration: "none"
                      },
                      href: window.stickyProductInfo.button_url,
                      rel: "noopener noreferrer",
                      children: (0, a.jsx)(t1, {
                        buttonStyle: "primary",
                        size: "medium",
                        href: window.stickyProductInfo.button_url,
                        children: window.stickyProductInfo.button_text
                      })
                    })
                  })]
                })
              })
            })
          })
        },
        u6 = e => (0, a.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 32 32",
          focusable: "false",
          ...e,
          children: [(0, a.jsx)("g", {
            id: "socialPlatforms",
            clipPath: "url(#clip0_4237_4843)",
            children: (0, a.jsx)("path", {
              id: "Subtract",
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M16 32.585C24.8366 32.585 32 25.4215 32 16.585C32 7.7484 24.8366 0.584961 16 0.584961C7.16344 0.584961 0 7.7484 0 16.585C0 25.4215 7.16344 32.585 16 32.585ZM15.6008 12.0006L18.0533 9.55935H18.042C18.7058 8.90685 19.5945 8.54685 20.5283 8.54685C21.4508 8.5581 22.3508 8.92935 23.0033 9.58185C23.667 10.2344 24.0383 11.1231 24.0383 12.0569C24.0383 12.9906 23.6783 13.8794 23.0258 14.5431L20.5845 16.9844L22.0133 18.4131L24.4658 15.9606C25.4895 14.9143 26.0633 13.5081 26.0633 12.0456C26.0633 10.5831 25.4783 9.17685 24.4433 8.14185C23.4083 7.10685 22.002 6.52185 20.5395 6.52185C19.077 6.52185 17.6708 7.0956 16.6245 8.11935L14.172 10.5719L15.6008 12.0006ZM13.092 20.9331L20.3595 13.6656L18.9308 12.2369L11.6633 19.5044L13.092 20.9331ZM9.98701 14.7456L7.54576 17.1981L7.53451 17.2094C6.51076 18.2556 5.93701 19.6619 5.93701 21.1244C5.93701 22.5869 6.52201 23.9931 7.55701 25.0281C8.59201 26.0631 9.99826 26.6481 11.4608 26.6481C12.9233 26.6481 14.3295 26.0744 15.3758 25.0506L17.8283 22.5981L16.3995 21.1693L13.9583 23.6106C13.2945 24.2631 12.4058 24.6231 11.472 24.6231C10.5495 24.6119 9.64951 24.2406 8.99701 23.5881C8.33326 22.9356 7.96201 22.0469 7.96201 21.1131C7.96201 20.1906 8.32201 19.2906 8.97451 18.6269L11.4158 16.1744L9.98701 14.7456Z",
              fill: "white"
            })
          }), (0, a.jsx)("defs", {
            children: (0, a.jsx)("clipPath", {
              id: "clip0_4237_4843",
              children: (0, a.jsx)("rect", {
                width: "32",
                height: "32",
                fill: "white",
                transform: "translate(0 0.584961)"
              })
            })
          })]
        }),
        u7 = n(3327),
        u9 = n.n(u7);

      function u8() {
        let e = uU().width >= 1268;
        return (0, a.jsxs)(a.Fragment, {
          children: [(0, a.jsxs)("main", {
            children: [(0, a.jsx)(uq, {}), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  columnsXL: 8,
                  startXL: 3,
                  endXL: 11,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "default",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [(0, a.jsx)("strong", {
                          children: window.introInfo.title_part_1
                        }), (0, a.jsx)("br", {}), window.introInfo.title_part_2 + " " + window.introInfo.title_part_3]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  columnsXL: 8,
                  startXL: 3,
                  endXL: 11,
                  className: u9().textCentered,
                  children: (0, a.jsx)(t4, {
                    component: "intro",
                    children: (0, a.jsx)("span", {
                      children: window.introInfo.text
                    })
                  })
                })
              })]
            }), (0, a.jsx)(cJ, {
              children: (0, a.jsx)(ub, {
                darkMode: !0,
                items: [{
                  id: 1,
                  text: window.functionsWithScrollVideo.item_1_title,
                  isActive: !0,
                  scrollMin: 0,
                  scrollMax: 1,
                  media: {
                    type: "video",
                    src: window.functionsWithScrollVideo.item_1_video_url
                  },
                  description: window.functionsWithScrollVideo.item_1_text
                }, {
                  id: 2,
                  text: window.functionsWithScrollVideo.item_2_title,
                  isActive: !1,
                  scrollMin: 0,
                  scrollMax: 1,
                  media: {
                    type: "video",
                    src: window.functionsWithScrollVideo.item_2_video_url
                  },
                  description: window.functionsWithScrollVideo.item_2_text
                }, {
                  id: 3,
                  text: window.functionsWithScrollVideo.item_3_title,
                  isActive: !1,
                  scrollMin: 0,
                  scrollMax: 1,
                  media: {
                    type: "video",
                    src: window.functionsWithScrollVideo.item_3_video_url
                  },
                  description: window.functionsWithScrollVideo.item_3_text
                }, {
                  id: 4,
                  text: window.functionsWithScrollVideo.item_4_title,
                  isActive: !1,
                  scrollMin: 0,
                  scrollMax: 1,
                  media: {
                    type: "video",
                    src: window.functionsWithScrollVideo.item_4_video_url
                  },
                  description: window.functionsWithScrollVideo.item_4_text
                }]
              })
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  columnsXL: 8,
                  startXL: 3,
                  endXL: 11,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.productScrollAnimation.title_part_1, (0, a.jsx)("br", {}), (0, a.jsx)("strong", {
                          children: window.productScrollAnimation.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(uJ, {}), (0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 12,
                  className: u9().textCentered,
                  children: e ? (0, a.jsxs)(a.Fragment, {
                    children: [(0, a.jsx)(t4, {
                      component: "intro",
                      children: window.productScrollAnimation.text_part_1
                    }), (0, a.jsx)(t4, {
                      component: "intro",
                      children: window.productScrollAnimation.text_part_2
                    }), (0, a.jsx)(t4, {
                      component: "intro",
                      children: window.productScrollAnimation.text_part_3
                    })]
                  }) : (0, a.jsxs)(a.Fragment, {
                    children: [(0, a.jsx)(t4, {
                      component: "p",
                      variant: "paragraph16",
                      children: window.productScrollAnimation.text_part_1
                    }), (0, a.jsx)(t4, {
                      component: "p",
                      variant: "paragraph16",
                      children: window.productScrollAnimation.text_part_2
                    }), (0, a.jsx)(t4, {
                      component: "p",
                      variant: "paragraph16",
                      children: window.productScrollAnimation.text_part_3
                    })]
                  })
                })
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "additional",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.infoImageCarousel.title_part_1 + " ", (0, a.jsx)("br", {}), (0, a.jsx)("strong", {
                          children: window.infoImageCarousel.title_part_2
                        }), " " + window.infoImageCarousel.title_part_3]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(uH, {
                darkMode: !0,
                desktopSlides: [{
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.infoImageCarousel.item_1_image_url,
                    alt: "Image 1",
                    title: "",
                    description: window.infoImageCarousel.item_1_text
                  }]
                }, {
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.infoImageCarousel.item_2_image_url,
                    alt: "Image 2",
                    title: "",
                    description: window.infoImageCarousel.item_2_text
                  }]
                }, {
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.infoImageCarousel.item_3_image_url,
                    alt: "Image 3",
                    title: "",
                    description: window.infoImageCarousel.item_3_text
                  }]
                }, {
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.infoImageCarousel.item_4_image_url,
                    alt: "Image 4",
                    title: "",
                    description: window.infoImageCarousel.item_4_text
                  }]
                }],
                mobileSlides: [{
                  mobileCarouselItems: [{
                    url: window.infoImageCarousel.item_1_image_url,
                    alt: "Image 1",
                    title: "",
                    description: window.infoImageCarousel.item_1_text
                  }, {
                    url: window.infoImageCarousel.item_2_image_url,
                    alt: "Image 2",
                    title: "",
                    description: window.infoImageCarousel.item_2_text
                  }, {
                    url: window.infoImageCarousel.item_3_image_url,
                    alt: "Image 3",
                    title: "",
                    description: window.infoImageCarousel.item_3_text
                  }, {
                    url: window.infoImageCarousel.item_4_image_url,
                    alt: "Image 4",
                    title: "",
                    description: window.infoImageCarousel.item_4_text
                  }]
                }]
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "additional",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.video.title_part_1 + " ", (0, a.jsx)("strong", {
                          children: window.video.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 12,
                  children: (0, a.jsx)(c7, {
                    aspectRatio: "16/9",
                    children: (0, a.jsx)("video", {
                      controls: !0,
                      preload: "auto",
                      poster: window.video.video_image_url,
                      children: (0, a.jsx)("source", {
                        src: window.video.video_url,
                        type: "video/mp4"
                      })
                    })
                  })
                })
              })]
            }), (0, a.jsxs)(cJ, {
              gap: "gap01",
              children: [(0, a.jsxs)("div", {
                children: [(0, a.jsx)(nl, {
                  children: (0, a.jsx)(nc, {
                    columns: 10,
                    start: 2,
                    end: 12,
                    className: u9().textCentered,
                    children: (0, a.jsx)(cG, {
                      strongColor: "green",
                      spaceBelow: "default",
                      children: (0, a.jsx)(t4, {
                        component: "p",
                        variant: "h2",
                        children: e ? (0, a.jsxs)("span", {
                          children: [window.gallery.title_part_1 + " ", (0, a.jsx)("strong", {
                            children: window.gallery.title_part_2 + " "
                          }), (0, a.jsx)("br", {}), window.gallery.title_part_3]
                        }) : (0, a.jsxs)("span", {
                          children: [window.gallery.title_part_1 + " ", (0, a.jsx)("strong", {
                            children: window.gallery.title_part_2 + " "
                          }), " ", window.gallery.title_part_3]
                        })
                      })
                    })
                  })
                }), (0, a.jsx)(cX, {
                  productImage: window.gallery.image_url,
                  images: [{
                    url: window.gallery.gallery_image_1_url,
                    alt: "Image 1",
                    title: "Image 1"
                  }, {
                    url: window.gallery.gallery_image_2_url,
                    alt: "Image 2",
                    title: "Image 2"
                  }, {
                    url: window.gallery.gallery_image_3_url,
                    alt: "Image 3",
                    title: "Image 3"
                  }, {
                    url: window.gallery.gallery_image_4_url,
                    alt: "Image 4",
                    title: "Image 4"
                  }, {
                    url: window.gallery.gallery_image_5_url,
                    alt: "Image 5",
                    title: "Image 5"
                  }, {
                    url: window.gallery.gallery_image_6_url,
                    alt: "Image 6",
                    title: "Image 6"
                  }, {
                    url: window.gallery.gallery_image_7_url,
                    alt: "Image 7",
                    title: "Image 7"
                  }, {
                    url: window.gallery.gallery_image_8_url,
                    alt: "Image 8",
                    title: "Image 8"
                  }],
                  showEyecatcher: !1
                })]
              }), (0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  columnsXL: 8,
                  startXL: 3,
                  endXL: 11,
                  className: u9().textCentered,
                  children: e ? (0, a.jsx)(t4, {
                    component: "intro",
                    children: window.gallery.text
                  }) : (0, a.jsx)(t4, {
                    component: "p",
                    variant: "paragraph16",
                    children: window.gallery.text
                  })
                })
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "additional",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.tiles.title_part_1 + " ", (0, a.jsx)("br", {}), (0, a.jsx)("strong", {
                          children: window.tiles.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(ui, {
                darkMode: !0,
                tiles: [{
                  bigTile: !1,
                  image: window.tiles.item_1_image_url,
                  imageBottom: !0,
                  text: window.tiles.item_1_text,
                  title: window.tiles.item_1_title,
                  titleSecondary: window.tiles.item_1_subtitle
                }, {
                  bigTile: !1,
                  image: "",
                  imageBottom: !1,
                  text: window.tiles.item_2_text,
                  title: window.tiles.item_2_title,
                  titleSecondary: window.tiles.item_2_subtitle
                }, {
                  bigTile: !0,
                  image: window.tiles.item_3_image_url,
                  imageBottom: !1,
                  text: window.tiles.item_3_text,
                  title: window.tiles.item_3_title,
                  titleSecondary: window.tiles.item_3_subtitle
                }, {
                  bigTile: !1,
                  image: "",
                  imageBottom: !1,
                  text: window.tiles.item_4_text,
                  title: window.tiles.item_4_title,
                  titleSecondary: window.tiles.item_4_subtitle
                }, {
                  bigTile: !1,
                  image: window.tiles.item_5_image_url,
                  imageBottom: !1,
                  text: window.tiles.item_5_text,
                  title: window.tiles.item_5_title,
                  titleSecondary: window.tiles.item_5_subtitle
                }]
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "additional",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.tilesCarousel.title_part_1, (0, a.jsx)("strong", {
                          children: " " + window.tilesCarousel.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(uH, {
                darkMode: !0,
                desktopSlides: [{
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.tilesCarousel.item_1_image_url,
                    alt: "Image 1",
                    title: ""
                  }]
                }, {
                  bigImagePosLeft: !1,
                  images: [{
                    url: window.tilesCarousel.item_2_image_url,
                    alt: "Image 1",
                    title: ""
                  }]
                }],
                mobileSlides: [{
                  mobileCarouselItems: [{
                    url: window.tilesCarousel.item_1_mobile_image_url,
                    alt: "Image 1",
                    title: ""
                  }, {
                    url: window.tilesCarousel.item_2_mobile_image_url,
                    alt: "Image 2",
                    title: ""
                  }]
                }]
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.productInfo.title_part_1, (0, a.jsx)("br", {}), (0, a.jsx)("strong", {
                          children: window.productInfo.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(u2, {
                darkMode: !0,
                ctaText: window.productInfo.button_text,
                headline: window.productInfo.subtitle,
                image: window.productInfo.image_url,
                imageAlt: "Thermomix Thermomix\xae TM7.",
                price: window.productInfo.text_part_1
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    strongColor: "green",
                    spaceBelow: "default",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.socialMediaLinks.title_part_1, (0, a.jsx)("br", {}), " " + window.socialMediaLinks.title_part_2, (0, a.jsx)("strong", {
                          children: " " + window.socialMediaLinks.title_part_3
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(c4, {
                links: [(0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_1,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(u6, {})
                }), (0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_2,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(c1, {})
                }), (0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_3,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(c0, {})
                }), (0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_4,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(c2, {})
                }), (0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_5,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(c5, {})
                }), (0, a.jsx)("a", {
                  href: window.socialMediaLinks.url_6,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  children: (0, a.jsx)(c3, {})
                })]
              })]
            }), (0, a.jsxs)(cJ, {
              children: [(0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  className: u9().textCentered,
                  children: (0, a.jsx)(cG, {
                    spaceBelow: "additional",
                    strongColor: "green",
                    children: (0, a.jsx)(t4, {
                      component: "p",
                      variant: "h2",
                      children: (0, a.jsxs)("span", {
                        children: [window.faqs.title_part_1, (0, a.jsx)("br", {}), (0, a.jsx)("strong", {
                          children: window.faqs.title_part_2
                        })]
                      })
                    })
                  })
                })
              }), (0, a.jsx)(nl, {
                children: (0, a.jsx)(nc, {
                  columns: 10,
                  start: 2,
                  end: 12,
                  columnsXL: 8,
                  startXL: 3,
                  endXL: 11,
                  className: u9().textWhite,
                  children: (0, a.jsxs)("div", {
                    className: u9().questionSection,
                    children: [(0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_1_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_1_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_2_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_2_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_3_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_3_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_4_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_4_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_5_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_5_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_6_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        spaceBelow: !0,
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_6_text
                        })
                      })]
                    }), (0, a.jsxs)("div", {
                      children: [(0, a.jsx)(cG, {
                        spaceBelow: "default",
                        strongColor: "green",
                        children: (0, a.jsx)(t4, {
                          component: "p",
                          variant: "h4",
                          fontWeight: "bold",
                          children: (0, a.jsx)("span", {
                            style: { fontWeight: "bold" },
                            children: window.faqs.item_7_title
                          })
                        })
                      }), (0, a.jsx)(t4, {
                        component: "p",
                        variant: e ? "paragraph18" : "paragraph16",
                        children: (0, a.jsx)("span", {
                          children: window.faqs.item_7_text
                        })
                      })]
                    })]
                  })
                })
              })]
            })]
          }), (0, a.jsx)("div", {
            style: {
              position: "relative",
              zIndex: 200
            },
            children: (0, a.jsx)(u4, {})
          })]
        })
      }
    },
    9950: function(e) {
      e.exports = {
        functionsTabWrapper: "functionsTab_functionsTabWrapper__AAi2A"
      }
    },
    3327: function(e) {
      e.exports = {
        textCentered: "page_textCentered__xdVM1",
        textWhite: "page_textWhite__fcBYV",
        questionSection: "page_questionSection__jQQT3"
      }
    },
    2804: function(e) {
      e.exports = {
        tileContent: "bentoBoxTiles_tileContent__27FW7",
        bentoBoxTile: "bentoBoxTiles_bentoBoxTile__It9lE",
        darkModeEnabled: "bentoBoxTiles_darkModeEnabled__K1oEe",
        bentoBoxTiles: "bentoBoxTiles_bentoBoxTiles__Alt1k",
        tileBig: "bentoBoxTiles_tileBig__6fCZ_",
        tileImageContainer: "bentoBoxTiles_tileImageContainer__Hrnj6",
        tileIcon: "bentoBoxTiles_tileIcon__FnWrI",
        tileImageBottom: "bentoBoxTiles_tileImageBottom__SYOLY",
        tileText: "bentoBoxTiles_tileText__yT4dy",
        tileTitle: "bentoBoxTiles_tileTitle__vt2gs",
        tileTitleSecondary: "bentoBoxTiles_tileTitleSecondary__Pyv2b"
      }
    },
    400: function(e) {
      e.exports = {
        wrapper: "button_wrapper__dcL6j",
        wide: "button_wide__RtMpW",
        button: "button_button__9DiUG",
        link: "button_link__H_fjf",
        center: "button_center__R167M"
      }
    },
    5644: function(e) {
      e.exports = {
        desktopScrollboxWrapper: "desktopScrollboxModule_desktopScrollboxWrapper__XZEeB",
        desktopScrollbox__list: "desktopScrollboxModule_desktopScrollbox__list__wnF6c",
        inactive: "desktopScrollboxModule_inactive__MJ_lB",
        desktopScrollbox__title: "desktopScrollboxModule_desktopScrollbox__title__3d6og",
        desktopScrollbox__progress: "desktopScrollboxModule_desktopScrollbox__progress__vkG9m",
        desktopScrollbox__media: "desktopScrollboxModule_desktopScrollbox__media__t4axE",
        active: "desktopScrollboxModule_active__6GmET",
        videoContainer: "desktopScrollboxModule_videoContainer__Y5qrv",
        darkMode: "desktopScrollboxModule_darkMode__dtfPe",
        description: "desktopScrollboxModule_description__Jkf8p"
      }
    },
    8259: function(e) {
      e.exports = {
        mobileScrollboxWrapper: "mobileScrollboxModule_mobileScrollboxWrapper__M6bc2",
        mobileScrollbox__list: "mobileScrollboxModule_mobileScrollbox__list__S55AT",
        inactive: "mobileScrollboxModule_inactive__L_8wl",
        mobileScrollbox__title: "mobileScrollboxModule_mobileScrollbox__title__g3OQO",
        folded: "mobileScrollboxModule_folded__8PljR",
        mediaContainer: "mobileScrollboxModule_mediaContainer__fg60Z",
        description: "mobileScrollboxModule_description__LbTWD",
        videoContainer: "mobileScrollboxModule_videoContainer__VKwnQ",
        active: "mobileScrollboxModule_active__15HVL",
        mobileScrollbox__progress: "mobileScrollboxModule_mobileScrollbox__progress__ILEUK"
      }
    },
    9044: function(e) {
      e.exports = {
        desktopCarouselWrapper: "desktopCarousel_desktopCarouselWrapper___mywc",
        swiper: "desktopCarousel_swiper__wRhSa",
        swiper__container: "desktopCarousel_swiper__container__U8qG5",
        swiper__slide: "desktopCarousel_swiper__slide__6ZQDQ",
        swiper__pagination: "desktopCarousel_swiper__pagination__DgfdD",
        swiper__prev: "desktopCarousel_swiper__prev__oQWkq",
        darkMode: "desktopCarousel_darkMode__wItOV",
        swiper__next: "desktopCarousel_swiper__next__Oz8FO"
      }
    },
    3983: function(e) {
      e.exports = {
        galleryCarouselWrapper: "galleryCarousel_galleryCarouselWrapper__fXkVa",
        swiper__dots: "galleryCarousel_swiper__dots__3SWRV",
        swiper__dot: "galleryCarousel_swiper__dot__ZhhRc",
        darkMode: "galleryCarousel_darkMode__vmrs_",
        swiper__dotsmall: "galleryCarousel_swiper__dotsmall__2Rj3Z",
        swiper__dotSelected: "galleryCarousel_swiper__dotSelected__s3gKU",
        swiper__dothidden: "galleryCarousel_swiper__dothidden__jHiuo"
      }
    },
    590: function(e) {
      e.exports = {
        imageLayoutWrap: "imageLayout_imageLayoutWrap__1vn_r",
        description: "imageLayout_description__O_wK_",
        "image-variant": "imageLayout_image-variant__g0gbr",
        "layout--2": "imageLayout_layout--2__7aUNG",
        "layout--3": "imageLayout_layout--3__m8wU3",
        "layout--1": "imageLayout_layout--1__nBjE5",
        "big-left": "imageLayout_big-left__je1Mu"
      }
    },
    4474: function(e) {
      e.exports = {
        mobileCarouselWrapper: "mobileCarousel_mobileCarouselWrapper__VD_Y0",
        swiper: "mobileCarousel_swiper__2oMk0",
        swiper__container: "mobileCarousel_swiper__container__0lK_a",
        swiper__slide: "mobileCarousel_swiper__slide__SP0xp",
        description: "mobileCarousel_description__OwSBQ"
      }
    },
    8175: function(e) {
      e.exports = {
        mainWrapper: "hero_mainWrapper__3itsG",
        heroContainer: "hero_heroContainer__87yGA",
        videoWrapper: "hero_videoWrapper__YCUj_",
        heroVideo: "hero_heroVideo__Fqbcb",
        heroOverlay: "hero_heroOverlay__gAQEz",
        headerContainer: "hero_headerContainer__g4cS7",
        heroContent: "hero_heroContent__svA0_",
        parallaxWrapper: "hero_parallaxWrapper__OpOnn",
        parallax: "hero_parallax__ItZm_",
        imageWrapper: "hero_imageWrapper__mMY8W",
        heroProduct: "hero_heroProduct__XbgFa",
        image1: "hero_image1__SYcqa",
        image2: "hero_image2__xxXZS",
        image3: "hero_image3__nNFuV",
        image4: "hero_image4__n9Cti"
      }
    },
    7313: function(e) {
      e.exports = {
        container: "productAnimation_container__SQMT8",
        canvas: "productAnimation_canvas__37aou"
      }
    },
    7506: function(e) {
      e.exports = {
        productBlockWrap: "productBlock_productBlockWrap__JOt53",
        productBlockWrap__container: "productBlock_productBlockWrap__container__LFYb6",
        darkMode: "productBlock_darkMode__psiX6",
        productBlockWrap__inner: "productBlock_productBlockWrap__inner__IBwPv",
        productBlockWrap__image: "productBlock_productBlockWrap__image__M0zXT",
        productBlockWrap__content: "productBlock_productBlockWrap__content__Znlwu",
        btnWrap: "productBlock_btnWrap__hdy4t",
        productBlockWrap__shippingWrapper: "productBlock_productBlockWrap__shippingWrapper__Q9oZQ"
      }
    },
    5301: function(e) {
      e.exports = {
        stickyProductBarRoot: "stickyProductBar_stickyProductBarRoot__YXPt8",
        hidden: "stickyProductBar_hidden__VvVUF",
        visible: "stickyProductBar_visible___iYD0",
        stickyProductBarInner: "stickyProductBar_stickyProductBarInner__rWCP1",
        buttonWrapper: "stickyProductBar_buttonWrapper__CSJ9j",
        titleWrapper: "stickyProductBar_titleWrapper__mnk2o",
        imageWrapper: "stickyProductBar_imageWrapper__Px8Fw"
      }
    }
  },
  function(e) {
    e.O(0, [250, 922, 755, 202, 971, 117, 744], function() {
      return e(e.s = 7726)
    }), _N_E = e.O()
  }
]);